/* TheArtFolio theme scripts */
(function () {
  "use strict";

  /* ---------- money formatting ---------- */
  function formatMoney(cents, format) {
    format = format || (window.theme && window.theme.moneyFormat) || "£{{amount}}";
    var value = (cents / 100);
    function thousands(num, dec) {
      var s = (num).toFixed(dec === undefined ? 2 : dec);
      var parts = s.split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts.join(".");
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, key) {
      switch (key) {
        case "amount": return thousands(value, 2);
        case "amount_no_decimals": return thousands(value, 0);
        case "amount_with_comma_separator": return thousands(value, 2).replace(/,/g, " ").replace(".", ",");
        case "amount_no_decimals_with_comma_separator": return thousands(value, 0).replace(/,/g, " ");
        default: return thousands(value, 2);
      }
    });
  }
  window.theme = window.theme || {};
  window.theme.formatMoney = formatMoney;

  // ===== FRAME VISUALISER DIMENSION SPEC (all values in real cm) =====
  // Catalogue sizes on the product page (55×40 … 100×70 landscape, etc.) are the
  // OUTER finished frame dimensions — what you measure on a mockup screenshot.
  // Print aperture = outer − 2×(moulding + mount when mounted).
  // Rosenstiels editions use a separate outer matrix (square 40/50/75/90,
  // landscape/portrait 50×40 / 75×60 / 95×75 / 120×95). Prefer dimensions
  // parsed from the Size option label so only those products change.
  const PRINT_SIZES = {
    square: {
      small:      { w: 40, h: 40, inW: 16, inH: 16 },
      medium:     { w: 50, h: 50, inW: 20, inH: 20 },
      large:      { w: 60, h: 60, inW: 24, inH: 24 },
      extralarge: { w: 75, h: 75, inW: 30, inH: 30 }
    },
    landscape: {
      small:      { w: 55, h: 40, inW: 22, inH: 16 },
      medium:     { w: 65, h: 48, inW: 26, inH: 19 },
      large:      { w: 80, h: 60, inW: 32, inH: 24 },
      extralarge: { w: 100, h: 70, inW: 40, inH: 28 }
    }
  };
  const ROSENSTIELS_PRINT_SIZES = {
    square: {
      small:      { w: 40, h: 40, inW: 16, inH: 16 },
      medium:     { w: 50, h: 50, inW: 20, inH: 20 },
      large:      { w: 75, h: 75, inW: 30, inH: 30 },
      extralarge: { w: 90, h: 90, inW: 35, inH: 35 }
    },
    landscape: {
      small:      { w: 50, h: 40, inW: 20, inH: 16 },
      medium:     { w: 75, h: 60, inW: 30, inH: 24 },
      large:      { w: 95, h: 75, inW: 37, inH: 30 },
      extralarge: { w: 120, h: 95, inW: 47, inH: 37 }
    }
  };

  function cmToInches(cm) {
    return Math.round((Number(cm) / 2.54) * 10) / 10;
  }

  function parseSizeCmFromLabel(value) {
    var match = String(value || "").match(/(\d+(?:\.\d+)?)\s*[×x]\s*(\d+(?:\.\d+)?)/i);
    if (!match) return null;
    var w = parseFloat(match[1]);
    var h = parseFloat(match[2]);
    if (!isFinite(w) || !isFinite(h) || w <= 0 || h <= 0) return null;
    return { w: w, h: h, inW: cmToInches(w), inH: cmToInches(h) };
  }

  // Panoramic buy-box labels are the sheet, 45×100 or 55×120. Landscape works
  // hang the long side across (100×45, 120×55). Portrait works keep the sheet
  // upright (45×100, 55×120). Prices are the same either way.
  function landscapePanoCm(parsed, orientation) {
    if (!parsed) return null;
    var a = Math.round(parsed.w);
    var b = Math.round(parsed.h);
    var key = (a < b ? a + "x" + b : b + "x" + a);
    var portrait = String(orientation || "").toLowerCase().indexOf("port") > -1;
    if (key === "45x100") {
      return portrait
        ? { w: 45, h: 100, inW: cmToInches(45), inH: cmToInches(100) }
        : { w: 100, h: 45, inW: cmToInches(100), inH: cmToInches(45) };
    }
    if (key === "55x120") {
      return portrait
        ? { w: 55, h: 120, inW: cmToInches(55), inH: cmToInches(120) }
        : { w: 120, h: 55, inW: cmToInches(120), inH: cmToInches(55) };
    }
    return null;
  }

  function outerCmFromParsed(parsed, orientation) {
    return parsed ? landscapePanoCm(parsed, orientation) || parsed : null;
  }

  function isRosenstielsCatalogue(el) {
    var node = el;
    while (node && node.getAttribute) {
      if (/rosenstiel/i.test(node.getAttribute("data-catalogue") || "")) return true;
      node = node.parentElement;
    }
    return false;
  }

  // Rosenstiels no-mount finishes smaller or slightly larger than the mounted
  // outer on the Size option. Keyed by that mounted outer (cm). Frame is the
  // finished size; print is the sheet aperture. Other catalogues keep one outer.
  const ROSENSTIELS_NO_MOUNT_BY_OUTER = {
    "40x40": { w: 42, h: 42, printW: 40, printH: 40 },
    "50x50": { w: 52, h: 52, printW: 50, printH: 50 },
    "75x75": { w: 78, h: 78, printW: 75, printH: 75 },
    "90x90": { w: 92, h: 92, printW: 90, printH: 90 },
    "50x40": { w: 44, h: 34, printW: 40, printH: 30 },
    "75x60": { w: 64, h: 48, printW: 60, printH: 45 },
    "95x75": { w: 84, h: 64, printW: 80, printH: 60 },
    "120x95": { w: 104, h: 78, printW: 100, printH: 75 },
    "40x50": { w: 34, h: 44, printW: 30, printH: 40 },
    "60x75": { w: 48, h: 64, printW: 45, printH: 60 },
    "75x95": { w: 64, h: 84, printW: 60, printH: 80 },
    "95x120": { w: 78, h: 104, printW: 75, printH: 100 }
  };

  function rosenstielsNoMountFromLabel(label) {
    var parsed = parseSizeCmFromLabel(label);
    if (!parsed) return null;
    var key = Math.round(parsed.w) + "x" + Math.round(parsed.h);
    var row = ROSENSTIELS_NO_MOUNT_BY_OUTER[key];
    if (!row) return null;
    return {
      w: row.w,
      h: row.h,
      inW: cmToInches(row.w),
      inH: cmToInches(row.h),
      printW: row.printW,
      printH: row.printH,
      label: row.w + "×" + row.h + "cm",
      inchLabel: cmToInches(row.w) + "×" + cmToInches(row.h) + "″"
    };
  }

  window.theme.rosenstielsNoMountSize = rosenstielsNoMountFromLabel;

  // Multi-panel sets: one fixed size each. Panels are spaced ~5cm apart;
  // each panel is a complete frame + mount on all four sides (same as single).
  const MULTI_PANEL_SPECS = {
    diptych: {
      panels: 2,
      gapCm: 5,
      mountCm: 2.5,
      // Outer panel 47.5×100cm (frame + mount already included); hung 100×100 with the 5cm gap.
      panel: { w: 47.5, h: 100, inW: 18.7, inH: 39.4 },
      overall: { w: 100, h: 100, inW: 39.4, inH: 39.4 }
    },
    triptych: {
      panels: 3,
      gapCm: 5,
      mountCm: 2.5,
      // Outer panel 45×100cm (frame + mount already included); hung 145×100 with the 5cm gaps.
      panel: { w: 45, h: 100, inW: 17.7, inH: 39.4 },
      overall: { w: 145, h: 100, inW: 57.1, inH: 39.4 }
    }
  };

  // Frame moulding FACE width per style. Verify these defaults against the
  // supplied mouldings; one edit here updates artwork and every room scene.
  const FRAME_WIDTH_CM = {
    standard: 2.0, // "Classic"
    widebox:  2.0, // "Deep Classic" — same face width as Classic; distinct colour rails only
    swoop:    3.5,
    venice:   3.0
  };

  // Previous product-page mount bands (single-panel only). Listings drew a
  // flat 12px, which is 1/24 of a 288px collection card. singleMountCm uses
  // the halfway point, so both surfaces share one mount as a fraction of the
  // finished frame. Diptych and triptych stay on MULTI_PANEL_SPECS.mountCm.
  const MOUNT_WIDTH_CM = {
    small:      4.5,
    medium:     5.5,
    large:      7.0,
    extralarge: 8.0
  };
  const LISTING_MOUNT_FRACTION = 12 / 288;

  function frameSizeTier(label) {
    var key = String(label || "").toLowerCase().replace(/[^a-z0-9]/g, "");
    if (key.indexOf("diptych") > -1 || key.indexOf("triptych") > -1) return "multi";
    if (key === "xl" || key.indexOf("extralarge") > -1 || key.indexOf("xlarge") > -1) return "extralarge";
    if (key.indexOf("small") > -1) return "small";
    if (key.indexOf("large") > -1) return "large";
    return "medium";
  }

  function singleMountCm(tier, outerW) {
    var spec = MOUNT_WIDTH_CM[tier] || MOUNT_WIDTH_CM.medium;
    var width = Number(outerW);
    if (!isFinite(width) || width <= 0) {
      width = (PRINT_SIZES.square[tier] || PRINT_SIZES.square.medium).w;
    }
    var listingCm = LISTING_MOUNT_FRACTION * width;
    return Math.round(((spec + listingCm) / 2) * 10) / 10;
  }

  // Retained for the how-it-works illustration CSS hook and older share URLs.
  // Product pages with no Size option (panoramic works) no longer apply these
  // A4/A3/A2 long edges or the 3.5 cm mount / 2.2 cm moulding.
  const LEGACY_SPECIAL_DIMENSIONS = {
    framePx: { standard: 18, swoop: 30, widebox: 18, venice: 22 },
    roomMountPx: 16,
    mountCm: 3.5,
    mouldCm: 2.2,
    printLongCm: { small: 30, medium: 42, large: 59 },
    artworkMountPx: 30
  };

  function multiPanelOuterCm(spec, frameCm, mountCm) {
    // panel.w / panel.h are already the outer panel. frameCm and mountCm are
    // drawn inside that panel (print = panel − 2×border); do not add them again.
    var derivedW = spec.panels * spec.panel.w + (spec.panels - 1) * (spec.gapCm || 0);
    var derivedH = spec.panel.h;
    var overall = spec.overall;
    var overallW = overall && overall.w;
    var overallH = overall && overall.h;
    if (frameCm < 0 || mountCm < 0 || !overall ||
        Math.abs(overallW - derivedW) > 0.05 || Math.abs(overallH - derivedH) > 0.05) {
      throw new Error(
        "Multi-panel spec mismatch: overall " + overallW + "×" + overallH +
        " vs panels " + derivedW + "×" + derivedH
      );
    }
    return { w: overallW, h: overallH, panelW: spec.panel.w, panelH: spec.panel.h };
  }

  // Cover-crop the print once to the combined canvas (N×panel), then reveal
  // equal vertical columns across the ~5cm gaps between frames.
  function multiPanelSliceLayout(spec, panelPxW, panelPxH, imgW, imgH) {
    var n = spec.panels;
    var canvasPxW = n * panelPxW;
    var canvasPxH = panelPxH;
    var scale = Math.max(canvasPxW / imgW, canvasPxH / imgH);
    var drawnW = imgW * scale;
    var drawnH = imgH * scale;
    var originX = (canvasPxW - drawnW) / 2;
    var originY = (canvasPxH - drawnH) / 2;
    var slices = [];
    for (var i = 0; i < n; i++) {
      slices.push({
        size: drawnW + "px " + drawnH + "px",
        position: (originX - i * panelPxW) + "px " + originY + "px"
      });
    }
    return slices;
  }

  var multiPanelImageCache = {};
  function loadImageSize(url, done) {
    if (!url) {
      done(null);
      return;
    }
    var cached = multiPanelImageCache[url];
    if (cached) {
      done(cached);
      return;
    }
    var img = new Image();
    img.onload = function () {
      var size = { w: img.naturalWidth || img.width, h: img.naturalHeight || img.height };
      if (size.w && size.h) multiPanelImageCache[url] = size;
      done(size.w && size.h ? size : null);
    };
    img.onerror = function () { done(null); };
    img.src = url;
  }

  function paintCollectionFormatCard(media, sourceImg, urlOverride) {
    var layout = media.getAttribute("data-format-panels");
    var spec = MULTI_PANEL_SPECS[layout];
    if (!spec) return;
    var img = sourceImg || media.querySelector("img");
    var slices = media.querySelectorAll(".dip-slice, .tri-slice");
    if (!img || !slices.length) return;

    function paint() {
      var size = { w: img.naturalWidth, h: img.naturalHeight };
      if (!size.w || !size.h) return;
      var first = slices[0];
      var panelPxW = first.clientWidth;
      var panelPxH = first.clientHeight;
      if (!panelPxW || !panelPxH) return;
      var slicesLayout = multiPanelSliceLayout(spec, panelPxW, panelPxH, size.w, size.h);
      var url = urlOverride || img.currentSrc || img.src;
      if (!url) return;
      var escaped = String(url).replace(/"/g, "%22");
      Array.prototype.forEach.call(slices, function (piece, index) {
        var slice = slicesLayout[index];
        if (!slice) return;
        piece.style.backgroundImage = 'url("' + escaped + '")';
        piece.style.backgroundRepeat = "no-repeat";
        piece.style.backgroundSize = slice.size;
        piece.style.backgroundPosition = slice.position;
      });
    }

    if (img.complete && img.naturalWidth) paint();
    else img.addEventListener("load", paint, { once: true });
  }

  function collectionFormatFramed(media) {
    var grid = (media && media.closest && media.closest(".masonry[data-coll-frames]"))
      || document.querySelector(".masonry[data-coll-frames]");
    return !!(grid && grid.getAttribute("data-coll-frames") === "on");
  }

  // Same centimetre envelope as applyStageDimensions (updatePreview):
  // multiPanelOuterCm + FRAME_WIDTH_CM + MULTI_PANEL_SPECS.mountCm, then
  // pxPerCm = renderedWidth / outer.w (card fills its slot; PDP uses 0.94 of stage).
  function sizeCollectionFormatCard(media) {
    var layout = media.getAttribute("data-format-panels");
    var spec = MULTI_PANEL_SPECS[layout];
    if (!spec) return;
    if (!collectionFormatFramed(media)) {
      media.style.removeProperty("aspect-ratio");
      media.style.removeProperty("gap");
      paintCollectionFormatCard(media);
      return;
    }
    var frameEl = media.querySelector(".card-frame");
    if (!frameEl) return;
    if (frameEl.classList.contains("is-none")) {
      media.style.removeProperty("aspect-ratio");
      media.style.removeProperty("gap");
      Array.prototype.forEach.call(media.querySelectorAll(".card-frame"), function (frame) {
        frame.style.setProperty("--frame-w", "0px");
        frame.style.setProperty("--mount-w", "0px");
        var mount = frame.querySelector(".card-mount");
        if (mount) mount.style.setProperty("--mount-w", "0px");
      });
      paintCollectionFormatCard(media);
      return;
    }
    var ftype = frameEl.getAttribute("data-frame-type") || "standard";
    var frameCm = FRAME_WIDTH_CM[ftype] || FRAME_WIDTH_CM.standard;
    var mountSpecCm = spec.mountCm;
    var mountEl = frameEl.querySelector(".card-mount");
    var mounted = !(mountEl && mountEl.classList.contains("is-off"));
    var outer = multiPanelOuterCm(spec, frameCm, mountSpecCm);
    var boxW = media.clientWidth;
    if (!boxW) return;
    var pxPerCm = boxW / outer.w;
    var frameW = frameCm * pxPerCm;
    var mountW = mounted ? mountSpecCm * pxPerCm : 0;
    media.style.aspectRatio = outer.w + " / " + outer.h;
    media.style.gap = (100 * (spec.gapCm || 0) / outer.w) + "%";
    Array.prototype.forEach.call(media.querySelectorAll(".card-frame"), function (frame) {
      frame.style.setProperty("--frame-w", frameW + "px");
      frame.style.setProperty("--mount-w", mountW + "px");
      var mount = frame.querySelector(".card-mount");
      if (mount) mount.style.setProperty("--mount-w", mountW + "px");
    });
    paintCollectionFormatCard(media);
  }

  var collectionFormatResizeTimer = null;
  var collectionFormatRO = null;
  function initCollectionFormatCards() {
    var nodes = document.querySelectorAll("[data-format-panels]");
    if (!nodes.length) return;
    Array.prototype.forEach.call(nodes, sizeCollectionFormatCard);
    if (!window.ResizeObserver) return;
    if (!collectionFormatRO) {
      collectionFormatRO = new ResizeObserver(function () {
        clearTimeout(collectionFormatResizeTimer);
        collectionFormatResizeTimer = setTimeout(function () {
          document.querySelectorAll("[data-format-panels]").forEach(sizeCollectionFormatCard);
        }, 50);
      });
    }
    Array.prototype.forEach.call(nodes, function (media) {
      collectionFormatRO.observe(media);
    });
  }

  // Single frames use the same mount fraction as the product page:
  // singleMountCm(tier, outerCm) / outerCm, times the rendered frame width.
  // Diptych and triptych cards keep sizeCollectionFormatCard (2.5cm).
  function sizeSingleFrameCard(frame) {
    if (!frame || frame.closest("[data-format-panels]") || frame.closest(".coll-enlarge-host")) return;
    var label = frame.getAttribute("data-frame-size") || "";
    var tier = frameSizeTier(label);
    var mountEl = frame.querySelector(".card-mount");
    var outer = outerCmFromParsed(parseSizeCmFromLabel(label), frame.closest(".card-media--portrait") ? "portrait" : "");
    if (!outer) {
      frame.removeAttribute("data-outer-aspect");
      frame.style.removeProperty("--card-outer-aspect");
      frame.style.removeProperty("aspect-ratio");
      if (tier === "multi") return;
      var mountedLegacy = !!(mountEl && !mountEl.classList.contains("is-off") && !frame.classList.contains("is-none"));
      var legacyWidth = (PRINT_SIZES.square[tier] || PRINT_SIZES.square.medium).w;
      var boxW = frame.clientWidth;
      if (!boxW) return;
      var legacyMount = mountedLegacy ? singleMountCm(tier, legacyWidth) : 0;
      var legacyPx = legacyMount * (boxW / legacyWidth);
      frame.style.setProperty("--mount-w", legacyPx + "px");
      if (mountEl) mountEl.style.setProperty("--mount-w", legacyPx + "px");
      return;
    }
    frame.setAttribute("data-outer-aspect", outer.w + "/" + outer.h);
    frame.style.setProperty("--card-outer-aspect", outer.w + " / " + outer.h);
    frame.style.aspectRatio = outer.w + " / " + outer.h;
    if (frame.classList.contains("is-none")) {
      frame.style.setProperty("--frame-w", "0px");
      frame.style.setProperty("--mount-w", "0px");
      if (mountEl) mountEl.style.setProperty("--mount-w", "0px");
      return;
    }
    var ftype = frame.getAttribute("data-frame-type") || "standard";
    var frameCm = FRAME_WIDTH_CM[ftype] || FRAME_WIDTH_CM.standard;
    if (tier === "multi") tier = "small";
    var mounted = !!(mountEl && !mountEl.classList.contains("is-off"));
    var mountCm = mounted ? (MOUNT_WIDTH_CM[tier] || MOUNT_WIDTH_CM.small) : 0;
    var widthCm = outer.w;
    if (!(widthCm > 0)) return;
    var frameLen = (frameCm / widthCm * 100) + "cqw";
    var mountLen = (mountCm / widthCm * 100) + "cqw";
    frame.style.setProperty("--frame-w", frameLen);
    frame.style.setProperty("--mount-w", mountLen);
    if (mountEl) mountEl.style.setProperty("--mount-w", mountLen);
  }

  function sizeAllSingleFrameCards() {
    document.querySelectorAll(".card-frame").forEach(sizeSingleFrameCard);
  }

  var singleFrameMountTimer = null;
  var singleFrameMountRO = null;
  function initSingleFrameMounts() {
    var nodes = document.querySelectorAll(".card-frame");
    if (!nodes.length) return;
    sizeAllSingleFrameCards();
    if (!window.ResizeObserver) return;
    if (!singleFrameMountRO) {
      singleFrameMountRO = new ResizeObserver(function () {
        clearTimeout(singleFrameMountTimer);
        singleFrameMountTimer = setTimeout(sizeAllSingleFrameCards, 50);
      });
    }
    Array.prototype.forEach.call(nodes, function (frame) {
      if (frame.closest("[data-format-panels]") || frame.closest(".coll-enlarge-host")) return;
      singleFrameMountRO.observe(frame);
    });
  }

  var LISTING_FRAME_BG = {
    oak: "linear-gradient(135deg,#C49A66,#A87E4C)",
    black: "#1B1A18",
    white: "#F4F1EA",
    gold: "linear-gradient(135deg,#D9B978,#B8934E)",
    silver: "linear-gradient(135deg,#D8DBDE,#AEB4B9)",
    bronze: "linear-gradient(135deg,#B08D5B,#7C5C34)",
    natural: "linear-gradient(135deg,#E6D6BC,#CBB68E)",
    "antique-gold": "linear-gradient(135deg,#C7A867,#93753F)",
    "antique-silver": "linear-gradient(135deg,#C4C3BC,#98968C)",
    "black-pewter": "linear-gradient(135deg,#26262a,#26262a 55%,#9a9ea1 55%,#7f8386)",
    "terracotta-silver": "linear-gradient(135deg,#b5673f,#b5673f 55%,#c9ccce 55%,#aeb2b5)",
    "white-silver": "linear-gradient(135deg,#f0ede7,#f0ede7 55%,#cfd2d5 55%,#b8bcbf)"
  };
  var LISTING_MOUNT_BG = {
    white: "#FFFFFF",
    "snow white": "#EDF0F0",
    "fresh linen": "#EEE9E3",
    cream: "#EEE9E3",
    ivory: "#EEE9E3",
    "warm sand": "#E8DABF",
    "french grey": "#C3BCA8",
    olive: "#7E7661",
    black: "#2D2824"
  };
  var LISTING_INNER = {
    white: "#C3BCA8",
    "snow white": "#C3BCA8",
    "fresh linen": "#C3BCA8",
    cream: "#C3BCA8",
    ivory: "#C3BCA8",
    "warm sand": "#C3BCA8",
    "french grey": "#FFFFFF",
    olive: "#EEE9E3",
    black: "#FFFFFF"
  };

  function listingColourKey(value) {
    return String(value || "").toLowerCase().replace(/ and /g, "-").replace(/\s+/g, "-");
  }

  function listingFramePlan(style, colour) {
    var name = String(style || "Classic").toLowerCase();
    var plan = {
      ftype: "standard",
      attr: "data-classic",
      prefix: "classic",
      key: "oak",
      frameW: "9px",
      frameBg: LISTING_FRAME_BG.oak
    };
    if (name.indexOf("swoop") > -1) {
      plan = { ftype: "swoop", attr: "data-swoop", prefix: "swoop", key: "black", frameW: "14px", frameBg: LISTING_FRAME_BG.black };
    } else if (name.indexOf("venice") > -1) {
      plan = { ftype: "venice", attr: "data-venice", prefix: "venice", key: "silver", frameW: "11px", frameBg: LISTING_FRAME_BG.silver };
    } else if (name.indexOf("deep") > -1 || name.indexOf("wide") > -1) {
      plan = { ftype: "widebox", attr: "data-deep-classic", prefix: "deep-classic", key: "oak", frameW: "11px", frameBg: LISTING_FRAME_BG.oak };
    }
    var key = listingColourKey(colour);
    if (plan.prefix === "venice") {
      if (key === "black" || key === "black-pewter") key = "black-pewter";
      else if (key === "white" || key === "white-silver") key = "white-silver";
      else if (key === "bronze" || key === "terracotta" || key === "terracotta-silver") key = "terracotta-silver";
      else if (key !== "silver") key = "silver";
    } else if (plan.prefix === "swoop") {
      if (["white", "black", "gold", "silver"].indexOf(key) === -1) key = "black";
    } else if (!LISTING_FRAME_BG[key]) {
      key = plan.key;
    }
    plan.key = key;
    plan.frameBg = LISTING_FRAME_BG[key] || plan.frameBg;
    return plan;
  }

  function listingMountOff(value) {
    var text = String(value || "").toLowerCase().trim();
    return text.indexOf("no mount") > -1 || text === "none" || text === "unmounted" || text === "no" || text === "off";
  }

  function applyListingDoubleMount(frame, spec) {
    var mount = frame.querySelector(".card-mount");
    var piece = mount && mount.querySelector(".card-piece");
    if (!mount || !piece) return;
    if (listingMountOff(spec.mount) || !/double/i.test(String(spec.mount || ""))) {
      piece.style.removeProperty("--mount2-w");
      piece.style.removeProperty("--mount2-bg");
      return;
    }
    var cm = parseFloat(String(frame.getAttribute("data-outer-aspect") || "").split("/")[0]);
    var widthPx = frame.clientWidth;
    if (!(cm > 0) || !(widthPx > 0)) return;
    var reveal = (0.5 / cm) * widthPx;
    var current = parseFloat(window.getComputedStyle(mount).getPropertyValue("--mount-w"));
    if (current > reveal) mount.style.setProperty("--mount-w", (current - reveal) + "px");
    var outer = listingColourKey(spec.mountColour);
    piece.style.setProperty("--mount2-w", reveal + "px");
    piece.style.setProperty("--mount2-bg", LISTING_INNER[outer] || "#C3BCA8");
  }

  window.theme.applyListingFrame = function (frame, spec) {
    if (!frame) return;
    spec = spec || {};
    var plan = listingFramePlan(spec.frametype || spec.style, spec.frame || spec.colour);
    FRAME_PHOTO_ATTRS.forEach(function (attr) { frame.removeAttribute(attr); });
    frame.setAttribute(plan.attr, plan.key);
    frame.setAttribute("data-frame-type", plan.ftype);
    if (spec.size) frame.setAttribute("data-frame-size", spec.size);
    else frame.removeAttribute("data-frame-size");
    frame.classList.remove("is-none");
    frame.style.setProperty("--frame-bg", plan.frameBg);
    frame.style.setProperty("--frame-w", plan.frameW);
    var mount = frame.querySelector(".card-mount");
    var off = listingMountOff(spec.mount);
    if (mount) {
      mount.classList.toggle("is-off", off);
      var mat = String(spec.mountColour || "white").toLowerCase();
      mount.style.setProperty("--mount-bg", LISTING_MOUNT_BG[mat] || "#FFFFFF");
    }
    ["t", "r", "b", "l"].forEach(function (side) {
      var rail = frame.querySelector(".card-rail--" + side);
      if (!rail) return;
      rail.style.backgroundImage = "url(\"" + frameAssetUrl(plan.prefix + "-" + plan.key + "-" + side + ".jpg") + "\")";
    });
    sizeSingleFrameCard(frame);
    applyListingDoubleMount(frame, spec);
    window.requestAnimationFrame(function () { applyListingDoubleMount(frame, spec); });
  };

  window.theme.refreshListingFrames = function () {
    initSingleFrameMounts();
  };

  // Width of the pictured wall, in centimetres. Room scale is
  // stageWidth / this — the same ratio on the product page and on Discover.
  // Measured from the object in each photograph (1024px-wide source):
  //   lounge        sofa arm to arm, x=86–748 → 64.6%. Two-seat sofa, 180cm → 279
  //   bedroom       headboard ≈ 15%–78% → 63%. King headboard, 160cm → 254
  //   kitchen       feature-wall run ≈ 22%–88% → 66%. Four 60cm units, 240cm → 364
  //   office        chair ≈ 20% of the frame. Office chair, 65cm → 325
  //   conservatory  back wall ≈ 12%–88% → 76% of the frame. That wall ~320cm → 421
  //   yours         no reference object in the empty scene → 320
  const ROOM_WALL_CM = {
    lounge: 279,
    bedroom: 254,
    kitchen: 364,
    office: 325,
    conservatory: 421,
    yours: 320
  };
  window.ROOM_WALL_CM = ROOM_WALL_CM;

  /* ---------- responsive header menu + priority "More" nav ---------- */
  document.addEventListener("DOMContentLoaded", function () {
    document.addEventListener("click", function (event) {
      var toggle = event.target.closest("[data-flist-toggle]");
      if (!toggle) return;
      var list = toggle.closest("[data-flist]");
      if (!list) return;
      var expanded = list.classList.toggle("is-expanded");
      toggle.setAttribute("aria-expanded", expanded ? "true" : "false");
      toggle.textContent = expanded
        ? toggle.getAttribute("data-less-label") || "Show less"
        : toggle.getAttribute("data-more-label") || "Show more";
    });
  });

  document.addEventListener("DOMContentLoaded", function () {
    var header = document.querySelector(".site-header");
    var toggle = header && header.querySelector("[data-menu-toggle]");
    var menu = header && header.querySelector("[data-header-menu]");
    var close = header && header.querySelector("[data-menu-close]");
    var backdrop = header && header.querySelector("[data-menu-backdrop]");
    var mobileQuery = window.matchMedia("(max-width: 1000px)");
    var lastOpener = null;
    if (!header || !toggle || !menu || !close || !backdrop) return;

    var primary = header.querySelector("[data-nav-primary]");
    var moreWrap = header.querySelector("[data-nav-more]");
    var moreToggle = header.querySelector("[data-nav-more-toggle]");
    var morePanel = header.querySelector("[data-nav-more-panel]");
    var moreList = header.querySelector("[data-nav-more-list]");
    var genresWrap = header.querySelector("[data-nav-genres]");
    var genresToggle = header.querySelector("[data-nav-genres-toggle]");
    var genresPanel = header.querySelector("[data-nav-genres-panel]");
    var roomsWrap = header.querySelector("[data-nav-rooms]");
    var roomsToggle = header.querySelector("[data-nav-rooms-toggle]");
    var roomsPanel = header.querySelector("[data-nav-rooms-panel]");
    var artistsWrap = header.querySelector("[data-nav-artists]");
    var artistsToggle = header.querySelector("[data-nav-artists-toggle]");
    var artistsPanel = header.querySelector("[data-nav-artists-panel]");
    var setsWrap = header.querySelector("[data-nav-sets]");
    var setsToggle = header.querySelector("[data-nav-sets-toggle]");
    var setsPanel = header.querySelector("[data-nav-sets-panel]");
    var priorityFrame = 0;

    function menuIsOpen() {
      return header.getAttribute("data-menu-open") === "true";
    }

    function updateMenuPosition() {
      var section = document.getElementById("shopify-section-header") || header;
      var bottom = Math.max(0, Math.round(section.getBoundingClientRect().bottom));
      menu.style.setProperty("--header-menu-top", bottom + "px");
    }

    function alignDropdown(wrap, panel) {
      if (!wrap || !panel) return;
      if (mobileQuery.matches) {
        panel.style.removeProperty("top");
        wrap.style.removeProperty("--nav-dropdown-gap");
        wrap.style.removeProperty("--nav-dropdown-bridge");
        return;
      }
      var wrapRect = wrap.getBoundingClientRect();
      var headerBottom = header.getBoundingClientRect().bottom;
      panel.style.top = (headerBottom - wrapRect.top) + "px";
      wrap.style.setProperty("--nav-dropdown-gap", Math.max(0, headerBottom - wrapRect.bottom) + "px");
    }

    function sizeDropdownBridge(wrap, panel) {
      if (!wrap || !panel || mobileQuery.matches || panel.hidden) return;
      wrap.style.setProperty("--nav-dropdown-bridge", panel.offsetWidth + "px");
    }

    function setMoreOpen(open) {
      if (!moreWrap || !moreToggle || !morePanel) return;
      alignDropdown(moreWrap, morePanel);
      moreWrap.setAttribute("data-open", open ? "true" : "false");
      moreToggle.setAttribute("aria-expanded", open ? "true" : "false");
      morePanel.hidden = !open;
      if (open) sizeDropdownBridge(moreWrap, morePanel);
    }

    function setGenresOpen(open) {
      if (!genresWrap || !genresToggle || !genresPanel) return;
      if (mobileQuery.matches) {
        genresWrap.setAttribute("data-open", "true");
        genresToggle.setAttribute("aria-expanded", "true");
        genresPanel.hidden = false;
        return;
      }
      alignDropdown(genresWrap, genresPanel);
      genresWrap.setAttribute("data-open", open ? "true" : "false");
      genresToggle.setAttribute("aria-expanded", open ? "true" : "false");
      genresPanel.hidden = !open;
      if (open) sizeDropdownBridge(genresWrap, genresPanel);
    }

    function setRoomsOpen(open) {
      if (!roomsWrap || !roomsToggle || !roomsPanel) return;
      if (mobileQuery.matches) {
        roomsWrap.setAttribute("data-open", "true");
        roomsToggle.setAttribute("aria-expanded", "true");
        roomsPanel.hidden = false;
        return;
      }
      alignDropdown(roomsWrap, roomsPanel);
      roomsWrap.setAttribute("data-open", open ? "true" : "false");
      roomsToggle.setAttribute("aria-expanded", open ? "true" : "false");
      roomsPanel.hidden = !open;
      if (open) sizeDropdownBridge(roomsWrap, roomsPanel);
    }

    function setArtistsOpen(open) {
      if (!artistsWrap || !artistsToggle || !artistsPanel) return;
      if (mobileQuery.matches) {
        artistsWrap.setAttribute("data-open", "true");
        artistsToggle.setAttribute("aria-expanded", "true");
        artistsPanel.hidden = false;
        return;
      }
      alignDropdown(artistsWrap, artistsPanel);
      artistsWrap.setAttribute("data-open", open ? "true" : "false");
      artistsToggle.setAttribute("aria-expanded", open ? "true" : "false");
      artistsPanel.hidden = !open;
      if (open) sizeDropdownBridge(artistsWrap, artistsPanel);
    }

    function setSetsOpen(open) {
      if (!setsWrap || !setsToggle || !setsPanel) return;
      if (mobileQuery.matches) {
        setsWrap.setAttribute("data-open", "true");
        setsToggle.setAttribute("aria-expanded", "true");
        setsPanel.hidden = false;
        return;
      }
      alignDropdown(setsWrap, setsPanel);
      setsWrap.setAttribute("data-open", open ? "true" : "false");
      setsToggle.setAttribute("aria-expanded", open ? "true" : "false");
      setsPanel.hidden = !open;
      if (open) sizeDropdownBridge(setsWrap, setsPanel);
    }

    function restoreNavItems() {
      if (!primary || !moreList || !moreWrap) return;
      var overflow = Array.prototype.slice.call(moreList.querySelectorAll("[data-nav-item]"));
      overflow.forEach(function (item) {
        primary.insertBefore(item, moreWrap);
      });
      moreWrap.hidden = true;
      setMoreOpen(false);
    }

    function fitsInPrimary() {
      if (!primary) return true;
      // Allow a small tolerance for sub-pixel rounding.
      return primary.scrollWidth <= primary.clientWidth + 1;
    }

    function primaryNavItems() {
      return Array.prototype.slice.call(primary.children).filter(function (el) {
        return el.hasAttribute && el.hasAttribute("data-nav-item");
      });
    }

    function movableNavItems() {
      return primaryNavItems().filter(function (el) {
        return !el.hasAttribute("data-nav-pinned");
      });
    }

    function updatePriorityNav() {
      if (!primary || !moreWrap || !moreList) return;

      restoreNavItems();

      if (mobileQuery.matches) return;

      // Always park preferred-more items in the More menu on desktop.
      var preferMore = Array.prototype.slice
        .call(primary.querySelectorAll("[data-nav-item][data-nav-prefer-more]"))
        .filter(function (el) {
          return el.parentElement === primary;
        });
      preferMore.forEach(function (item) {
        moreList.appendChild(item);
      });

      var items = movableNavItems();
      var hasOverflow = preferMore.length > 0 || (!fitsInPrimary() && items.length);

      if (!hasOverflow) return;

      // Reserve More width, then peel trailing (non-pinned) links until the row fits.
      moreWrap.hidden = false;
      setMoreOpen(false);

      var guard = 0;
      while (!fitsInPrimary() && items.length && guard < 20) {
        guard += 1;
        var move = items.pop();
        if (!move) break;
        moreList.insertBefore(move, moreList.firstChild);
      }

      var moreItems = Array.prototype.slice.call(moreList.children);
      moreItems.sort(function (a, b) {
        var left = (a.textContent || "").replace(/\s+/g, " ").trim();
        var right = (b.textContent || "").replace(/\s+/g, " ").trim();
        return left.localeCompare(right, "en", { sensitivity: "base" });
      });
      moreItems.forEach(function (item) {
        moreList.appendChild(item);
      });

      if (!moreList.children.length) {
        moreWrap.hidden = true;
        setMoreOpen(false);
      }
    }

    function schedulePriorityNav() {
      if (moreWrap && moreWrap.getAttribute("data-open") === "true") return;
      if (priorityFrame) cancelAnimationFrame(priorityFrame);
      priorityFrame = requestAnimationFrame(function () {
        priorityFrame = 0;
        updatePriorityNav();
      });
    }

    function setMenuOpen(open, moveFocus) {
      var mobile = mobileQuery.matches;
      open = mobile && open;
      header.setAttribute("data-menu-open", open ? "true" : "false");
      if (open) {
        updateMenuPosition();
        window.requestAnimationFrame(updateMenuPosition);
      }
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
      toggle.setAttribute("aria-label", open ? "Close menu" : "Open menu");
      menu.setAttribute("aria-hidden", mobile && !open ? "true" : "false");
      if (mobile && !open) menu.setAttribute("inert", "");
      else menu.removeAttribute("inert");
      backdrop.hidden = !open;
      document.documentElement.classList.toggle("header-menu-lock", open);
      if (!moveFocus) return;
      if (open) {
        var firstLink = menu.querySelector("a");
        (firstLink || close).focus();
      } else if (lastOpener && document.contains(lastOpener)) {
        lastOpener.focus();
      }
    }

    toggle.addEventListener("click", function () {
      var willOpen = !menuIsOpen();
      if (willOpen) lastOpener = toggle;
      setMenuOpen(willOpen, true);
    });
    close.addEventListener("click", function () { setMenuOpen(false, true); });
    backdrop.addEventListener("click", function () { setMenuOpen(false, true); });
    menu.addEventListener("click", function (event) {
      if (event.target.closest("a,[data-favourites-open]")) setMenuOpen(false, false);
    });

    if (moreToggle) {
      moreToggle.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        var open = moreWrap.getAttribute("data-open") !== "true";
        setGenresOpen(false);
        setRoomsOpen(false);
        setSetsOpen(false);
        setArtistsOpen(false);
        setMoreOpen(open);
      });
    }
    if (genresToggle) {
      genresToggle.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (mobileQuery.matches) return;
        var open = genresWrap.getAttribute("data-open") !== "true";
        setMoreOpen(false);
        setRoomsOpen(false);
        setSetsOpen(false);
        setArtistsOpen(false);
        setGenresOpen(open);
      });
    }
    if (roomsToggle) {
      roomsToggle.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (mobileQuery.matches) return;
        var open = roomsWrap.getAttribute("data-open") !== "true";
        setMoreOpen(false);
        setGenresOpen(false);
        setSetsOpen(false);
        setArtistsOpen(false);
        setRoomsOpen(open);
      });
    }
    if (setsToggle) {
      setsToggle.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (mobileQuery.matches) return;
        var open = setsWrap.getAttribute("data-open") !== "true";
        setMoreOpen(false);
        setGenresOpen(false);
        setRoomsOpen(false);
        setArtistsOpen(false);
        setSetsOpen(open);
      });
    }
    if (artistsToggle) {
      artistsToggle.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (mobileQuery.matches) return;
        var open = artistsWrap.getAttribute("data-open") !== "true";
        setMoreOpen(false);
        setGenresOpen(false);
        setRoomsOpen(false);
        setSetsOpen(false);
        setArtistsOpen(open);
      });
    }

    // Desktop: open More / Genres on hover (and keyboard focus); click still works for touch.
    (function bindDesktopHoverMenus() {
      var hoverQuery = window.matchMedia("(hover: hover) and (pointer: fine)");
      var moreCloseTimer = 0;
      var genresCloseTimer = 0;
      var roomsCloseTimer = 0;
      var setsCloseTimer = 0;
      var artistsCloseTimer = 0;

      function canHoverOpen() {
        return hoverQuery.matches && !mobileQuery.matches;
      }

      function clearTimer(which) {
        if (which === "more" && moreCloseTimer) {
          clearTimeout(moreCloseTimer);
          moreCloseTimer = 0;
        }
        if (which === "genres" && genresCloseTimer) {
          clearTimeout(genresCloseTimer);
          genresCloseTimer = 0;
        }
        if (which === "rooms" && roomsCloseTimer) {
          clearTimeout(roomsCloseTimer);
          roomsCloseTimer = 0;
        }
        if (which === "sets" && setsCloseTimer) {
          clearTimeout(setsCloseTimer);
          setsCloseTimer = 0;
        }
        if (which === "artists" && artistsCloseTimer) {
          clearTimeout(artistsCloseTimer);
          artistsCloseTimer = 0;
        }
      }

      function bindHover(wrap, openFn, closeOther, which) {
        if (!wrap) return;
        wrap.addEventListener("pointerenter", function () {
          if (!canHoverOpen()) return;
          clearTimer(which);
          if (closeOther) closeOther();
          openFn(true);
        });
        wrap.addEventListener("pointerleave", function () {
          if (!canHoverOpen()) return;
          clearTimer(which);
          var id = setTimeout(function () {
            if (which === "more") moreCloseTimer = 0;
            else if (which === "rooms") roomsCloseTimer = 0;
            else if (which === "sets") setsCloseTimer = 0;
            else if (which === "artists") artistsCloseTimer = 0;
            else genresCloseTimer = 0;
            openFn(false);
          }, 140);
          if (which === "more") moreCloseTimer = id;
          else if (which === "rooms") roomsCloseTimer = id;
          else if (which === "sets") setsCloseTimer = id;
          else if (which === "artists") artistsCloseTimer = id;
          else genresCloseTimer = id;
        });
        wrap.addEventListener("focusin", function () {
          if (mobileQuery.matches) return;
          clearTimer(which);
          if (closeOther) closeOther();
          openFn(true);
        });
        wrap.addEventListener("focusout", function (event) {
          if (mobileQuery.matches) return;
          if (wrap.contains(event.relatedTarget)) return;
          openFn(false);
        });
      }

      bindHover(moreWrap, setMoreOpen, function () { setGenresOpen(false); setRoomsOpen(false); setSetsOpen(false); setArtistsOpen(false); }, "more");
      bindHover(genresWrap, setGenresOpen, function () { setMoreOpen(false); setRoomsOpen(false); setSetsOpen(false); setArtistsOpen(false); }, "genres");
      bindHover(roomsWrap, setRoomsOpen, function () { setMoreOpen(false); setGenresOpen(false); setSetsOpen(false); setArtistsOpen(false); }, "rooms");
      bindHover(setsWrap, setSetsOpen, function () { setMoreOpen(false); setGenresOpen(false); setRoomsOpen(false); setArtistsOpen(false); }, "sets");
      bindHover(artistsWrap, setArtistsOpen, function () { setMoreOpen(false); setGenresOpen(false); setRoomsOpen(false); setSetsOpen(false); }, "artists");
    })();

    document.addEventListener("pointerdown", function (event) {
      if (moreWrap && !moreWrap.hidden && moreWrap.getAttribute("data-open") === "true" && !moreWrap.contains(event.target)) {
        setMoreOpen(false);
      }
      if (genresWrap && genresWrap.getAttribute("data-open") === "true" && !mobileQuery.matches && !genresWrap.contains(event.target)) {
        setGenresOpen(false);
      }
      if (roomsWrap && roomsWrap.getAttribute("data-open") === "true" && !mobileQuery.matches && !roomsWrap.contains(event.target)) {
        setRoomsOpen(false);
      }
      if (setsWrap && setsWrap.getAttribute("data-open") === "true" && !mobileQuery.matches && !setsWrap.contains(event.target)) {
        setSetsOpen(false);
      }
      if (artistsWrap && artistsWrap.getAttribute("data-open") === "true" && !mobileQuery.matches && !artistsWrap.contains(event.target)) {
        setArtistsOpen(false);
      }
    });
    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && moreWrap && moreWrap.getAttribute("data-open") === "true") {
        setMoreOpen(false);
        if (moreToggle) moreToggle.focus();
        return;
      }
      if (event.key === "Escape" && genresWrap && genresWrap.getAttribute("data-open") === "true" && !mobileQuery.matches) {
        setGenresOpen(false);
        if (genresToggle) genresToggle.focus();
        return;
      }
      if (event.key === "Escape" && roomsWrap && roomsWrap.getAttribute("data-open") === "true" && !mobileQuery.matches) {
        setRoomsOpen(false);
        if (roomsToggle) roomsToggle.focus();
        return;
      }
      if (event.key === "Escape" && setsWrap && setsWrap.getAttribute("data-open") === "true" && !mobileQuery.matches) {
        setSetsOpen(false);
        if (setsToggle) setsToggle.focus();
        return;
      }
      if (event.key === "Escape" && artistsWrap && artistsWrap.getAttribute("data-open") === "true" && !mobileQuery.matches) {
        setArtistsOpen(false);
        if (artistsToggle) artistsToggle.focus();
        return;
      }
      if (!menuIsOpen()) return;
      if (event.key === "Escape") {
        event.preventDefault();
        setMenuOpen(false, true);
        return;
      }
      if (event.key !== "Tab") return;
      var focusable = menu.querySelectorAll('a[href],button:not([disabled]),[tabindex]:not([tabindex="-1"])');
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener("change", function () {
        setMenuOpen(false, false);
        setMoreOpen(false);
        setGenresOpen(mobileQuery.matches);
        setRoomsOpen(mobileQuery.matches);
        setSetsOpen(mobileQuery.matches);
        setArtistsOpen(mobileQuery.matches);
        schedulePriorityNav();
      });
    } else {
      mobileQuery.addListener(function () {
        setMenuOpen(false, false);
        setMoreOpen(false);
        setGenresOpen(mobileQuery.matches);
        setRoomsOpen(mobileQuery.matches);
        setSetsOpen(mobileQuery.matches);
        setArtistsOpen(mobileQuery.matches);
        schedulePriorityNav();
      });
    }
    function alignOpenDropdowns() {
      alignDropdown(moreWrap, morePanel);
      alignDropdown(genresWrap, genresPanel);
      alignDropdown(roomsWrap, roomsPanel);
      alignDropdown(artistsWrap, artistsPanel);
      alignDropdown(setsWrap, setsPanel);
    }

    window.addEventListener("resize", function () {
      if (menuIsOpen()) updateMenuPosition();
      alignOpenDropdowns();
      schedulePriorityNav();
    });
    if ("ResizeObserver" in window && primary) {
      var navEl = header.querySelector(".nav");
      if (navEl) new ResizeObserver(schedulePriorityNav).observe(navEl);
    }
    setMenuOpen(false, false);
    setGenresOpen(mobileQuery.matches);
    setRoomsOpen(mobileQuery.matches);
    setSetsOpen(mobileQuery.matches);
    setArtistsOpen(mobileQuery.matches);
    schedulePriorityNav();
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(schedulePriorityNav).catch(function () {});
    }
  });

  /* ---------- sticky header: hide on scroll down, show on scroll up ---------- */
  document.addEventListener("DOMContentLoaded", function () {
    var header = document.querySelector(".site-header");
    if (!header) return;
    var section = header.closest(".shopify-section") || header;

    var lastY = window.scrollY || 0;
    var ticking = false;
    var topReveal = 24;
    var minDelta = 6;
    var reduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    function overlaysOpen() {
      return header.getAttribute("data-menu-open") === "true"
        || document.documentElement.classList.contains("search-lock")
        || document.documentElement.classList.contains("favourites-lock");
    }

    function updateHeader() {
      ticking = false;
      var y = window.scrollY || 0;
      var delta = y - lastY;

      header.classList.toggle("is-scrolled", y > 8);
      section.classList.toggle("is-scrolled", y > 8);

      if (reduced || overlaysOpen() || y <= topReveal) {
        section.classList.remove("is-scroll-hidden");
        header.classList.remove("is-scroll-hidden");
        lastY = y;
        return;
      }

      if (Math.abs(delta) < minDelta) return;

      if (delta > 0 && y > 80) {
        section.classList.add("is-scroll-hidden");
        header.classList.add("is-scroll-hidden");
        var more = header.querySelector("[data-nav-more]");
        if (more && more.getAttribute("data-open") === "true") {
          more.setAttribute("data-open", "false");
          var toggle = more.querySelector("[data-nav-more-toggle]");
          var panel = more.querySelector("[data-nav-more-panel]");
          if (toggle) toggle.setAttribute("aria-expanded", "false");
          if (panel) panel.hidden = true;
        }
      } else if (delta < 0) {
        section.classList.remove("is-scroll-hidden");
        header.classList.remove("is-scroll-hidden");
      }

      lastY = y;
    }

    window.addEventListener("scroll", function () {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(updateHeader);
      }
    }, { passive: true });

    updateHeader();
  });

  /* ---------- frame rail photo prefetch / apply helpers ---------- */
  // Photo moulding rails are CSS background-images. Without prefetch, a style
  // or colour click paints CSS gradients (or empty rails) until the JPGs arrive.
  var FRAME_RAIL_SIDES = ["l", "t", "r", "b"];
  var FRAME_RAIL_SETS = {
    swoop: { prefix: "swoop", keys: ["white", "black", "gold", "silver"] },
    classic: {
      prefix: "classic",
      keys: ["oak", "black", "white", "gold", "silver", "bronze", "natural", "antique-gold", "antique-silver"]
    },
    "deep-classic": {
      prefix: "deep-classic",
      keys: ["oak", "black", "white", "gold", "silver", "bronze", "natural", "antique-gold", "antique-silver"]
    },
    venice: {
      prefix: "venice",
      keys: ["silver", "black-pewter", "terracotta-silver", "white-silver"]
    }
  };
  var frameAssetBase = null;
  var frameAssetPrefetch = Object.create(null);
  var frameAssetReady = Object.create(null);
  var frameAssetWaiters = Object.create(null);

  function getFrameAssetBase() {
    if (frameAssetBase != null) return frameAssetBase;
    var link = document.querySelector('link[href*="frame-visualiser.css"], link[href*="theme.css"]');
    var href = link && link.href;
    frameAssetBase = href ? href.replace(/[^/]+$/, "") : "";
    return frameAssetBase;
  }

  function frameAssetUrl(filename) {
    return getFrameAssetBase() + filename;
  }

  function frameRailFilenames(prefix, key) {
    return FRAME_RAIL_SIDES.map(function (side) {
      return prefix + "-" + key + "-" + side + ".jpg";
    });
  }

  function markFrameAssetReady(filename) {
    frameAssetReady[filename] = true;
    var waiters = frameAssetWaiters[filename];
    if (!waiters) return;
    delete frameAssetWaiters[filename];
    waiters.forEach(function (fn) {
      try { fn(); } catch (e) {}
    });
  }

  function prefetchFrameAsset(filename) {
    if (!filename || frameAssetPrefetch[filename]) return;
    frameAssetPrefetch[filename] = true;
    var img = new Image();
    function ready() { markFrameAssetReady(filename); }
    function loaded() {
      if (typeof img.decode === "function") {
        img.decode().then(ready, ready);
      } else {
        ready();
      }
    }
    img.onload = loaded;
    img.onerror = ready;
    img.src = frameAssetUrl(filename);
    if (img.complete) {
      if (img.naturalWidth) loaded();
      else ready();
    }
  }

  function whenFrameAssetsReady(filenames, done) {
    var pending = 0;
    var settled = false;
    function finish() {
      if (settled) return;
      settled = true;
      done();
    }
    function oneReady() {
      pending--;
      if (pending <= 0) finish();
    }
    filenames.forEach(function (name) {
      if (frameAssetReady[name]) return;
      pending++;
      prefetchFrameAsset(name);
      if (frameAssetReady[name]) {
        pending--;
        return;
      }
      (frameAssetWaiters[name] || (frameAssetWaiters[name] = [])).push(oneReady);
    });
    if (pending <= 0) finish();
  }

  function prefetchFrameRailSet(setKey) {
    var set = FRAME_RAIL_SETS[setKey];
    if (!set) return;
    set.keys.forEach(function (key) {
      frameRailFilenames(set.prefix, key).forEach(prefetchFrameAsset);
    });
  }

  function prefetchFrameRailsForModes(modes) {
    modes = modes || {};
    if (!modes.swoop || modes.swoop === "photo") prefetchFrameRailSet("swoop");
    if (!modes.classic || modes.classic === "photo") {
      prefetchFrameRailSet("classic");
      prefetchFrameRailSet("deep-classic");
    }
    if (!modes.venice || modes.venice === "photo") prefetchFrameRailSet("venice");
  }

  function scheduleFrameRailPrefetch(modes) {
    var run = function () { prefetchFrameRailsForModes(modes); };
    if (typeof window.requestIdleCallback === "function") {
      window.requestIdleCallback(run, { timeout: 1200 });
    } else {
      window.setTimeout(run, 120);
    }
  }

  function frameRailPhotoPlan(ftype, fkey, modes) {
    if (!fkey || !modes) return null;
    if (ftype === "swoop" && modes.swoop === "photo" && FRAME_RAIL_SETS.swoop.keys.indexOf(fkey) > -1) {
      return { attr: "data-swoop", prefix: "swoop", key: fkey };
    }
    if (ftype === "standard" && modes.classic === "photo" && FRAME_RAIL_SETS.classic.keys.indexOf(fkey) > -1) {
      return { attr: "data-classic", prefix: "classic", key: fkey };
    }
    if (ftype === "widebox" && modes.classic === "photo" && FRAME_RAIL_SETS["deep-classic"].keys.indexOf(fkey) > -1) {
      return { attr: "data-deep-classic", prefix: "deep-classic", key: fkey };
    }
    if (ftype === "venice" && modes.venice === "photo" && FRAME_RAIL_SETS.venice.keys.indexOf(fkey) > -1) {
      return { attr: "data-venice", prefix: "venice", key: fkey };
    }
    return null;
  }

  var FRAME_PHOTO_ATTRS = ["data-classic", "data-deep-classic", "data-swoop", "data-venice"];

  function frameShadowScale(widthPx) {
    var s = (Number(widthPx) || 0) / 280;
    if (s < 0.8) s = 0.8;
    if (s > 2.2) s = 2.2;
    return s.toFixed(3);
  }

  function syncFrameShadowScale(wrap) {
    if (!wrap) return;
    var rendered = wrap.offsetWidth;
    wrap.style.setProperty("--fv-s-fit", frameShadowScale(rendered));
    var stage = wrap.closest("[data-shadow]");
    if (stage && /realistic-v[34]/.test(String(stage.getAttribute("data-shadow") || ""))) {
      wrap.style.setProperty("--fv-s", frameShadowScale(rendered));
    }
  }

  function ensureFrameShadowScaleObserver(wrap) {
    if (!wrap || wrap._fvScaleRO || typeof ResizeObserver !== "function") return;
    wrap._fvScaleRO = new ResizeObserver(function () {
      syncFrameShadowScale(wrap);
    });
    wrap._fvScaleRO.observe(wrap);
  }

  function clearFramePhotoAttrs(frameEl) {
    FRAME_PHOTO_ATTRS.forEach(function (attr) { frameEl.removeAttribute(attr); });
  }

  function currentFramePhotoPlan(frameEl) {
    for (var i = 0; i < FRAME_PHOTO_ATTRS.length; i++) {
      var attr = FRAME_PHOTO_ATTRS[i];
      var key = frameEl.getAttribute(attr);
      if (key) return { attr: attr, key: key };
    }
    return null;
  }

  function applyFramePhotoAttrs(frameEl, plan) {
    if (!plan) {
      clearFramePhotoAttrs(frameEl);
      return;
    }
    var current = currentFramePhotoPlan(frameEl);
    if (current && current.attr === plan.attr && current.key === plan.key) {
      frameEl.querySelectorAll("[data-rail], .card-rail").forEach(function (rail) {
        if (rail.style.backgroundImage) rail.style.backgroundImage = "";
      });
      return;
    }
    frameEl.setAttribute(plan.attr, plan.key);
    FRAME_PHOTO_ATTRS.forEach(function (attr) {
      if (attr !== plan.attr) frameEl.removeAttribute(attr);
    });
    frameEl.querySelectorAll("[data-rail], .card-rail").forEach(function (rail) {
      if (rail.style.backgroundImage) rail.style.backgroundImage = "";
    });
  }

  function swapFrameStyleProfile(img, filename, alt) {
    if (!img || !filename) return;
    var cur = img.getAttribute("src") || "";
    if (cur.indexOf(filename) !== -1) {
      img.alt = alt;
      return;
    }
    var nextUrl = frameAssetUrl(filename);
    var probe = new Image();
    probe.onload = function () {
      if ((img.getAttribute("src") || "").indexOf(filename) !== -1) {
        img.alt = alt;
        return;
      }
      var apply = function () {
        img.src = nextUrl;
        img.alt = alt;
      };
      if (typeof probe.decode === "function") probe.decode().then(apply, apply);
      else apply();
    };
    probe.src = nextUrl;
  }

  function bindScenesLightbox(scope) {
    var section = (scope && scope.matches && scope.matches("[data-scenes]"))
      ? scope
      : ((scope && scope.querySelector && scope.querySelector("[data-scenes]")) || document.querySelector("[data-scenes]"));
    if (!section || section._artfolioScenesBound) return;
    var dialog = section.querySelector("[data-scenes-lightbox]");
    var img = dialog && dialog.querySelector("[data-scenes-lightbox-img]");
    var caption = dialog && dialog.querySelector("[data-scenes-lightbox-caption]");
    if (!dialog || !img) return;
    section._artfolioScenesBound = true;
    section.addEventListener("click", function (event) {
      var btn = event.target && event.target.closest && event.target.closest(".scenes-item");
      if (!btn || !section.contains(btn)) return;
      img.src = btn.getAttribute("data-scene-src") || "";
      img.alt = btn.getAttribute("data-scene-alt") || "";
      var text = btn.getAttribute("data-scene-caption") || "";
      if (caption) {
        caption.textContent = text;
        caption.hidden = !text;
      }
      if (typeof dialog.showModal === "function") dialog.showModal();
    });
  }

  /* ---------- reusable frame visualiser + product bindings ---------- */
  function initFrameVisualiser(root) {
    var dataEl = root.querySelector("[data-product-json]");
    var isProductPage = !!dataEl;
    var product = dataEl ? JSON.parse(dataEl.textContent) : { options: [], variants: [] };
    var visualiser = root.matches("[data-frame-visualiser]") ? root : root.querySelector("[data-frame-visualiser]");
    if (!visualiser) return null;
    if (visualiser.frameVisualiser) return visualiser.frameVisualiser;
    var visualiserApi = {};

    // Warm moulding rail JPGs so colour/style clicks do not flash CSS gradients.
    var initialRailModes = {
      swoop: visualiser.getAttribute("data-swoop-render") || "css",
      classic: visualiser.getAttribute("data-classic-render") || "css",
      venice: visualiser.getAttribute("data-venice-render") || "css"
    };
    // Current defaults first (blocking cache warm), then the rest on idle.
    prefetchFrameRailSet("classic");
    scheduleFrameRailPrefetch(initialRailModes);

    // Discover may portal its customise drawer to <body> after init. Keep
    // control lookups working without changing product-page behaviour.
    function portaledDiscoverDrawer() {
      var drawer = document.querySelector("[data-discover-drawer]");
      return drawer && !root.contains(drawer) ? drawer : null;
    }
    function controlQuery(selector) {
      var found = root.querySelector(selector);
      if (found) return found;
      var drawer = portaledDiscoverDrawer();
      return drawer ? drawer.querySelector(selector) : null;
    }
    function controlQueryAll(selector) {
      var list = Array.prototype.slice.call(root.querySelectorAll(selector));
      var drawer = portaledDiscoverDrawer();
      if (drawer) list = list.concat(Array.prototype.slice.call(drawer.querySelectorAll(selector)));
      return list;
    }
    function setControlTexts(selector, text) {
      if (text == null) return;
      controlQueryAll(selector).forEach(function (el) { el.textContent = text; });
    }

    var form = root.querySelector("[data-product] form") || root.querySelector("form");
    var idInput = root.querySelector("[data-variant-id]");
    var priceMain = root.querySelector("[data-price]");
    var priceWas = root.querySelector("[data-price-was]");
    var addBtn = root.querySelector("[data-add]");
    var addLabel = root.querySelector("[data-add-label]");
    var addAmt = root.querySelector("[data-add-amount]");
    var qtyInput = root.querySelector("[data-qty]");

    var frameEls = visualiser.querySelectorAll("[data-frame]");
    var mountEls = visualiser.querySelectorAll("[data-mount]");
    var isSplitRooms = visualiser.hasAttribute("data-split-rooms");
    var framewrap = visualiser.querySelector("[data-framewrap]");
    var mountColourOpt = controlQuery("[data-mount-colour-opt]");

    function refreshArtworkNodes() {
      frameEls = visualiser.querySelectorAll("[data-frame]");
      mountEls = visualiser.querySelectorAll("[data-mount]");
    }

    // Artwork orientation only — never Diptych/Triptych (those come from Size).
    function visualiserShape(orientation) {
      var value = String(orientation || "portrait").toLowerCase();
      if (value.indexOf("square") > -1) return "square";
      // "Portrait panoramic" is tall. Bare "Panoramic" hangs landscape.
      if (value.indexOf("port") > -1) return "portrait";
      if (value.indexOf("land") > -1 || value.indexOf("pano") > -1) return "landscape";
      return "portrait";
    }

    function dimensionShape(orientation) {
      var value = String(orientation || "portrait").toLowerCase();
      if (value.indexOf("pano") > -1 && value.indexOf("port") > -1) return "portrait";
      if (value.indexOf("pano") > -1) return null;
      if (value.indexOf("square") > -1) return "square";
      if (value.indexOf("land") > -1) return "landscape";
      return "portrait";
    }

    function layoutFromSize(value) {
      var v = String(value || "").toLowerCase();
      if (v.indexOf("triptych") > -1) return "triptych";
      if (v.indexOf("diptych") > -1) return "diptych";
      return null;
    }

    function isMultiPanelLayout(layout) {
      return layout === "diptych" || layout === "triptych";
    }

    function selectedDimensionShape() {
      return dimensionShape(visualiser.getAttribute("data-orientation"));
    }

    function productHasSizeOption() {
      return (product.options || []).some(function (name) {
        return looksLike(name, ["size", "dimension"]);
      });
    }

    function selectedLayout() {
      return layoutFromSize(controlValue("size"));
    }

    function rosenstielsFinishedSize(label) {
      var mountVal = controlValue("mount");
      if (!mountVal || !/no mount|none|unmounted/i.test(mountVal)) return null;
      if (!(isRosenstielsCatalogue(visualiser) || isRosenstielsCatalogue(root))) return null;
      return rosenstielsNoMountFromLabel(label);
    }

    function sizeKey(value) {
      var key = String(value || "").toLowerCase().replace(/[^a-z0-9]/g, "");
      if (key.indexOf("diptych") > -1 || key.indexOf("triptych") > -1) return "multi";
      if (key === "xl" || key.indexOf("extralarge") > -1 || key.indexOf("xlarge") > -1) return "extralarge";
      if (key.indexOf("small") > -1) return "small";
      if (key.indexOf("large") > -1) return "large";
      return "medium";
    }

    // Named size tiers only. Diptych/Triptych and products with no Size option
    // are not Large/Extra Large in the data, so they get the house-rule sentence.
    function glazingForTier(tier) {
      if (tier === "large" || tier === "extralarge") return "2 mm acrylic";
      if (tier === "small" || tier === "medium") return "1.5 mm float glass";
      return "1.5 mm float glass; 2 mm acrylic on Large and Extra Large";
    }

    function printSizeCm(shape, tier, label) {
      var parsed = parseSizeCmFromLabel(label);
      if (!parsed && tier) {
        sizeControlButtons().some(function (button) {
          var value = button.getAttribute("data-value") || button.textContent || "";
          if (layoutFromSize(value) || sizeKey(value) !== tier) return false;
          parsed = parseSizeCmFromLabel(value);
          return !!parsed;
        });
      }
      if (parsed) return landscapePanoCm(parsed, shape) || parsed;
      var table = isRosenstielsCatalogue(visualiser) || isRosenstielsCatalogue(root)
        ? ROSENSTIELS_PRINT_SIZES
        : PRINT_SIZES;
      if (!shape || !tier) return null;
      if (shape === "portrait") {
        var landscape = table.landscape && table.landscape[tier];
        if (!landscape) return null;
        return { w: landscape.h, h: landscape.w, inW: landscape.inH, inH: landscape.inW };
      }
      return (table[shape] && table[shape][tier]) || null;
    }

    var sizeDimensionUnit = "cm";
    function dimensionLabel(dimensions) {
      if (sizeDimensionUnit === "inch") {
        return dimensions.inW + "×" + dimensions.inH + "″";
      }
      return dimensions.w + "×" + dimensions.h + "cm";
    }

    function sizeControlButtons() {
      var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-pp-type="size"]'));
      (product.options || []).forEach(function (optionName, index) {
        if (!looksLike(optionName, ["size", "dimension"])) return;
        var group = root.querySelector('[data-option-index="' + (index + 1) + '"]');
        if (group) buttons = buttons.concat(Array.prototype.slice.call(group.querySelectorAll("[data-value]")));
      });
      return buttons;
    }

    function multiLayoutAllowed(layout, shape) {
      if (layout === "diptych") return shape === "square";
      if (layout === "triptych") return shape === "landscape";
      return false;
    }

    function updateSizeControlLabels() {
      var shape = selectedDimensionShape();
      var layout = selectedLayout();
      var buttons = sizeControlButtons();
      var activeExtraLarge = null;
      var largeButton = null;
      var activeInvalidMulti = null;
      var hideProductSize = isProductPage && !productHasSizeOption();

      controlQueryAll("[data-size-unit]").forEach(function (group) {
        group.hidden = hideProductSize || (!shape && !layout);
      });
      controlQueryAll("[data-size-approx-note]").forEach(function (note) {
        note.hidden = (!shape && !layout) || sizeDimensionUnit !== "inch";
      });
      controlQueryAll("[data-multi-size-note]").forEach(function (note) {
        var showDiptych = multiLayoutAllowed("diptych", shape);
        var showTriptych = multiLayoutAllowed("triptych", shape);
        note.hidden = !shape || showDiptych || showTriptych;
        if (!note.hidden) {
          if (shape === "portrait") {
            note.textContent = "Diptych and Triptych are available on square and landscape works.";
          } else {
            note.textContent = "Diptych suits square works; Triptych suits landscape.";
          }
        }
      });

      buttons.forEach(function (button) {
        var value = button.getAttribute("data-value");
        var buttonLayout = layoutFromSize(value);
        var tier = sizeKey(value);
        var sub = button.querySelector("[data-size-dimension]");
        if (!sub && (shape || buttonLayout)) {
          sub = document.createElement("span");
          sub.className = "sub";
          sub.setAttribute("data-size-dimension", "");
          button.appendChild(sub);
        }

        if (buttonLayout) {
          var multiAllowed = multiLayoutAllowed(buttonLayout, shape);
          button.hidden = !multiAllowed;
          if (sub) {
            var lockedDim = sub.getAttribute("data-bb-size-dim");
            if (lockedDim) {
              sub.textContent = lockedDim;
            } else {
              sub.textContent = multiAllowed
                ? dimensionLabel(MULTI_PANEL_SPECS[buttonLayout].overall)
                : "";
            }
          }
          if (!multiAllowed && button.getAttribute("aria-pressed") === "true") {
            activeInvalidMulti = button;
          }
          return;
        }

        if (hideProductSize) {
          button.hidden = true;
          return;
        }

        if (!shape) {
          if (tier === "extralarge") {
            button.hidden = true;
            if (button.getAttribute("aria-pressed") === "true") activeExtraLarge = button;
          } else {
            button.hidden = false;
          }
          if (sub) sub.textContent = sub.getAttribute("data-legacy-label") || "";
          if (tier === "large") largeButton = button;
          return;
        }

        button.hidden = false;
        if (tier !== "multi") {
          if (sub) {
            var finished = rosenstielsFinishedSize(value);
            sub.textContent = finished
              ? dimensionLabel(finished)
              : (landscapePanoCm(parseSizeCmFromLabel(value))
                ? ""
                : dimensionLabel(printSizeCm(shape, tier, value)));
          }
        }
        if (tier === "large") largeButton = button;
      });

      if ((!shape && activeExtraLarge && largeButton) || (activeInvalidMulti && largeButton)) {
        largeButton.click();
      }

      controlQueryAll("[data-selected-size-dimension]").forEach(function (label) {
        if (layout && multiLayoutAllowed(layout, shape)) {
          label.textContent = dimensionLabel(MULTI_PANEL_SPECS[layout].overall);
        } else if (shape) {
          var selectedSize = controlValue("size");
          var selectedTier = sizeKey(selectedSize);
          var selectedFinished = rosenstielsFinishedSize(selectedSize);
          if (selectedFinished) label.textContent = dimensionLabel(selectedFinished);
          else if (selectedTier === "multi" || landscapePanoCm(parseSizeCmFromLabel(selectedSize))) label.textContent = "";
          else label.textContent = dimensionLabel(printSizeCm(shape, selectedTier, selectedSize));
        } else {
          label.textContent = "";
        }
      });
    }

    controlQueryAll("[data-size-unit]").forEach(function (group) {
      group.addEventListener("click", function (event) {
        var button = event.target.closest("[data-size-unit-value]");
        if (!button) return;
        sizeDimensionUnit = button.getAttribute("data-size-unit-value") === "inch" ? "inch" : "cm";
        controlQueryAll("[data-size-unit-value]").forEach(function (unitButton) {
          unitButton.setAttribute(
            "aria-pressed",
            unitButton.getAttribute("data-size-unit-value") === sizeDimensionUnit ? "true" : "false"
          );
        });
        updateSizeControlLabels();
      });
    });

    function extractBgImageUrl(styleValue) {
      var match = String(styleValue || "").match(/url\(["']?(.*?)["']?\)/i);
      return match ? match[1] : "";
    }

    function cssVarPx(el, names) {
      var view = el.ownerDocument && el.ownerDocument.defaultView || window;
      var cs = view.getComputedStyle(el);
      for (var i = 0; i < names.length; i += 1) {
        var n = parseFloat(cs.getPropertyValue(names[i]));
        if (isFinite(n) && n > 0) return n;
      }
      return 0;
    }

    function setMitreClip(el, points) {
      var value = "polygon(" + points + ")";
      el.style.setProperty("clip-path", value, "important");
      el.style.setProperty("-webkit-clip-path", value, "important");
    }

    function framesIn(scope) {
      var frames = [];
      if (!scope) return frames;
      if (scope.hasAttribute && scope.hasAttribute("data-frame")) frames.push(scope);
      if (scope.querySelectorAll) {
        Array.prototype.forEach.call(scope.querySelectorAll("[data-frame]"), function (frame) {
          if (frames.indexOf(frame) === -1) frames.push(frame);
        });
      }
      return frames;
    }

    // html2canvas drops clip-path when it contains calc()/var(), so the photo
    // moulding rails render as rectangles and the mitres become box joins.
    // Rewrite clips with pixel polygons the library can actually parse.
    function hardenFrameMitres(scope) {
      framesIn(scope).forEach(function (frame) {
        if (frame.classList.contains("none")) return;
        var t = cssVarPx(frame, ["--frame-t", "--frame-w"]);
        var r = cssVarPx(frame, ["--frame-r", "--frame-w"]);
        var b = cssVarPx(frame, ["--frame-b", "--frame-w"]);
        var l = cssVarPx(frame, ["--frame-l", "--frame-w"]);
        var top = frame.querySelector('[data-rail="t"]');
        var right = frame.querySelector('[data-rail="r"]');
        var bottom = frame.querySelector('[data-rail="b"]');
        var left = frame.querySelector('[data-rail="l"]');
        if (top) {
          var tw = Math.max(1, top.getBoundingClientRect().width);
          var th = Math.max(1, top.getBoundingClientRect().height);
          setMitreClip(top, "0px 0px, " + tw + "px 0px, " + (tw - r) + "px " + th + "px, " + l + "px " + th + "px");
        }
        if (bottom) {
          var bw = Math.max(1, bottom.getBoundingClientRect().width);
          var bh = Math.max(1, bottom.getBoundingClientRect().height);
          setMitreClip(bottom, l + "px 0px, " + (bw - r) + "px 0px, " + bw + "px " + bh + "px, 0px " + bh + "px");
        }
        if (left) {
          var lw = Math.max(1, left.getBoundingClientRect().width);
          var lh = Math.max(1, left.getBoundingClientRect().height);
          setMitreClip(left, "0px 0px, " + lw + "px " + t + "px, " + lw + "px " + (lh - b) + "px, 0px " + lh + "px");
        }
        if (right) {
          var rw = Math.max(1, right.getBoundingClientRect().width);
          var rh = Math.max(1, right.getBoundingClientRect().height);
          setMitreClip(right, "0px " + t + "px, " + rw + "px 0px, " + rw + "px " + rh + "px, 0px " + (rh - b) + "px");
        }
      });
    }

    function loadRailImage(src) {
      return new Promise(function (resolve, reject) {
        if (!src) {
          reject(new Error("no_src"));
          return;
        }
        var image = new Image();
        image.crossOrigin = "anonymous";
        image.onload = function () { resolve(image); };
        image.onerror = reject;
        image.src = src;
      });
    }

    function paintMitredRails(canvas, capturedEl) {
      var capturedRect = capturedEl.getBoundingClientRect();
      var scaleX = canvas.width / Math.max(1, capturedRect.width);
      var scaleY = canvas.height / Math.max(1, capturedRect.height);
      var ctx = canvas.getContext("2d");
      var jobs = [];
      framesIn(capturedEl).forEach(function (frame) {
        if (frame.classList.contains("none")) return;
        var t = cssVarPx(frame, ["--frame-t", "--frame-w"]);
        var r = cssVarPx(frame, ["--frame-r", "--frame-w"]);
        var b = cssVarPx(frame, ["--frame-b", "--frame-w"]);
        var l = cssVarPx(frame, ["--frame-l", "--frame-w"]);
        Array.prototype.forEach.call(frame.querySelectorAll("[data-rail]"), function (rail) {
          var side = rail.getAttribute("data-rail");
          var cs = window.getComputedStyle(rail);
          var url = extractBgImageUrl(cs.backgroundImage);
          if (!url || cs.display === "none" || cs.visibility === "hidden") return;
          var rect = rail.getBoundingClientRect();
          var x = (rect.left - capturedRect.left) * scaleX;
          var y = (rect.top - capturedRect.top) * scaleY;
          var w = rect.width * scaleX;
          var h = rect.height * scaleY;
          var ts = t * scaleY;
          var rs = r * scaleX;
          var bs = b * scaleY;
          var ls = l * scaleX;
          jobs.push(loadRailImage(url).then(function (img) {
            ctx.save();
            ctx.beginPath();
            if (side === "t") {
              ctx.moveTo(x, y);
              ctx.lineTo(x + w, y);
              ctx.lineTo(x + w - rs, y + h);
              ctx.lineTo(x + ls, y + h);
            } else if (side === "b") {
              ctx.moveTo(x + ls, y);
              ctx.lineTo(x + w - rs, y);
              ctx.lineTo(x + w, y + h);
              ctx.lineTo(x, y + h);
            } else if (side === "l") {
              ctx.moveTo(x, y);
              ctx.lineTo(x + w, y + ts);
              ctx.lineTo(x + w, y + h - bs);
              ctx.lineTo(x, y + h);
            } else {
              ctx.moveTo(x, y + ts);
              ctx.lineTo(x + w, y);
              ctx.lineTo(x + w, y + h);
              ctx.lineTo(x, y + h - bs);
            }
            ctx.closePath();
            ctx.clip();
            ctx.imageSmoothingEnabled = true;
            ctx.imageSmoothingQuality = "high";
            ctx.drawImage(img, x, y, w, h);
            ctx.globalCompositeOperation = "source-atop";
            ctx.fillStyle = (side === "t" || side === "r")
              ? "rgba(255,255,255,0.045)"
              : "rgba(0,0,0,0.055)";
            ctx.fillRect(x, y, w, h);
            ctx.restore();
          }).catch(function () {}));
        });
      });
      return Promise.all(jobs).then(function () { return canvas; });
    }

    function canvasToJpegDataUrl(canvas, quality, maxEdge, background) {
      var out = canvas;
      var edge = Math.max(canvas.width, canvas.height);
      if (maxEdge && edge > maxEdge) {
        var scale = maxEdge / edge;
        out = document.createElement("canvas");
        out.width = Math.round(canvas.width * scale);
        out.height = Math.round(canvas.height * scale);
        var ctx = out.getContext("2d");
        if (background) {
          ctx.fillStyle = background;
          ctx.fillRect(0, 0, out.width, out.height);
        }
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = "high";
        ctx.drawImage(canvas, 0, 0, out.width, out.height);
      }
      return new Promise(function (resolve, reject) {
        try {
          out.toBlob(function (blob) {
            if (!blob) return reject(new Error("invalid_image"));
            var reader = new FileReader();
            reader.onload = function () { resolve(String(reader.result || "")); };
            reader.onerror = function () { reject(new Error("invalid_image")); };
            reader.readAsDataURL(blob);
          }, "image/jpeg", quality || 0.93);
        } catch (error) {
          reject(new Error("invalid_image"));
        }
      });
    }

    function readArtworkFromDom() {
      var img = visualiser.querySelector("[data-piece] img");
      var slice = visualiser.querySelector(".dip-slice, .tri-slice");
      var image = "";
      var highRes = "";
      if (img) {
        image = img.currentSrc || img.src || "";
        var zoomHost = img.closest("[data-zoom]");
        highRes = (zoomHost && zoomHost.getAttribute("data-zoom-src")) || image;
      } else if (slice) {
        image = extractBgImageUrl(slice.style.backgroundImage);
        highRes = image;
      }
      return {
        orientation: visualiser.getAttribute("data-orientation") || "portrait",
        image: image,
        highRes: highRes,
        alt: (img && img.alt) || "",
        title: "",
        paletteClass: "a-slate"
      };
    }

    var currentArtwork = readArtworkFromDom();

    function createDynamicFrame(artwork, slice, panelCount) {
      var frame = document.createElement("div");
      frame.className = "frame none";
      frame.setAttribute("data-frame", "");

      var mount = document.createElement("div");
      mount.className = "mount off";
      mount.setAttribute("data-mount", "");

      var piece = document.createElement("div");
      piece.className = "piece";
      piece.setAttribute("data-piece", "");
      if (slice != null) {
        var slices = panelCount === 2 ? 2 : 3;
        piece.classList.add(slices === 2 ? "dip-slice" : "tri-slice");
        piece.setAttribute("data-slice", String(slice));
        if (artwork.image) piece.style.backgroundImage = 'url("' + artwork.image.replace(/"/g, "%22") + '")';
      } else {
        piece.setAttribute("data-zoom", "");
        if (artwork.highRes || artwork.image) {
          piece.setAttribute("data-zoom-src", artwork.highRes || artwork.image);
        }
        if (artwork.image) {
          var img = document.createElement("img");
          img.src = artwork.image;
          img.alt = artwork.alt || artwork.title || "Artwork";
          piece.appendChild(img);
        }
      }
      if (!artwork.image) piece.classList.add("a", artwork.paletteClass || "a-slate");

      mount.appendChild(piece);
      frame.appendChild(mount);
      ["t", "r", "b", "l"].forEach(function (side) {
        var rail = document.createElement("span");
        rail.className = "rail " + side;
        rail.setAttribute("data-rail", side);
        frame.appendChild(rail);
      });
      return frame;
    }

    function updateStageOrientationClass(layout) {
      visualiser.querySelectorAll("[data-stage]").forEach(function (stageEl) {
        ["portrait", "landscape", "square", "triptych", "diptych"].forEach(function (name) {
          stageEl.classList.remove("o-" + name);
        });
        if (isMultiPanelLayout(layout)) {
          stageEl.classList.add("o-" + layout);
        } else {
          stageEl.classList.add("o-" + visualiserShape(visualiser.getAttribute("data-orientation")));
        }
      });
    }

    function currentDomLayout() {
      var set = visualiser.querySelector("[data-arrange-layer] .diptych, [data-arrange-layer] .triptych");
      if (!set) return null;
      return set.classList.contains("diptych") ? "diptych" : "triptych";
    }

    function syncPanelLayout(force) {
      var layout = selectedLayout();
      var layers = visualiser.querySelectorAll("[data-arrange-layer]");
      if (!layers.length) return;

      if (!force && currentDomLayout() === layout) {
        updateStageOrientationClass(layout);
        return;
      }

      var artwork = currentArtwork || readArtworkFromDom();
      layers.forEach(function (arrangeLayer) {
        var handle = arrangeLayer.querySelector("[data-arrange-handle]");
        Array.prototype.slice.call(arrangeLayer.children).forEach(function (child) {
          if (child !== handle) arrangeLayer.removeChild(child);
        });
        if (isMultiPanelLayout(layout)) {
          var set = document.createElement("div");
          set.className = layout;
          var count = MULTI_PANEL_SPECS[layout].panels;
          for (var i = 0; i < count; i++) set.appendChild(createDynamicFrame(artwork, i, count));
          if (handle) arrangeLayer.insertBefore(set, handle);
          else arrangeLayer.appendChild(set);
        } else {
          var frame = createDynamicFrame(artwork, null);
          if (handle) arrangeLayer.insertBefore(frame, handle);
          else arrangeLayer.appendChild(frame);
        }
      });

      updateStageOrientationClass(layout);
      refreshArtworkNodes();

      var zoomHint = visualiser.querySelector(".zoom-hint");
      if (!zoomHint && artwork.image && !isMultiPanelLayout(layout)) {
        zoomHint = document.createElement("div");
        zoomHint.className = "zoom-hint";
        zoomHint.setAttribute("aria-hidden", "true");
        zoomHint.textContent = "⌕ Hover to zoom";
        var artSummary = visualiser.querySelector("[data-selection-summary]");
        if (artSummary && artSummary.parentNode) artSummary.parentNode.insertBefore(zoomHint, artSummary);
      }
      if (zoomHint) {
        zoomHint.hidden = !artwork.image || isMultiPanelLayout(layout);
        if (visualiser.hasAttribute("data-zoom-hint-seen")) zoomHint.classList.add("is-dismissed");
        else zoomHint.classList.remove("is-dismissed");
      }

      visualiser.querySelectorAll("[data-zoom]").forEach(function (dynamicPiece) {
        attachMagnifier(dynamicPiece, dynamicPiece.getAttribute("data-zoom-src"));
      });
    }

    function replaceArtwork(artwork) {
      artwork = artwork || {};
      currentArtwork = {
        orientation: artwork.orientation || visualiser.getAttribute("data-orientation") || "portrait",
        image: artwork.image || "",
        highRes: artwork.highRes || artwork.image || "",
        alt: artwork.alt || "",
        title: artwork.title || "",
        paletteClass: artwork.paletteClass || "a-slate"
      };
      visualiser.setAttribute("data-orientation", String(currentArtwork.orientation).toLowerCase());
      syncPanelLayout(true);
      updateSizeControlLabels();
      updatePreview();
    }

    var frameColours = {
      "oak": "linear-gradient(135deg,#C49A66,#A87E4C)", "black": "#1B1A18", "white": "#F4F1EA",
      "gold": "linear-gradient(135deg,#D9B978,#B8934E)", "silver": "linear-gradient(135deg,#D8DBDE,#AEB4B9)",
      "bronze": "linear-gradient(135deg,#B08D5B,#7C5C34)", "natural": "linear-gradient(135deg,#E6D6BC,#CBB68E)",
      "antique-gold": "linear-gradient(135deg,#C7A867,#93753F)", "antique-silver": "linear-gradient(135deg,#C4C3BC,#98968C)",
      "black-pewter": "linear-gradient(135deg,#26262a,#26262a 55%,#9a9ea1 55%,#7f8386)",
      "terracotta-silver": "linear-gradient(135deg,#b5673f,#b5673f 55%,#c9ccce 55%,#aeb2b5)",
      "white-silver": "linear-gradient(135deg,#f0ede7,#f0ede7 55%,#cfd2d5 55%,#b8bcbf)"
    };
    function colourKey(val) {
      if (!val) return "";
      var v = val.toLowerCase();
      if (v === "antique gold") return "antique-gold";
      if (v === "antique silver") return "antique-silver";
      if (v === "black and pewter") return "black-pewter";
      if (v === "terracotta and silver") return "terracotta-silver";
      if (v === "white and silver") return "white-silver";
      return v.split(" ")[0];
    }

    // realistic moulding finishes + profiles
    var FINISH = {
      oak:              { out:"#cda86f", mid:"#9b7a4d", inn:"#bb976a", hi:"#e6cd9d", grain:"rgba(70,44,16,.13)" },
      black:            { out:"#33302d", mid:"#121110", inn:"#262321", hi:"#4d4945", grain:"rgba(255,255,255,.05)" },
      white:            { out:"#f3efe9", mid:"#dad4ca", inn:"#eae5dd", hi:"#ffffff", grain:"rgba(0,0,0,.035)" },
      gold:             { out:"#d9b978", mid:"#b8934e", inn:"#c9a45c", hi:"#e8d09a", grain:"rgba(90,60,10,.10)" },
      silver:           { out:"#d8dbde", mid:"#aeb4b9", inn:"#c4c8cc", hi:"#eceef0", grain:"rgba(0,0,0,.04)" },
      bronze:           { out:"#b08d5b", mid:"#7c5c34", inn:"#997745", hi:"#caa870", grain:"rgba(60,30,8,.12)" },
      natural:          { out:"#e6d6bc", mid:"#cbb68e", inn:"#d9c7a5", hi:"#f2eadb", grain:"rgba(70,44,16,.10)" },
      "antique-gold":   { out:"#c7a867", mid:"#93753f", inn:"#b0924e", hi:"#d9c080", grain:"rgba(80,50,10,.10)" },
      "antique-silver": { out:"#c4c3bc", mid:"#98968c", inn:"#b0aea6", hi:"#d6d5d0", grain:"rgba(0,0,0,.05)" },
      "black-pewter":   { out:"#3a3a3e", mid:"#1a1a1c", inn:"#2a2a2e", hi:"#9a9ea1", grain:"rgba(255,255,255,.05)" },
      "terracotta-silver": { out:"#c47852", mid:"#b5673f", inn:"#a05535", hi:"#c9ccce", grain:"rgba(80,40,10,.10)" },
      "white-silver":   { out:"#f0ede7", mid:"#e0dbd2", inn:"#ece8e0", hi:"#cfd2d5", grain:"rgba(0,0,0,.04)" }
    };
    function typeKey(v){ v=(v||"").toLowerCase(); if(v.indexOf("swoop")>-1)return "swoop"; if(v.indexOf("venice")>-1)return "venice"; if(v.indexOf("wide")>-1||v.indexOf("box")>-1||v.indexOf("deep")>-1)return "widebox"; return "standard"; }
    function railBg(tk, fk, side){
      var f = FINISH[fk] || FINISH.black;
      var dir = side==="t" ? "to bottom" : side==="b" ? "to top" : side==="l" ? "to right" : "to left";
      var prof;
      if(tk==="standard") prof = "linear-gradient("+dir+","+f.out+","+f.mid+" 58%,"+f.inn+")";
      else if(tk==="swoop") prof = "linear-gradient("+dir+","+f.out+" 0%,"+f.hi+" 9%,"+f.mid+" 50%,"+f.out+" 91%,"+f.inn+")";
      else if(tk==="venice") prof = "linear-gradient("+dir+","+f.out+" 0%,"+f.hi+" 12%,"+f.mid+" 45%,"+f.out+" 88%,"+f.inn+")";
      else prof = "linear-gradient("+dir+","+f.hi+" 0%,"+f.out+" 15%,"+f.mid+" 36%,"+f.mid+" 84%,"+f.inn+")";
      var gd = (side==="t"||side==="b") ? "90deg" : "0deg";
      var grain = "repeating-linear-gradient("+gd+",transparent 0 2px,"+f.grain+" 2px 2.7px,transparent 2.7px 5.4px)";
      return grain + "," + prof;
    }
    function finishBg(fk){
      var f = FINISH[fk] || FINISH.black;
      return "radial-gradient(130% 100% at 30% 20%,"+f.hi+"55,transparent 60%),"
        + "repeating-linear-gradient(8deg,transparent 0 3px,"+f.grain+" 3px 4px,transparent 4px 7px),"
        + "linear-gradient(135deg,"+f.out+","+f.mid+")";
    }
    var fpSwatch = root.querySelector("[data-fp-swatch]");
    var fpLoupe = root.querySelector("[data-fp-loupe]");
    var fpName = root.querySelector("[data-fp-name]");
    var selectionSummary = root.querySelector("[data-selection-summary]");
    var fpFinishUrls = {};
    try { fpFinishUrls = JSON.parse((fpSwatch || {}).dataset.finishUrls || "{}"); } catch(e) {}

    var selected = {};
    var seedVariant = product.selected_or_first_available_variant || (product.variants && product.variants[0]);
    if (seedVariant && seedVariant.options) {
      seedVariant.options.forEach(function (optVal, i) {
        if (optVal != null) selected[String(i + 1)] = optVal;
      });
    }
    // initialise from currently-pressed option buttons
    root.querySelectorAll("[data-option-index]").forEach(function (group) {
      var idx = group.getAttribute("data-option-index");
      var pressed = group.querySelector('[aria-pressed="true"]');
      if (pressed) selected[idx] = pressed.getAttribute("data-value");
    });

    function currentVariant() {
      if (!product.options || (product.options.length === 1 && /^title$/i.test(product.options[0]))) {
        return product.variants[0];
      }
      return product.variants.find(function (v) {
        return product.options.every(function (opt, i) {
          return v.options[i] === selected[String(i + 1)];
        });
      });
    }

    function looksLike(name, words) {
      name = (name || "").toLowerCase();
      return words.some(function (w) { return name.indexOf(w) > -1; });
    }

    function isFrameStyleVariantValue(val) {
      var v = String(val || "").toLowerCase();
      return /classic|swoop|venice|deep|standard|wide\s*box|widebox|vintage|cushion|\bbox\b/.test(v);
    }

    function frameStyleOptionIndex() {
      var idx = -1;
      (product.options || []).forEach(function (name, i) {
        if (!looksLike(name, ["frame"])) return;
        var hasStyle = (product.variants || []).some(function (variant) {
          return isFrameStyleVariantValue(variant.options[i]);
        });
        if (hasStyle) idx = i;
      });
      return idx;
    }

    function syncFrameStyleVariant(styleValue) {
      var idx = frameStyleOptionIndex();
      if (idx < 0 || !styleValue) return;
      selected[String(idx + 1)] = styleValue;
    }

    // Frame style lives on presentational tiles, not data-option-index.
    // Overlay the pressed default so ?variant= cannot keep the old style.
    var pressedStyleTile = root.querySelector('[data-pp-type="frametype"][aria-pressed="true"]');
    if (pressedStyleTile) syncFrameStyleVariant(pressedStyleTile.getAttribute("data-value"));

    function controlValue(type) {
      // Frame style tiles are presentational (not data-option-index). Prefer the
      // pressed button so Set as default saves the look on screen, not the
      // ?variant= seed which is often the previous Classic/first available.
      var pressed = controlQuery('[data-pp-type="' + type + '"][aria-pressed="true"]');
      if (pressed) return pressed.getAttribute("data-value");
      var val = null;
      (product.options || []).forEach(function (optName, i) {
        var ln = (optName || "").toLowerCase();
        var sel = selected[String(i + 1)];
        if (type === "frame" && ln.indexOf("frame") > -1 && sel && !isFrameStyleVariantValue(sel)) val = sel;
        if (type === "frametype" && ln.indexOf("frame") > -1 && sel && isFrameStyleVariantValue(sel)) val = sel;
        if (type === "mount" && ln.indexOf("mount") > -1) val = sel;
        if (type === "size" && (ln.indexOf("size") > -1 || ln.indexOf("dimension") > -1)) val = sel;
      });
      if (val) return val;
      var attrs = { frametype: "initialFrame", frame: "initialColour", size: "initialSize", mount: "initialMount" };
      return attrs[type] ? visualiser.dataset[attrs[type]] : null;
    }

    var CSS_COLOURS = ["None","Oak","Black","White"];
    var MOUNT_COLOURS = {
      white: "#FFFFFF",
      "snow white": "#EDF0F0",
      "fresh linen": "#EEE9E3",
      "warm sand": "#E8DABF",
      "french grey": "#C3BCA8",
      olive: "#7E7661",
      black: "#2D2824",
      // legacy aliases from older shares / favourites
      snow: "#EDF0F0",
      ivory: "#EEE9E3",
      stone: "#C3BCA8",
      charcoal: "#2D2824",
      sage: "#7E7661",
      clay: "#E8DABF"
    };
    var PHOTO_COLOURS = {
      swoop:   ["White","Black","Gold","Silver"],
      classic: ["Oak","Black","White","Gold","Silver","Bronze","Natural","Antique Gold","Antique Silver"],
      venice:  ["Silver","Black and Pewter","Terracotta and Silver","White and Silver"]
    };
    var SWOOP_PHOTO_KEYS  = { white:1, black:1, gold:1, silver:1 };
    var CLASSIC_PHOTO_KEYS = { oak:1, black:1, white:1, gold:1, silver:1, bronze:1, natural:1, "antique-gold":1, "antique-silver":1 };
    var CLASSIC_RAIL_PHOTO_KEYS = { oak:1, black:1, white:1, gold:1, silver:1, bronze:1, natural:1, "antique-gold":1, "antique-silver":1 };
    var DEEP_CLASSIC_RAIL_PHOTO_KEYS = { oak:1, black:1, white:1, gold:1, silver:1, bronze:1, natural:1, "antique-gold":1, "antique-silver":1 };
    var VENICE_PHOTO_KEYS = { silver:1, "black-pewter":1, "terracotta-silver":1, "white-silver":1 };
    // Colour is remembered per style so switching Classic → Deep Classic does not
    // carry Silver (etc.) onto a style that was still on its own finish.
    var FRAME_COLOUR_DEFAULTS = { standard: "Oak", widebox: "Oak", swoop: "Black", venice: "Silver" };
    var frameColourByStyle = {
      standard: FRAME_COLOUR_DEFAULTS.standard,
      widebox: FRAME_COLOUR_DEFAULTS.widebox,
      swoop: FRAME_COLOUR_DEFAULTS.swoop,
      venice: FRAME_COLOUR_DEFAULTS.venice
    };

    function colourForStyle(ftype) {
      var key = ftype || "standard";
      return frameColourByStyle[key] || FRAME_COLOUR_DEFAULTS[key] || "Oak";
    }

    function rememberFrameColour(ftype, colour) {
      if (!ftype || !colour) return;
      frameColourByStyle[ftype] = colour;
    }

    function setFrameColourUi(colour) {
      if (!colour) return;
      controlQueryAll('[data-pp-type="frame"]').forEach(function (sw) {
        sw.setAttribute("aria-pressed", sw.getAttribute("data-value") === colour ? "true" : "false");
      });
      var input = controlQuery('[data-pp-input="frame"]');
      if (input) input.value = colour;
      setControlTexts('[data-pp-val="frame"]', colour);
    }

    function getRenderModes() {
      var w = root.querySelector("[data-swoop-render]");
      return {
        swoop:   w ? w.getAttribute("data-swoop-render") : "css",
        classic: w ? w.getAttribute("data-classic-render") : "css",
        venice:  w ? w.getAttribute("data-venice-render") : "css"
      };
    }

    function stylePhotoFamily(chip) {
      if (chip === "swoop") return "swoop";
      if (chip === "venice") return "venice";
      if (chip === "widebox") return "deep-classic";
      return "classic";
    }

    var PROFILE_COLOUR_KEYS = {
      oak: 1, black: 1, white: 1, gold: 1, silver: 1, bronze: 1, natural: 1,
      "antique-gold": 1, "antique-silver": 1
    };
    var VENICE_PROFILE_KEYS = {
      silver: 1,
      "black-pewter": 1,
      "terracotta-silver": 1,
      "white-silver": 1
    };

    function profileColourKey(val, family) {
      var k = colourKey(val);
      if (family === "venice") {
        if (VENICE_PROFILE_KEYS[k]) return k;
        if (k === "black") return "black-pewter";
        if (k === "white") return "white-silver";
        if (k === "bronze" || k === "terracotta") return "terracotta-silver";
        return "silver";
      }
      if (k === "black-pewter") return "black";
      if (k === "terracotta-silver") return "bronze";
      if (k === "white-silver") return "white";
      return PROFILE_COLOUR_KEYS[k] ? k : "oak";
    }

    function styleProfileLabel(family) {
      if (family === "deep-classic") return "Deep Classic";
      if (family === "swoop") return "Swoop";
      if (family === "venice") return "Venice";
      return "Classic";
    }

    function frameProfileFilename(profile) {
      // Deep Classic / Swoop / Venice photo profiles ship under -r2 to bust CDN cache.
      if (profile.indexOf("deep-classic-") === 0) return "frame-profile-" + profile + "-r2.png";
      if (/^swoop-(white|black|gold|silver)$/.test(profile)) return "frame-profile-" + profile + "-r2.png";
      if (/^venice-(silver|black-pewter|terracotta-silver|white-silver)$/.test(profile)) {
        return "frame-profile-" + profile + "-r2.png";
      }
      return "frame-profile-" + profile + ".png";
    }

    function syncFrameStylePreviews(frameVal) {
      // Only the selected style tile follows the active frame colour.
      // Other styles stay on their default profile.
      var colour = frameVal || controlValue("frame") || "Oak";
      var frameNone = !colour || /no frame|none|unframed/i.test(colour);
      var colourLabel = frameNone ? "Oak" : colour;
      root.querySelectorAll(".frame-style-swatch").forEach(function (swatch) {
        var el = swatch.querySelector(".frame-style-preview");
        if (!el) return;
        var family = el.getAttribute("data-profile-family") || stylePhotoFamily(el.getAttribute("data-chip"));
        var isActive = swatch.getAttribute("aria-pressed") === "true";
        var fallbackKey = family === "swoop" ? "black" : family === "venice" ? "silver" : "oak";
        var fkey = frameNone ? fallbackKey : profileColourKey(colour, family);
        var profile = isActive
          ? family + "-" + fkey
          : (el.getAttribute("data-default-profile") || family + "-" + fallbackKey);
        if (family === "swoop" && !/^swoop-(white|black|gold|silver)$/.test(profile)) {
          profile = "swoop-black";
        }
        if (family === "venice" && !/^venice-(silver|black-pewter|terracotta-silver|white-silver)$/.test(profile)) {
          profile = "venice-silver";
        }
        var label;
        if (!isActive) {
          label = family === "swoop" ? "Black" : family === "venice" ? "Silver" : "Oak";
        } else if (frameNone) {
          label = family === "swoop" ? "Black" : family === "venice" ? "Silver" : "Oak";
        } else {
          label = colourLabel;
        }
        el.setAttribute("data-profile", profile);
        var img = el.querySelector(".frame-style-profile");
        if (!img) return;
        swapFrameStyleProfile(img, frameProfileFilename(profile), styleProfileLabel(family) + " frame profile — " + label);
      });
    }

    function syncFrameColourFinishFamily(ftype) {
      var family = ftype === "widebox" ? "deep-classic" : ftype === "standard" ? "classic" : "";
      controlQueryAll('[data-pp-group="frame"]').forEach(function (group) {
        if (family) group.setAttribute("data-frame-finish-family", family);
        else group.removeAttribute("data-frame-finish-family");
      });
    }

    function filterColourSwatches() {
      var ftype = typeKey(controlValue("frametype"));
      var modes = getRenderModes();
      var activeList;
      if (ftype === "swoop" && modes.swoop === "photo") activeList = PHOTO_COLOURS.swoop;
      else if ((ftype === "standard" || ftype === "widebox") && modes.classic === "photo") activeList = PHOTO_COLOURS.classic;
      else if (ftype === "venice" && modes.venice === "photo") activeList = PHOTO_COLOURS.venice;
      else activeList = CSS_COLOURS;
      syncFrameColourFinishFamily(ftype);

      var swatches = controlQueryAll('[data-pp-type="frame"]');
      var currentVal = controlValue("frame");
      var currentValid = false;
      var styleDefault = FRAME_COLOUR_DEFAULTS[ftype] || "Oak";
      var defaultSwatch = null;
      var firstValid = null;
      swatches.forEach(function (sw) {
        var val = sw.getAttribute("data-value");
        var allowed = activeList.indexOf(val) > -1;
        sw.hidden = !allowed;
        if (allowed && !firstValid) firstValid = sw;
        if (allowed && val === styleDefault) defaultSwatch = sw;
        if (allowed && val === currentVal) currentValid = true;
      });
      // Keep the current colour across style changes whenever it is still offered.
      if (!currentValid) {
        var fallbackSwatch = defaultSwatch || firstValid;
        if (fallbackSwatch) {
          var newVal = fallbackSwatch.getAttribute("data-value");
          setFrameColourUi(newVal);
          rememberFrameColour(ftype, newVal);
        }
      } else if (currentVal) {
        rememberFrameColour(ftype, currentVal);
      }
    }

    function scheduleMultiPanelSlices(multiSpec) {
      if (!multiSpec) return;
      var url = "";
      if (currentArtwork && currentArtwork.image) url = currentArtwork.image;
      var stages = visualiser.querySelectorAll("[data-stage]");
      if (!stages.length) return;

      function paintStage(stageEl, size) {
        if (!size) return;
        var slices = stageEl.querySelectorAll(".tri-slice, .dip-slice");
        if (!slices.length) return;
        var first = slices[0];
        var panelPxW = first.clientWidth || first.offsetWidth;
        var panelPxH = first.clientHeight || first.offsetHeight;
        if (!panelPxW || !panelPxH) return;
        var layout = multiPanelSliceLayout(multiSpec, panelPxW, panelPxH, size.w, size.h);
        Array.prototype.forEach.call(slices, function (piece, index) {
          var slice = layout[index];
          if (!slice) return;
          piece.style.backgroundRepeat = "no-repeat";
          piece.style.backgroundSize = slice.size;
          piece.style.backgroundPosition = slice.position;
        });
      }

      stages.forEach(function (stageEl) {
        var slices = stageEl.querySelectorAll(".tri-slice, .dip-slice");
        if (!slices.length) return;
        var stageUrl = url || extractBgImageUrl(slices[0].style.backgroundImage);
        if (!stageUrl) return;
        loadImageSize(stageUrl, function (size) {
          requestAnimationFrame(function () {
            paintStage(stageEl, size);
            requestAnimationFrame(function () { paintStage(stageEl, size); });
          });
        });
      });
    }

    var multiPanelResizeTimer = null;
    function observeMultiPanelResize(multiSpec) {
      if (!window.ResizeObserver || !multiSpec) return;
      if (!visualiser._multiPanelRO) {
        visualiser._multiPanelRO = new ResizeObserver(function () {
          clearTimeout(multiPanelResizeTimer);
          multiPanelResizeTimer = setTimeout(function () {
            var layout = selectedLayout();
            if (isMultiPanelLayout(layout)) scheduleMultiPanelSlices(MULTI_PANEL_SPECS[layout]);
          }, 50);
        });
      }
      visualiser._multiPanelRO.disconnect();
      visualiser.querySelectorAll("[data-stage]").forEach(function (stageEl) {
        var first = stageEl.querySelector(".tri-slice, .dip-slice");
        if (first) visualiser._multiPanelRO.observe(first);
      });
    }

    function updatePreview() {
      filterColourSwatches();
      syncPanelLayout();
      updateSizeControlLabels();
      var frameVal = controlValue("frame");
      syncFrameStylePreviews(frameVal);
      var frameNone = !frameVal || /no frame|none|unframed/i.test(frameVal);
      var frameKey = colourKey(frameVal);
      var ftype = typeKey(controlValue("frametype"));
      var fkey = (FINISH[frameKey]) ? frameKey : "black";
      var szv = controlValue("size");
      var tier = sizeKey(szv);
      var mountVal = controlValue("mount");
      var mounted = mountVal && !/no mount|none|unmounted/i.test(mountVal);
      var shape = selectedDimensionShape();
      var layout = selectedLayout();
      var multiSpec = isMultiPanelLayout(layout) ? MULTI_PANEL_SPECS[layout] : null;
      var hasSizeOpt = productHasSizeOption();
      var sizeCm = multiSpec
        ? multiSpec.panel
        : ((hasSizeOpt || !isProductPage) ? printSizeCm(shape, tier, szv) : null);
      if (!multiSpec && sizeCm && !frameNone && !mounted) {
        var noMountOuter = rosenstielsFinishedSize(szv);
        if (noMountOuter) sizeCm = noMountOuter;
      }
      var stages = visualiser.querySelectorAll("[data-stage]");
      var dimsByStage = typeof WeakMap === "function" ? new WeakMap() : null;
      var lastDims = { frameW: 0, mountW: 0 };

      function applyStageDimensions(stageEl) {
        var wrap = stageEl.querySelector("[data-framewrap]");
        var inRoom = stageEl.classList.contains("room");
        var frameW = 0;
        var mountW = 0;

        if (sizeCm && wrap) {
          var stageStyle = window.getComputedStyle(stageEl);
          var padX = (parseFloat(stageStyle.paddingLeft) || 0) + (parseFloat(stageStyle.paddingRight) || 0);
          var padY = (parseFloat(stageStyle.paddingTop) || 0) + (parseFloat(stageStyle.paddingBottom) || 0);
          var stageWidth = Math.max(1, (stageEl.clientWidth || 600) - padX);
          var stageHeight = Math.max(1, (stageEl.clientHeight || stageEl.clientWidth || 600) - padY);
          var frameCm = frameNone ? 0 : FRAME_WIDTH_CM[ftype];
          // Catalogue size chips are OUTER finished dimensions. On most editions
          // the mount toggle only changes the print aperture. Rosenstiels
          // no-mount uses a different finished size (sizeCm already swapped).
          var mountSpecCm = multiSpec ? multiSpec.mountCm : singleMountCm(tier, sizeCm.w);
          var mountCm = mounted ? mountSpecCm : 0;
          var outer;
          var printCm;
          if (multiSpec) {
            // panel.w/h are the outer panel. The print sits inside the frame and mount.
            outer = multiPanelOuterCm(multiSpec, frameCm, mountSpecCm);
            var multiInset = 2 * (frameCm + mountCm);
            printCm = {
              w: Math.max(1, sizeCm.w - multiInset),
              h: Math.max(1, sizeCm.h - multiInset)
            };
          } else if (frameNone) {
            outer = { w: sizeCm.w, h: sizeCm.h };
            printCm = { w: sizeCm.w, h: sizeCm.h };
          } else {
            outer = { w: sizeCm.w, h: sizeCm.h };
            var inset = 2 * (frameCm + mountCm);
            printCm = {
              w: Math.max(1, sizeCm.w - inset),
              h: Math.max(1, sizeCm.h - inset)
            };
          }
          var pxPerCm;

          if (inRoom) {
            // One centimetre on the wall is stageWidth / the scene's real width.
            // The room name only chooses which wall; Discover uses the same ratio.
            var room = stageEl.getAttribute("data-room") || "lounge";
            var wallCm = ROOM_WALL_CM[room] || ROOM_WALL_CM.yours;
            stageEl.setAttribute("data-room-wall-cm", String(wallCm));
            wallCm = Number(stageEl.getAttribute("data-room-wall-cm")) || 320;
            pxPerCm = stageWidth / wallCm;
          } else {
            // Artwork view normalises the complete assembly to one generous target
            // while frame and mount widths remain exact proportions of the cm spec.
            // Multi-panel sets already fill the stage well; single hangs sit small
            // in the square PDP preview — scale those up only. Rooms unchanged.
            var artworkFit = multiSpec ? 0.94 : (isProductPage ? 0.90 : 0.78);
            var requestedFit = parseFloat(visualiser.getAttribute("data-artwork-fit") || "");
            if (requestedFit > 0 && requestedFit <= 1) artworkFit = requestedFit;
            // Each size fills the preview on its own, the way portrait, square and
            // landscape do. 45×100 and 55×120 stay the same width; only the frame
            // and mount change thickness. The room view still uses real centimetres.
            var refW = outer.w;
            var refH = outer.h;
            var heroSlide = stageEl.closest(".hero-plate-slide");
            if (heroSlide && refW > 0) {
              // Homepage plate fills the column width. The stack follows this
              // frame so a taller portrait is not letterboxed beside the label.
              pxPerCm = stageWidth * artworkFit / refW;
              var heroStack = heroSlide.closest(".hero-plate-stack");
              if (heroStack && heroSlide.classList.contains("is-active") && refH > 0) {
                var ratioKey = refW + "/" + refH;
                if (heroStack.getAttribute("data-hero-ratio") !== ratioKey) {
                  heroStack.setAttribute("data-hero-ratio", ratioKey);
                  heroStack.style.aspectRatio = refW + " / " + refH;
                }
              }
            } else {
              pxPerCm = Math.min(
                stageWidth * artworkFit / refW,
                stageHeight * artworkFit / refH
              );
            }
          }

          frameW = frameCm * pxPerCm;
          mountW = mountCm * pxPerCm;
          // The room fallback is a percentage width (landscape 52% ≈ a triptych).
          // Width transitions, so the first paint would keep that box until the
          // animation finished. Snap the first spec size, then allow later changes
          // to animate from one centimetre size to the next.
          var snapSize = !wrap.style.width;
          if (snapSize) wrap.style.transition = "none";
          // Lock both axes from the cm spec so stage CSS (max-height / flex) cannot
          // squash squarer sizes (e.g. landscape Large 80×60) relative to XL 100×70.
          stageEl.setAttribute("data-dimension-mode", "spec");
          wrap.style.width = (outer.w * pxPerCm) + "px";
          wrap.style.height = (outer.h * pxPerCm) + "px";
          wrap.style.minWidth = wrap.style.width;
          wrap.style.minHeight = wrap.style.height;
          wrap.style.flexGrow = "0";
          wrap.style.flexShrink = "0";
          wrap.style.flexBasis = "auto";
          wrap.style.alignSelf = "center";
          wrap.style.maxHeight = "none";
          wrap.style.maxWidth = "none";
          if (snapSize) {
            void wrap.offsetWidth;
            wrap.style.transition = "";
          }
          wrap.style.setProperty("--fv-s", frameShadowScale(outer.w * pxPerCm));
          syncFrameShadowScale(wrap);
          ensureFrameShadowScaleObserver(wrap);
          stageEl.setAttribute("data-dimension-mode", "spec");
          stageEl.style.removeProperty("--room-size-scale");
          stageEl.querySelectorAll("[data-piece]").forEach(function (piece) {
            // Multi-panel slices fill the mount aperture; aspect-ratio is driven by
            // the frame box so No mount cannot overflow the rails.
            if (multiSpec || piece.classList.contains("tri-slice") || piece.classList.contains("dip-slice")) {
              piece.style.aspectRatio = "auto";
            } else {
              piece.style.aspectRatio = printCm.w + " / " + printCm.h;
            }
          });
          var panelSet = stageEl.querySelector(".triptych, .diptych");
          if (panelSet && multiSpec) {
            panelSet.style.setProperty("--panel-gap", (multiSpec.gapCm * pxPerCm) + "px");
            panelSet.style.width = "100%";
            panelSet.style.height = "100%";
            Array.prototype.forEach.call(panelSet.querySelectorAll("[data-frame]"), function (panelFrame) {
              panelFrame.removeAttribute("data-panel-edge");
              panelFrame.style.removeProperty("flex");
              panelFrame.style.removeProperty("flex-grow");
              panelFrame.style.removeProperty("flex-shrink");
              panelFrame.style.removeProperty("flex-basis");
              panelFrame.style.removeProperty("width");
              panelFrame.style.removeProperty("max-width");
              panelFrame.style.removeProperty("min-width");
            });
          }
        } else if (!isProductPage) {
          var legacy = LEGACY_SPECIAL_DIMENSIONS;
          var legacyTier = tier === "extralarge" ? "large" : tier;
          var borderCmLegacy = legacy.mountCm + legacy.mouldCm;
          var roomScale = (legacy.printLongCm[legacyTier] + 2 * borderCmLegacy) /
            (legacy.printLongCm.large + 2 * borderCmLegacy);
          var sizeMult = legacyTier === "small" ? 1.41 : legacyTier === "large" ? 0.71 : 1;

          stageEl.setAttribute("data-dimension-mode", "legacy");
          stageEl.style.setProperty("--room-size-scale", roomScale);
          if (wrap) {
            wrap.style.removeProperty("width");
            wrap.style.removeProperty("height");
            wrap.style.removeProperty("max-height");
            wrap.style.removeProperty("--fv-s");
            wrap.style.removeProperty("--fv-s-fit");
          }
          stageEl.querySelectorAll("[data-piece]").forEach(function (piece) {
            piece.style.removeProperty("aspect-ratio");
            if (piece.classList.contains("tri-slice") || piece.classList.contains("dip-slice")) {
              piece.style.removeProperty("background-size");
              piece.style.removeProperty("background-position");
            }
          });
          var legacySet = stageEl.querySelector(".triptych, .diptych");
          if (legacySet) {
            legacySet.style.removeProperty("--panel-gap");
            Array.prototype.forEach.call(legacySet.querySelectorAll("[data-frame]"), function (panelFrame) {
              panelFrame.style.removeProperty("flex");
              panelFrame.style.removeProperty("flex-grow");
              panelFrame.style.removeProperty("flex-shrink");
              panelFrame.style.removeProperty("flex-basis");
              panelFrame.style.removeProperty("width");
              panelFrame.style.removeProperty("max-width");
              panelFrame.style.removeProperty("min-width");
            });
          }

          if (inRoom) {
            frameW = Math.max(4, Math.round(legacy.framePx[ftype] * roomScale));
            mountW = Math.max(4, Math.round(legacy.roomMountPx * roomScale));
          } else {
            frameW = Math.round(legacy.framePx[ftype] * sizeMult);
            mountW = Math.round(legacy.artworkMountPx * sizeMult);
          }
        } else {
          // No Size option: do not invent A4/A3/A2 or either print ladder.
          stageEl.setAttribute("data-dimension-mode", "unspecified");
          stageEl.style.removeProperty("--room-size-scale");
          if (wrap) {
            wrap.style.removeProperty("width");
            wrap.style.removeProperty("height");
            wrap.style.removeProperty("max-height");
            wrap.style.removeProperty("--fv-s");
            wrap.style.removeProperty("--fv-s-fit");
          }
          stageEl.querySelectorAll("[data-piece]").forEach(function (piece) {
            piece.style.removeProperty("aspect-ratio");
          });
          var unspecStyle = window.getComputedStyle(stageEl);
          var unspecPadX = (parseFloat(unspecStyle.paddingLeft) || 0) + (parseFloat(unspecStyle.paddingRight) || 0);
          var unspecPadY = (parseFloat(unspecStyle.paddingTop) || 0) + (parseFloat(unspecStyle.paddingBottom) || 0);
          var unspecW = Math.max(1, (stageEl.clientWidth || 600) - unspecPadX);
          var unspecH = Math.max(1, (stageEl.clientHeight || stageEl.clientWidth || 600) - unspecPadY);
          var unspecEdge = Math.min(unspecW, unspecH);
          mountW = (mounted && !frameNone) ? Math.max(10, Math.round(unspecEdge * 0.04)) : 0;
          if (!frameNone) {
            frameW = Math.max(8, Math.round(unspecEdge * 0.025));
          }
        }

        lastDims = { frameW: frameW, mountW: mountW };
        if (dimsByStage) dimsByStage.set(stageEl, lastDims);
        return lastDims;
      }

      Array.prototype.forEach.call(stages, applyStageDimensions);

      function dimsFor(el) {
        var host = el && el.closest ? el.closest("[data-stage]") : null;
        if (host && dimsByStage) {
          var found = dimsByStage.get(host);
          if (found) return found;
        }
        return lastDims;
      }

      var modes = getRenderModes();
      var photoPlan = frameNone ? null : frameRailPhotoPlan(ftype, fkey, modes);
      if (photoPlan) {
        frameRailFilenames(photoPlan.prefix, photoPlan.key).forEach(prefetchFrameAsset);
      }

      frameEls.forEach(function (frameEl) {
        if (frameNone) {
          frameEl.classList.add("none");
          clearFramePhotoAttrs(frameEl);
          frameEl.querySelectorAll("[data-rail]").forEach(function (r) { r.style.backgroundImage = ""; });
          frameEl.style.setProperty("--frame-w", "0px");
          ["t", "r", "b", "l"].forEach(function (side) {
            frameEl.style.removeProperty("--frame-" + side);
          });
          return;
        }

        frameEl.classList.remove("none");
        frameEl.removeAttribute("data-panel-edge");
        frameEl.style.setProperty("--frame-w", dimsFor(frameEl).frameW + "px");
        ["t", "r", "b", "l"].forEach(function (side) {
          frameEl.style.removeProperty("--frame-" + side);
        });

        var applyToken = (frameEl._railApplyToken || 0) + 1;
        frameEl._railApplyToken = applyToken;
        var nextBg = frameColours[frameKey] || "#1B1A18";

        if (photoPlan) {
          whenFrameAssetsReady(frameRailFilenames(photoPlan.prefix, photoPlan.key), function () {
            if (frameEl._railApplyToken !== applyToken) return;
            frameEl.style.setProperty("--frame-bg", nextBg);
            applyFramePhotoAttrs(frameEl, photoPlan);
          });
        } else {
          frameEl.style.setProperty("--frame-bg", nextBg);
          clearFramePhotoAttrs(frameEl);
          ["t", "r", "b", "l"].forEach(function (s) {
            var rail = frameEl.querySelector('[data-rail="' + s + '"]');
            if (rail) rail.style.backgroundImage = railBg(ftype, fkey, s);
          });
        }
      });

      if (fpSwatch) {
        var photoStyle = ftype === "swoop" ? "swoop"
          : ftype === "standard" ? "classic"
          : ftype === "widebox" ? "deep-classic"
          : ftype === "venice" ? "venice"
          : null;
        var photoKeys = (ftype === "swoop") ? SWOOP_PHOTO_KEYS
          : (ftype === "standard" || ftype === "widebox") ? CLASSIC_PHOTO_KEYS
          : ftype === "venice" ? VENICE_PHOTO_KEYS
          : {};
        var modes = getRenderModes();
        var photoMode = (ftype === "swoop" && modes.swoop === "photo")
          || ((ftype === "standard" || ftype === "widebox") && modes.classic === "photo")
          || (ftype === "venice" && modes.venice === "photo");
        var finishKey = photoStyle ? photoStyle + "-" + fkey : "";
        if (photoMode && photoStyle && photoKeys[fkey] && !frameNone) {
          fpSwatch.setAttribute("data-finish", finishKey);
          fpSwatch.style.backgroundImage = "";
        } else {
          fpSwatch.removeAttribute("data-finish");
          fpSwatch.style.backgroundImage = finishBg(fkey);
        }
      }
      var frameStyleName = controlValue("frametype") || "Classic";
      var finishPreviewName = frameNone
        ? "No frame selected"
        : "Close-up: " + frameStyleName + " " + (frameVal || "Oak");
      if (selectionSummary) {
        var sizeSummary = szv || "Medium";
        if (multiSpec) {
          sizeSummary = (layout === "triptych" ? "Triptych" : "Diptych") + " (" + dimensionLabel(multiSpec.overall) + ")";
        }
        var nextSelectionSummary = [frameStyleName, frameVal || "No frame"];
        if (sizeCm || multiSpec) {
          nextSelectionSummary.push(sizeSummary, mountVal || "No mount");
        }
        nextSelectionSummary = nextSelectionSummary.join(" · ");
        if (selectionSummary.textContent.trim() !== nextSelectionSummary) {
          selectionSummary.textContent = nextSelectionSummary;
        }
      }
      if (fpName) fpName.textContent = finishPreviewName;
      if (fpSwatch) {
        fpSwatch.setAttribute(
          "aria-label",
          frameNone
            ? "Finish preview unavailable because no frame is selected"
            : "Magnified preview of " + frameStyleName + " " + (frameVal || "Oak") + " finish"
        );
      }
      mountEls.forEach(function (mountEl) {
        var mountPx = mounted ? dimsFor(mountEl).mountW : 0;
        if (mounted) {
          mountEl.classList.remove("off");
        } else {
          mountEl.classList.add("off");
        }
        mountEl.style.setProperty("--mount-w", mountPx + "px");
        ["t", "r", "b", "l"].forEach(function (side) {
          mountEl.style.removeProperty("--mount-" + side);
        });
      });
      if (mountColourOpt) {
        mountColourOpt.hidden = !mounted;
        mountColourOpt.style.opacity = "";
        mountColourOpt.querySelectorAll(".swatch").forEach(function (s) { s.disabled = !mounted; });
      }
      root.querySelectorAll('[data-dock-jump="opt-mount-colour"]').forEach(function (pill) {
        pill.hidden = !mounted;
      });
      var mc = controlQuery('[data-mount-colour] [aria-pressed="true"]');
      var mountColourName = (mc && mc.getAttribute("data-name")) || visualiser.dataset.initialMountColour || "White";
      var mcb = mc
        ? (mc.getAttribute("data-colour") || "#EEE9E3")
        : (MOUNT_COLOURS[String(mountColourName).toLowerCase()] || "#EEE9E3");
      var mcInput = controlQuery("[data-mount-colour-input]");
      if (mcInput) {
        mcInput.disabled = !mounted;
        mcInput.value = mounted ? mountColourName : "";
      }
      if (mountColourOpt) {
        mountColourOpt.setAttribute("data-mount-name", mounted ? mountColourName : "");
        mountColourOpt.setAttribute("data-mount-color", mounted ? mcb : "");
      }
      mountEls.forEach(function (mountEl) { mountEl.style.setProperty("--mount-bg", mcb); });
      // Slice only after frame + mount padding have sized the print apertures.
      if (multiSpec) {
        scheduleMultiPanelSlices(multiSpec);
        observeMultiPanelResize(multiSpec);
      }
      syncMountSwitchUi();
      updateSpecPanel();
    }

    function formatSpecCm(w, h) {
      function round(n) {
        return Math.round(Number(n) * 10) / 10;
      }
      return round(w) + " × " + round(h) + " cm";
    }

    function orientationFromPrintCm(printCm) {
      var max = Math.max(Number(printCm.w) || 0, Number(printCm.h) || 0);
      if (!max) return "";
      if (Math.abs(printCm.w - printCm.h) / max <= 0.08) return "Square";
      return printCm.w > printCm.h ? "Landscape" : "Portrait";
    }

    function framedSpecLabel(outerW, outerH, multiSpec, layout) {
      var label = "≈ " + formatSpecCm(outerW, outerH);
      if (!multiSpec) return label;
      return label + (layout === "diptych" ? " across both panels" : " across all panels");
    }

    function artworkSpecLabel(printCm, multiSpec, layout) {
      var panel = formatSpecCm(printCm.w, printCm.h);
      if (!multiSpec || !multiSpec.overall) return panel;
      var hung = formatSpecCm(multiSpec.overall.w, multiSpec.overall.h);
      if (layout === "diptych") return panel + " per panel · " + hung + " hung with a 5 cm gap";
      return panel + " per panel · " + hung + " hung with 5 cm gaps";
    }

    function specLiveRoot() {
      return root.querySelector("[data-spec-live]") || document.querySelector("[data-spec-live]");
    }

    function setSpecRow(name, text, hide) {
      var live = specLiveRoot();
      var row = live ? live.querySelector('[data-spec="' + name + '"]') : null;
      if (!row) return;
      if (hide) {
        row.setAttribute("hidden", "hidden");
      } else {
        row.removeAttribute("hidden");
      }
      var dd = row.querySelector("[data-spec-value]");
      if (dd && text != null) dd.textContent = text;
    }

    function notifySpecUpdated() {
      try {
        document.dispatchEvent(new CustomEvent("artfolio:spec-updated"));
      } catch (err) {}
    }

    function updateSpecPanel() {
      if (!specLiveRoot()) return;
      var frameVal = controlValue("frame");
      var frameNone = !frameVal || /no frame|none|unframed/i.test(frameVal);
      var ftype = typeKey(controlValue("frametype"));
      var szv = controlValue("size");
      var tier = sizeKey(szv);
      var mountVal = controlValue("mount");
      var mounted = !!(mountVal && !/no mount|none|unmounted/i.test(mountVal));
      var shape = selectedDimensionShape();
      var layout = selectedLayout();
      var multiSpec = isMultiPanelLayout(layout) ? MULTI_PANEL_SPECS[layout] : null;
      if (isProductPage && !productHasSizeOption() && !multiSpec) {
        setSpecRow("print-size", "", true);
        setSpecRow("framed-size", "", true);
        setSpecRow("frame-profile", "", true);
        if (frameNone) {
          setSpecRow("glazing", "", true);
          setSpecRow("hanging", "", true);
          setSpecRow("mount", "", true);
        } else {
          setSpecRow("glazing", "float glass", false);
          setSpecRow("hanging", "Tensioned string fixture, ready to hang", false);
          if (mounted) {
            var panoMc = controlQuery('[data-mount-colour] [aria-pressed="true"]');
            var panoMountColour = (panoMc && panoMc.getAttribute("data-name")) || visualiser.dataset.initialMountColour || "";
            setSpecRow("mount", panoMountColour || "Mounted", false);
          } else {
            setSpecRow("mount", "No mount", false);
          }
        }
        notifySpecUpdated();
        return;
      }
      var frameCm = frameNone ? 0 : (FRAME_WIDTH_CM[ftype] || FRAME_WIDTH_CM.standard);
      var noMountFrame = (!mounted && !frameNone && !multiSpec) ? rosenstielsFinishedSize(szv) : null;
      if (noMountFrame) {
        setSpecRow("print-size", formatSpecCm(noMountFrame.printW, noMountFrame.printH), false);
        setSpecRow("orientation", orientationFromPrintCm({ w: noMountFrame.printW, h: noMountFrame.printH }), false);
        setSpecRow("framed-size", framedSpecLabel(noMountFrame.w, noMountFrame.h, null, null), false);
        var noMountStyle = controlValue("frametype") || "Classic";
        setSpecRow("frame-profile", noMountStyle + " · " + frameVal + " · ~" + frameCm + " cm face", false);
        setSpecRow("glazing", glazingForTier(tier), false);
        setSpecRow("hanging", "Tensioned string fixture, ready to hang", false);
        setSpecRow("mount", "No mount", false);
        notifySpecUpdated();
        return;
      }
      var singleCm = multiSpec ? null : printSizeCm(shape, tier, szv);
      var mountCm = 0;
      if (mounted && !frameNone) {
        if (multiSpec) mountCm = multiSpec.mountCm;
        else if (singleCm) mountCm = singleMountCm(tier, singleCm.w);
      }
      var printCm = multiSpec
        ? {
            w: Math.max(1, multiSpec.panel.w - 2 * (frameCm + mountCm)),
            h: Math.max(1, multiSpec.panel.h - 2 * (frameCm + mountCm))
          }
        : singleCm;
      var panoOuter = !multiSpec ? landscapePanoCm(singleCm, shape) : null;
      if (panoOuter) {
        var panoInset = 2 * (frameCm + mountCm);
        printCm = {
          w: Math.max(1, panoOuter.w - panoInset),
          h: Math.max(1, panoOuter.h - panoInset)
        };
      }
      if (!printCm) {
        setSpecRow("print-size", "", true);
        setSpecRow("framed-size", "", true);
        setSpecRow("frame-profile", "", true);
        setSpecRow("mount", "", true);
        setSpecRow("glazing", "", true);
        setSpecRow("hanging", "", true);
        notifySpecUpdated();
        return;
      }
      setSpecRow("print-size", artworkSpecLabel(printCm, multiSpec, layout), false);
      var orientCm = (multiSpec && multiSpec.overall) ? multiSpec.overall : printCm;
      setSpecRow("orientation", orientationFromPrintCm(orientCm), false);
      if (frameNone) {
        setSpecRow("framed-size", "", true);
        setSpecRow("frame-profile", "", true);
        setSpecRow("glazing", "", true);
        setSpecRow("hanging", "", true);
        setSpecRow("mount", "", true);
        notifySpecUpdated();
        return;
      }
      var outerW = panoOuter ? panoOuter.w : printCm.w + 2 * (frameCm + mountCm);
      var outerH = panoOuter ? panoOuter.h : printCm.h + 2 * (frameCm + mountCm);
      if (multiSpec) {
        var outer = multiPanelOuterCm(multiSpec, frameCm, mountCm);
        outerW = outer.w;
        outerH = outer.h;
      }
      setSpecRow("framed-size", framedSpecLabel(outerW, outerH, multiSpec, layout), false);
      var styleName = controlValue("frametype") || "Classic";
      setSpecRow("frame-profile", styleName + " · " + frameVal + " · ~" + frameCm + " cm face", false);
      setSpecRow("glazing", glazingForTier(tier), false);
      setSpecRow("hanging", "Tensioned string fixture, ready to hang", false);
      if (mounted) {
        var mc = controlQuery('[data-mount-colour] [aria-pressed="true"]');
        var mountColourName = (mc && mc.getAttribute("data-name")) || visualiser.dataset.initialMountColour || "";
        var mountLabel = mountCm + " cm";
        if (mountColourName) mountLabel = mountColourName + " · " + mountLabel;
        setSpecRow("mount", mountLabel, false);
      } else {
        setSpecRow("mount", "No mount", false);
      }
      notifySpecUpdated();
    }

    function updateVariant() {
      if (!isProductPage) {
        try { updatePreview(); } catch (err) { console.warn("[artfolio] preview", err); }
        return;
      }
      var v = currentVariant();
      if (!v) {
        if (addBtn) addBtn.setAttribute("disabled", "disabled");
        if (addLabel) addLabel.textContent = "Unavailable";
        if (addAmt) addAmt.textContent = "";
        try { updatePreview(); } catch (err) { console.warn("[artfolio] preview", err); }
        return;
      }
      // Commit the variant before the preview. A preview error must not leave
      // the form on the previous size while the buy box shows the new one.
      if (idInput) idInput.value = v.id;
      var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
      if (priceMain) priceMain.textContent = formatMoney(v.price);
      if (priceWas) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          priceWas.textContent = formatMoney(v.compare_at_price);
          if (priceMain) priceMain.classList.add("on-sale");
        } else {
          priceWas.textContent = "";
          if (priceMain) priceMain.classList.remove("on-sale");
        }
      }
      if (v.available) {
        if (addBtn) addBtn.removeAttribute("disabled");
        if (addLabel) addLabel.textContent = "Add to basket";
        if (addAmt) addAmt.textContent = formatMoney(v.price * qty);
      } else {
        if (addBtn) addBtn.setAttribute("disabled", "disabled");
        if (addLabel) addLabel.textContent = "Sold out";
        if (addAmt) addAmt.textContent = "";
      }
      try { updatePreview(); } catch (err) { console.warn("[artfolio] preview", err); }
    }

    // option group clicks (variant options)
    root.querySelectorAll("[data-option-index]").forEach(function (group) {
      group.addEventListener("click", function (e) {
        var btn = e.target.closest("[data-value]");
        if (!btn || btn.disabled) return;
        var idx = group.getAttribute("data-option-index");
        var nextValue = btn.getAttribute("data-value");
        var valueChanged = selected[idx] !== nextValue;
        selected[idx] = nextValue;
        group.querySelectorAll("[data-value]").forEach(function (b) {
          b.setAttribute("aria-pressed", b === btn ? "true" : "false");
        });
        var display = nextValue;
        if (looksLike(product.options && product.options[Number(idx) - 1], ["size", "dimension"])) {
          display = String(nextValue || "").replace(/\s*\([^)]*\)\s*$/, "").replace(/^\s+|\s+$/g, "") || nextValue;
        }
        root.querySelectorAll('[data-option-val="' + idx + '"]').forEach(function (optVal) {
          optVal.textContent = display;
        });
        updateVariant();
        var optionName = product.options && product.options[Number(idx) - 1];
        if (valueChanged && looksLike(optionName, ["size", "dimension"]) && visualiserApi.arrangeReset) {
          visualiserApi.arrangeReset();
        }
      });
    });

    // presentational framing controls (line-item properties, not variants)
    controlQueryAll("[data-pp-group]").forEach(function (group) {
      group.addEventListener("click", function (e) {
        var btn = e.target.closest("[data-value]");
        if (!btn || btn.disabled) return;
        var valueChanged = btn.getAttribute("aria-pressed") !== "true";
        var type = group.getAttribute("data-pp-group");
        // Colour / size / mount clicks must never rewrite style selection state.
        group.querySelectorAll("[data-value]").forEach(function (b) { b.setAttribute("aria-pressed", b === btn ? "true" : "false"); });
        var input = controlQuery('[data-pp-input="' + type + '"]');
        if (input) input.value = btn.getAttribute("data-value");
        setControlTexts(
          '[data-pp-val="' + type + '"]',
          (type === "frametype" && btn.getAttribute("data-display-name"))
            || btn.getAttribute("data-value")
        );
        if (type === "frame") {
          rememberFrameColour(typeKey(controlValue("frametype")), btn.getAttribute("data-value"));
        }
        if (type === "frametype") {
          // Keep the selected colour; filterColourSwatches remaps only if unavailable.
          syncFrameStyleVariant(btn.getAttribute("data-value"));
        }
        if (type === "frametype" && frameStyleOptionIndex() >= 0 && isProductPage) {
          updateVariant();
        } else {
          updatePreview();
        }
        if (valueChanged && type === "size" && visualiserApi.arrangeReset) visualiserApi.arrangeReset();
      });
    });

    // Seed per-style colour memory from the initial selection.
    (function ensureFrameStyleSelection() {
      var buttons = controlQueryAll('[data-pp-type="frametype"]');
      if (!buttons.length) return;
      var pressed = controlQuery('[data-pp-type="frametype"][aria-pressed="true"]');
      if (pressed) {
        syncFrameStyleVariant(pressed.getAttribute("data-value"));
        return;
      }
      var wanted = String(
        visualiser.dataset.initialFrame ||
        controlValue("frametype") ||
        "Classic"
      );
      var wantedKey = typeKey(wanted);
      var match = null;
      buttons.forEach(function (btn) {
        var v = btn.getAttribute("data-value") || "";
        if (!match && (v === wanted || typeKey(v) === wantedKey)) match = btn;
      });
      if (!match) match = buttons[0];
      buttons.forEach(function (btn) {
        btn.setAttribute("aria-pressed", btn === match ? "true" : "false");
      });
      var input = controlQuery('[data-pp-input="frametype"]');
      if (input) input.value = match.getAttribute("data-value");
      setControlTexts(
        '[data-pp-val="frametype"]',
        match.getAttribute("data-display-name") || match.getAttribute("data-value")
      );
      syncFrameStyleVariant(match.getAttribute("data-value"));
    })();
    rememberFrameColour(typeKey(controlValue("frametype")), controlValue("frame") || colourForStyle(typeKey(controlValue("frametype"))));
    (function syncFrameStyleLabel() {
      var pressed = controlQuery('[data-pp-type="frametype"][aria-pressed="true"]');
      if (pressed && pressed.getAttribute("data-display-name")) {
        setControlTexts('[data-pp-val="frametype"]', pressed.getAttribute("data-display-name"));
      }
    })();

    // hover loupe (desktop only — floats outside the overflow:hidden swatch)
    // ZOOM 2.5 is the minimum to fill the 150px lens from the 60px swatch;
    // higher-res supplier photos would allow more zoom without softening.
    if (fpSwatch && fpLoupe) {
      var LENS = 150, ZOOM = 2.5;
      function currentFinishUrl() {
        var fin = fpSwatch.getAttribute("data-finish");
        return fin ? fpFinishUrls[fin] : null;
      }
      fpSwatch.addEventListener("mouseenter", function () {
        var url = currentFinishUrl();
        if (!url) return;
        fpLoupe.style.backgroundImage = 'url("' + url + '")';
        fpLoupe.style.backgroundRepeat = "no-repeat";
        fpLoupe.style.display = "block";
      });
      fpSwatch.addEventListener("mouseleave", function () {
        fpLoupe.style.display = "none";
      });
      fpSwatch.addEventListener("mousemove", function (e) {
        if (fpLoupe.style.display !== "block") return;
        var r = fpSwatch.getBoundingClientRect();
        var x = e.clientX - r.left, y = e.clientY - r.top;
        var bw = r.width * ZOOM, bh = r.height * ZOOM;
        fpLoupe.style.backgroundSize = bw + "px " + bh + "px";
        var bx = (x / r.width) * bw - LENS / 2;
        var by = (y / r.height) * bh - LENS / 2;
        fpLoupe.style.backgroundPosition = -bx + "px " + -by + "px";
        fpLoupe.style.left = (x - LENS / 2) + "px";
        fpLoupe.style.top = (y - LENS / 2) + "px";
      });
    }

    // mount colour (line-item property, not a variant)
    var mcGroup = controlQuery("[data-mount-colour]");
    if (mcGroup) {
      mcGroup.addEventListener("click", function (e) {
        var btn = e.target.closest("[data-colour]");
        if (!btn || btn.disabled) return;
        mcGroup.querySelectorAll("[data-colour]").forEach(function (b) { b.setAttribute("aria-pressed", b === btn ? "true" : "false"); });
        var input = mcGroup.querySelector("[data-mount-colour-input]");
        if (input) input.value = btn.getAttribute("data-name") || btn.getAttribute("data-colour");
        setControlTexts("[data-mc-val]", btn.getAttribute("data-name") || "");
        var mcOpt = controlQuery("[data-mount-colour-opt]");
        if (mcOpt) {
          mcOpt.setAttribute("data-mount-name", btn.getAttribute("data-name") || "");
          mcOpt.setAttribute("data-mount-color", btn.getAttribute("data-colour") || "");
        }
        updatePreview();
      });
    }

    // quantity
    var minus = root.querySelector("[data-qty-minus]");
    var plus = root.querySelector("[data-qty-plus]");
    if (minus) minus.addEventListener("click", function () { qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1); updateVariant(); });
    if (plus) plus.addEventListener("click", function () { qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1; updateVariant(); });
    if (qtyInput) qtyInput.addEventListener("change", updateVariant);

    // preview view toggle (artwork / in a room)
    var stage = isSplitRooms
      ? visualiser.querySelector('[data-stage="room"]')
      : visualiser.querySelector("[data-stage]");
    var dimensionResizeFrame = null;
    function refreshDimensionsAfterResize() {
      if (dimensionResizeFrame) cancelAnimationFrame(dimensionResizeFrame);
      dimensionResizeFrame = requestAnimationFrame(function () {
        dimensionResizeFrame = null;
        updatePreview();
      });
    }
    if ("ResizeObserver" in window) {
      var stagesToObserve = visualiser.querySelectorAll("[data-stage]");
      if (stagesToObserve.length) {
        var stageRO = new ResizeObserver(refreshDimensionsAfterResize);
        Array.prototype.forEach.call(stagesToObserve, function (stageEl) {
          stageRO.observe(stageEl);
        });
      } else {
        window.addEventListener("resize", refreshDimensionsAfterResize);
      }
    } else {
      window.addEventListener("resize", refreshDimensionsAfterResize);
    }
    root.querySelectorAll("[data-view]").forEach(function (b) {
      b.addEventListener("click", function () {
        var previousRoom = stage && stage.getAttribute("data-room");
        var nextRoom = b.getAttribute("data-view") === "room" ? b.getAttribute("data-room") : null;
        root.querySelectorAll("[data-view]").forEach(function (x) { x.setAttribute("aria-pressed", x === b ? "true" : "false"); });
        if (!stage) return;
        if (b.getAttribute("data-view") === "room") {
          var rm = b.getAttribute("data-room");
          if (rm) stage.setAttribute("data-room", rm);
          var lt = b.getAttribute("data-light");
          if (lt) stage.setAttribute("data-light", lt);
          stage.classList.add("room");
        } else if (!isSplitRooms) {
          stage.classList.remove("room");
        }
        var viewSelect = root.querySelector("[data-views-select]");
        if (viewSelect) {
          var selectVal = b.getAttribute("data-view") === "room" ? (b.getAttribute("data-room") || "lounge") : "art";
          if (viewSelect.value !== selectVal) viewSelect.value = selectVal;
        }
        updatePreview();
        if (visualiserApi.positionToolRefresh) visualiserApi.positionToolRefresh();
        if (nextRoom && nextRoom !== previousRoom && visualiserApi.arrangeReset) visualiserApi.arrangeReset();
        if (visualiserApi.yourRoomRefresh) visualiserApi.yourRoomRefresh();
        if (visualiserApi.yourRoomLightRefresh) visualiserApi.yourRoomLightRefresh();
      });
    });

    var viewsSelect = root.querySelector("[data-views-select]");
    if (viewsSelect) {
      viewsSelect.addEventListener("change", function () {
        var val = viewsSelect.value;
        var btn = val === "art"
          ? root.querySelector('[data-view="art"]')
          : root.querySelector('[data-view="room"][data-room="' + val + '"]');
        if (btn) btn.click();
      });
    }

    function isMountOffValue(value) {
      return /no mount|none|unmounted|^no$/.test(String(value || "").toLowerCase());
    }

    function syncMountSwitchUi() {
      var mountVal = controlValue("mount");
      if (!mountVal) {
        var pressed = controlQuery(".mount-switch-row [data-value][aria-pressed='true']");
        if (pressed) mountVal = pressed.getAttribute("data-value");
      }
      var mounted = !!(mountVal && !isMountOffValue(mountVal));
      controlQueryAll("[data-mount-switch]").forEach(function (sw) {
        sw.setAttribute("aria-checked", mounted ? "true" : "false");
        var row = sw.closest(".mount-switch-row") || sw.parentElement;
        if (!row) return;
        var onBtn = null;
        var offBtn = null;
        row.querySelectorAll("[data-value]").forEach(function (btn) {
          if (isMountOffValue(btn.getAttribute("data-value"))) offBtn = btn;
          else if (!onBtn) onBtn = btn;
        });
        var title = row.querySelector("[data-mount-switch-title]");
        var sub = row.querySelector("[data-mount-switch-sub]");
        if (title) {
          title.textContent = mounted
            ? ((onBtn && onBtn.getAttribute("data-value")) || "Mounted")
            : ((offBtn && offBtn.getAttribute("data-value")) || "No mount");
        }
        if (sub) {
          var multiMount = isMultiPanelLayout(selectedLayout());
          sub.textContent = mounted
            ? (multiMount ? "25mm mount on each panel" : "Bordered with card")
            : "Print fills the frame";
        }
      });
    }

    controlQueryAll("[data-mount-switch]").forEach(function (sw) {
      sw.addEventListener("click", function (e) {
        e.preventDefault();
        var row = sw.closest(".mount-switch-row");
        if (!row) return;
        var currentlyOn = sw.getAttribute("aria-checked") === "true";
        var target = null;
        row.querySelectorAll("[data-value]").forEach(function (btn) {
          var isOff = isMountOffValue(btn.getAttribute("data-value"));
          if (currentlyOn ? isOff : !isOff) target = btn;
        });
        if (target) target.click();
      });
    });

    // Customer arrange-in-room: opt-in move + resize (preview only; Reset restores true hang/size)
    (function () {
      if (!stage) return;
      var wrap = stage.querySelector("[data-framewrap]");
      var layer = stage.querySelector("[data-arrange-layer]");
      var handle = stage.querySelector("[data-arrange-handle]");
      var toggleBtn = root.querySelector("[data-arrange-toggle]");
      var resetBtn = root.querySelector("[data-arrange-reset]");
      var smallerBtn = root.querySelector("[data-arrange-smaller]");
      var largerBtn = root.querySelector("[data-arrange-larger]");
      if (!layer || !wrap) return;

      // Resize clamp around the accurate true size (0.7×–1.4×).
      // To allow fully free resize later: set MIN very low / MAX very high, or remove clamp() in setScale.
      var ARRANGE_SCALE_MIN = 0.7;
      var ARRANGE_SCALE_MAX = 1.4;
      var ARRANGE_SCALE_STEP = 0.08;

      var ax = 0, ay = 0, as = 1;
      var mode = null; // "move" | "resize"
      var startX = 0, startY = 0, startAx = 0, startAy = 0, startAs = 1, startDist = 0;
      var pointers = {};

      function inRoom() {
        return stage.classList.contains("room") && !stage.classList.contains("positioning");
      }
      function isEditing() {
        return inRoom() && stage.classList.contains("arranging");
      }
      function setEditing(on) {
        if (on && inRoom()) {
          stage.classList.add("arranging");
          layer.setAttribute("tabindex", "0");
          if (toggleBtn) {
            toggleBtn.textContent = "Done";
            toggleBtn.setAttribute("aria-pressed", "true");
          }
        } else {
          stage.classList.remove("arranging");
          layer.setAttribute("tabindex", "-1");
          layer.classList.remove("is-dragging", "is-resizing");
          wrap.classList.remove("is-arranging");
          mode = null;
          pointers = {};
          if (toggleBtn) {
            toggleBtn.textContent = "Reposition frame";
            toggleBtn.setAttribute("aria-pressed", "false");
          }
        }
      }
      function clamp(n, lo, hi) { return Math.max(lo, Math.min(hi, n)); }
      function clampMove() {
        var sw = stage.clientWidth || 1, sh = stage.clientHeight || 1;
        ax = clamp(ax, -sw * 0.45, sw * 0.45);
        ay = clamp(ay, -sh * 0.45, sh * 0.45);
      }
      // Offset lives on .framewrap via CSS vars so shadow + blend move/scale with the piece
      function applyTransform() {
        wrap.style.setProperty("--arrange-x", ax + "px");
        wrap.style.setProperty("--arrange-y", ay + "px");
        wrap.style.setProperty("--arrange-s", String(as));
      }
      function reset() {
        ax = 0; ay = 0; as = 1;
        layer.classList.remove("is-dragging", "is-resizing");
        wrap.classList.remove("is-arranging");
        applyTransform();
      }
      function setScale(next) {
        as = clamp(next, ARRANGE_SCALE_MIN, ARRANGE_SCALE_MAX);
        applyTransform();
      }
      function pointerCount() {
        return Object.keys(pointers).length;
      }
      function pinchDist() {
        var ids = Object.keys(pointers);
        if (ids.length < 2) return 0;
        var a = pointers[ids[0]], b = pointers[ids[1]];
        var dx = a.x - b.x, dy = a.y - b.y;
        return Math.sqrt(dx * dx + dy * dy) || 1;
      }

      if (toggleBtn) {
        toggleBtn.addEventListener("click", function () {
          if (!inRoom()) return;
          setEditing(!isEditing());
        });
      }

      layer.addEventListener("pointerdown", function (e) {
        if (!isEditing() || e.button > 0) return;
        if (e.target.closest && e.target.closest("[data-arrange-handle]")) return;
        e.preventDefault();
        pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
        try { layer.setPointerCapture(e.pointerId); } catch (err) {}
        wrap.classList.add("is-arranging");
        if (pointerCount() >= 2) {
          mode = "resize";
          startAs = as;
          startDist = pinchDist();
          layer.classList.add("is-resizing");
          layer.classList.remove("is-dragging");
        } else {
          mode = "move";
          startX = e.clientX; startY = e.clientY;
          startAx = ax; startAy = ay;
          layer.classList.add("is-dragging");
        }
      });

      layer.addEventListener("pointermove", function (e) {
        if (!isEditing() || !pointers[e.pointerId]) return;
        pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
        if (mode === "resize" || pointerCount() >= 2) {
          if (pointerCount() >= 2) {
            mode = "resize";
            var d = pinchDist();
            if (startDist > 0) setScale(startAs * (d / startDist));
          }
          return;
        }
        if (mode !== "move") return;
        ax = startAx + (e.clientX - startX);
        ay = startAy + (e.clientY - startY);
        clampMove();
        applyTransform();
      });

      function endPointer(e) {
        delete pointers[e.pointerId];
        try { layer.releasePointerCapture(e.pointerId); } catch (err) {}
        if (pointerCount() === 0) {
          mode = null;
          layer.classList.remove("is-dragging", "is-resizing");
          wrap.classList.remove("is-arranging");
        } else if (pointerCount() === 1) {
          mode = "move";
          var id = Object.keys(pointers)[0];
          startX = pointers[id].x; startY = pointers[id].y;
          startAx = ax; startAy = ay;
          layer.classList.add("is-dragging");
          layer.classList.remove("is-resizing");
        }
      }
      layer.addEventListener("pointerup", endPointer);
      layer.addEventListener("pointercancel", endPointer);

      if (handle) {
        var handleDrag = false;
        handle.addEventListener("pointerdown", function (e) {
          if (!isEditing() || e.button > 0) return;
          e.preventDefault();
          e.stopPropagation();
          handleDrag = true;
          mode = "resize";
          startX = e.clientX; startY = e.clientY;
          startAs = as;
          layer.classList.add("is-resizing");
          wrap.classList.add("is-arranging");
          try { handle.setPointerCapture(e.pointerId); } catch (err) {}
        });
        handle.addEventListener("pointermove", function (e) {
          if (!handleDrag || !isEditing()) return;
          var delta = ((e.clientX - startX) + (e.clientY - startY)) / 180;
          setScale(startAs * (1 + delta));
        });
        function endHandle() {
          handleDrag = false;
          mode = null;
          layer.classList.remove("is-resizing");
          wrap.classList.remove("is-arranging");
        }
        handle.addEventListener("pointerup", endHandle);
        handle.addEventListener("pointercancel", endHandle);
      }

      if (smallerBtn) smallerBtn.addEventListener("click", function () {
        if (!isEditing()) return;
        setScale(as - ARRANGE_SCALE_STEP);
      });
      if (largerBtn) largerBtn.addEventListener("click", function () {
        if (!isEditing()) return;
        setScale(as + ARRANGE_SCALE_STEP);
      });
      if (resetBtn) resetBtn.addEventListener("click", function () {
        if (!isEditing()) return;
        reset();
      });

      layer.addEventListener("keydown", function (e) {
        if (!isEditing()) return;
        var step = e.shiftKey ? 16 : 8;
        if (e.key === "ArrowLeft") { ax -= step; clampMove(); applyTransform(); e.preventDefault(); }
        else if (e.key === "ArrowRight") { ax += step; clampMove(); applyTransform(); e.preventDefault(); }
        else if (e.key === "ArrowUp") { ay -= step; clampMove(); applyTransform(); e.preventDefault(); }
        else if (e.key === "ArrowDown") { ay += step; clampMove(); applyTransform(); e.preventDefault(); }
        else if (e.key === "+" || e.key === "=") { setScale(as + ARRANGE_SCALE_STEP); e.preventDefault(); }
        else if (e.key === "-" || e.key === "_") { setScale(as - ARRANGE_SCALE_STEP); e.preventDefault(); }
        else if (e.key === "0") { reset(); e.preventDefault(); }
        else if (e.key === "Escape") { setEditing(false); e.preventDefault(); }
      });

      // True-size/background resets (print size, room, upload); cosmetic frame changes preserve placement.
      visualiserApi.arrangeReset = function () {
        reset();
        if (!stage.classList.contains("room")) setEditing(false);
      };
      visualiserApi.arrangeEnterEdit = function () { setEditing(true); };
      visualiserApi.arrangeExitEdit = function () { setEditing(false); };
      applyTransform();
    })();

    // Uploaded-room light direction — changes only frame rails and shadows.
    (function () {
      if (!stage) return;
      var lightControl = root.querySelector("[data-your-room-light]");
      var lightToggle = root.querySelector("[data-your-room-light-toggle]");
      var lightMenu = root.querySelector("[data-your-room-light-menu]");
      var lightButtons = root.querySelectorAll("[data-your-room-light-value]");
      var yoursView = root.querySelector('[data-view="room"][data-room="yours"]');
      if (!lightControl || !lightToggle || !lightMenu || !yoursView) return;

      var currentLight = yoursView.getAttribute("data-light") || "top-left";
      function isYours() {
        return stage.classList.contains("room") && stage.getAttribute("data-room") === "yours";
      }
      function closeMenu() {
        lightMenu.hidden = true;
        lightToggle.setAttribute("aria-expanded", "false");
      }
      function applyLight(value) {
        currentLight = value || "top-left";
        yoursView.setAttribute("data-light", currentLight);
        if (isYours()) stage.setAttribute("data-light", currentLight);
        var activeLabel = "Soft";
        lightButtons.forEach(function (button) {
          var active = button.getAttribute("data-your-room-light-value") === currentLight;
          button.setAttribute("aria-pressed", active ? "true" : "false");
          if (active) activeLabel = button.getAttribute("data-light-label") || "Soft";
        });
        lightToggle.setAttribute("aria-label", "Light direction: " + activeLabel);
        lightToggle.setAttribute("title", "Light direction: " + activeLabel);
      }

      lightToggle.addEventListener("click", function (event) {
        event.stopPropagation();
        var opening = lightMenu.hidden;
        lightMenu.hidden = !opening;
        lightToggle.setAttribute("aria-expanded", opening ? "true" : "false");
      });
      lightMenu.addEventListener("click", function (event) {
        var button = event.target.closest("[data-your-room-light-value]");
        if (!button) return;
        applyLight(button.getAttribute("data-your-room-light-value"));
        closeMenu();
      });
      lightMenu.addEventListener("keydown", function (event) {
        if (event.key === "Escape") {
          closeMenu();
          lightToggle.focus();
        }
      });
      document.addEventListener("click", function (event) {
        if (!lightControl.contains(event.target)) closeMenu();
      });

      visualiserApi.yourRoomLightRefresh = function () {
        if (isYours()) applyLight(currentLight);
        else closeMenu();
      };
      applyLight(currentLight);
    })();

    // Your room — client-side photo upload (object URL only; never sent to server)
    (function () {
      if (!stage) return;
      var scene = stage.querySelector(".room-scene");
      var uploadBtn = root.querySelector("[data-your-room-upload]");
      var fileInput = root.querySelector("[data-your-room-input]");
      var removeBtn = root.querySelector("[data-your-room-remove]");
      if (!scene || !uploadBtn || !fileInput) return;

      var objectUrl = null;
      var MAX_EDGE = 2000;
      var WARN_BYTES = 15 * 1024 * 1024;

      function isYours() {
        return stage.classList.contains("room") && stage.getAttribute("data-room") === "yours";
      }
      function applySceneBg(url) {
        if (!url) {
          scene.style.backgroundImage = "";
          scene.style.backgroundSize = "";
          scene.style.backgroundPosition = "";
          scene.style.backgroundRepeat = "";
          return;
        }
        scene.style.backgroundImage = 'url("' + url + '")';
        scene.style.backgroundSize = "cover";
        scene.style.backgroundPosition = "center";
        scene.style.backgroundRepeat = "no-repeat";
      }
      function setHasPhoto(on) {
        if (on) stage.classList.add("has-your-photo");
        else stage.classList.remove("has-your-photo");
      }
      function clearPhoto() {
        if (objectUrl) {
          URL.revokeObjectURL(objectUrl);
          objectUrl = null;
        }
        applySceneBg(null);
        setHasPhoto(false);
        fileInput.value = "";
        if (visualiserApi.arrangeReset) visualiserApi.arrangeReset();
        if (visualiserApi.arrangeExitEdit) visualiserApi.arrangeExitEdit();
      }
      function applyPhoto(url) {
        if (objectUrl && objectUrl !== url) URL.revokeObjectURL(objectUrl);
        objectUrl = url;
        applySceneBg(url);
        setHasPhoto(true);
        if (visualiserApi.arrangeReset) visualiserApi.arrangeReset();
        if (visualiserApi.arrangeEnterEdit) visualiserApi.arrangeEnterEdit();
      }
      function prepareImage(file, done) {
        if (!file || !file.type || file.type.indexOf("image/") !== 0) {
          window.alert("Please choose an image file (JPG, PNG, HEIC, etc.).");
          done(null);
          return;
        }
        if (file.size > WARN_BYTES) {
          // Still attempt; downscale path below usually keeps it usable
        }
        var tempUrl = URL.createObjectURL(file);
        var img = new Image();
        img.onload = function () {
          var w = img.naturalWidth || 0, h = img.naturalHeight || 0;
          if (!w || !h || (w <= MAX_EDGE && h <= MAX_EDGE)) {
            done(tempUrl);
            return;
          }
          var scale = MAX_EDGE / Math.max(w, h);
          var cw = Math.max(1, Math.round(w * scale));
          var ch = Math.max(1, Math.round(h * scale));
          var canvas = document.createElement("canvas");
          canvas.width = cw;
          canvas.height = ch;
          var ctx = canvas.getContext("2d");
          if (!ctx) {
            done(tempUrl);
            return;
          }
          ctx.drawImage(img, 0, 0, cw, ch);
          canvas.toBlob(function (blob) {
            URL.revokeObjectURL(tempUrl);
            if (!blob) { done(null); return; }
            done(URL.createObjectURL(blob));
          }, "image/jpeg", 0.9);
        };
        img.onerror = function () {
          URL.revokeObjectURL(tempUrl);
          window.alert("Couldn’t read that image. Try a different photo.");
          done(null);
        };
        img.src = tempUrl;
      }

      uploadBtn.addEventListener("click", function () {
        fileInput.click();
      });
      fileInput.addEventListener("change", function () {
        var file = fileInput.files && fileInput.files[0];
        if (!file) return;
        prepareImage(file, function (url) {
          if (!url) return;
          applyPhoto(url);
        });
      });
      if (removeBtn) {
        removeBtn.addEventListener("click", function () {
          clearPhoto();
        });
      }

      // Keep uploaded image in memory across scenes; only paint it while on Your room
      visualiserApi.yourRoomRefresh = function () {
        if (isYours()) {
          if (objectUrl) {
            applySceneBg(objectUrl);
            setHasPhoto(true);
          } else {
            applySceneBg(null);
            setHasPhoto(false);
            if (visualiserApi.arrangeExitEdit) visualiserApi.arrangeExitEdit();
          }
        } else {
          // Drop inline bg so stock room CSS photos show through
          applySceneBg(null);
        }
      };
    })();

    // admin frame-position tool — drag left/top only; copy readout for CSS hang values
    (function () {
      if (!stage) return;
      var wrap = stage.querySelector("[data-framewrap]");
      if (!wrap) return;
      var toolOn = stage.getAttribute("data-position-tool") === "on"
        || /(?:\?|&)position=1(?:&|$)/.test(location.search || "");
      if (!toolOn) return;

      var roomPos = {};
      var panel = document.createElement("div");
      panel.className = "pos-tool";
      panel.innerHTML = '<div class="pos-tool-title">Position tool</div>'
        + '<div class="pos-tool-room" data-pos-room></div>'
        + '<code class="pos-tool-vals" data-pos-vals>left: —; top: —;</code>'
        + '<div class="pos-tool-actions">'
        + '<button type="button" class="pos-tool-btn" data-pos-copy>Copy</button>'
        + '<button type="button" class="pos-tool-btn" data-pos-reset>Reset</button>'
        + '</div>';
      var gallery = root.querySelector(".gallery") || stage.parentNode;
      gallery.appendChild(panel);

      var roomEl = panel.querySelector("[data-pos-room]");
      var valsEl = panel.querySelector("[data-pos-vals]");
      var dragging = false, startX = 0, startY = 0, startLeft = 0, startTop = 0;

      function active() {
        return stage.classList.contains("room");
      }
      function roomKey() {
        return stage.getAttribute("data-room") || "lounge";
      }
      function clamp(n, lo, hi) {
        return Math.max(lo, Math.min(hi, n));
      }
      function round1(n) {
        return Math.round(n * 10) / 10;
      }
      function getPosPct() {
        if (wrap.style.left && wrap.style.left.indexOf("%") > -1) {
          return { left: parseFloat(wrap.style.left), top: parseFloat(wrap.style.top) };
        }
        var sw = stage.clientWidth || 1, sh = stage.clientHeight || 1;
        var cs = getComputedStyle(wrap);
        return {
          left: (parseFloat(cs.left) / sw) * 100,
          top: (parseFloat(cs.top) / sh) * 100
        };
      }
      function setPosPct(left, top) {
        left = round1(clamp(left, 5, 95));
        top = round1(clamp(top, 5, 95));
        wrap.style.left = left + "%";
        wrap.style.top = top + "%";
        roomPos[roomKey()] = { left: left, top: top };
        updateReadout();
      }
      function updateReadout() {
        if (!active()) {
          panel.classList.remove("is-on");
          stage.classList.remove("positioning");
          wrap.classList.remove("is-dragging");
          return;
        }
        panel.classList.add("is-on");
        stage.classList.add("positioning");
        var room = roomKey();
        var pos = roomPos[room] || getPosPct();
        roomEl.textContent = room.charAt(0).toUpperCase() + room.slice(1);
        valsEl.textContent = "left: " + round1(pos.left) + "%; top: " + round1(pos.top) + "%;";
      }
      function applyRoomPos() {
        if (!active()) {
          wrap.style.left = "";
          wrap.style.top = "";
          updateReadout();
          return;
        }
        var saved = roomPos[roomKey()];
        if (saved) {
          wrap.style.left = saved.left + "%";
          wrap.style.top = saved.top + "%";
        } else {
          wrap.style.left = "";
          wrap.style.top = "";
        }
        updateReadout();
      }

      wrap.addEventListener("pointerdown", function (e) {
        if (!active() || e.button > 0) return;
        e.preventDefault();
        var pos = getPosPct();
        dragging = true;
        startX = e.clientX;
        startY = e.clientY;
        startLeft = pos.left;
        startTop = pos.top;
        wrap.classList.add("is-dragging");
        try { wrap.setPointerCapture(e.pointerId); } catch (err) {}
      });
      wrap.addEventListener("pointermove", function (e) {
        if (!dragging) return;
        var sw = stage.clientWidth || 1, sh = stage.clientHeight || 1;
        var dx = ((e.clientX - startX) / sw) * 100;
        var dy = ((e.clientY - startY) / sh) * 100;
        setPosPct(startLeft + dx, startTop + dy);
      });
      function endDrag(e) {
        if (!dragging) return;
        dragging = false;
        wrap.classList.remove("is-dragging");
        try { wrap.releasePointerCapture(e.pointerId); } catch (err) {}
      }
      wrap.addEventListener("pointerup", endDrag);
      wrap.addEventListener("pointercancel", endDrag);

      panel.querySelector("[data-pos-copy]").addEventListener("click", function () {
        var text = valsEl.textContent;
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(text).then(function () {
            valsEl.classList.add("copied");
            setTimeout(function () { valsEl.classList.remove("copied"); }, 900);
          });
        } else {
          var ta = document.createElement("textarea");
          ta.value = text;
          document.body.appendChild(ta);
          ta.select();
          try { document.execCommand("copy"); } catch (err) {}
          document.body.removeChild(ta);
        }
      });
      panel.querySelector("[data-pos-reset]").addEventListener("click", function () {
        delete roomPos[roomKey()];
        wrap.style.left = "";
        wrap.style.top = "";
        updateReadout();
      });

      visualiserApi.positionToolRefresh = applyRoomPos;
      applyRoomPos();
    })();

    // hover magnifier (artwork view only)
    function canHoverZoom() {
      return !(window.matchMedia && !window.matchMedia("(hover: hover) and (pointer: fine)").matches);
    }
    function dismissZoomHint() {
      if (!canHoverZoom()) return;
      visualiser.setAttribute("data-zoom-hint-seen", "");
      var hint = visualiser.querySelector(".zoom-hint");
      if (hint) hint.classList.add("is-dismissed");
    }
    function attachMagnifier(piece, src) {
      if (!piece || !src) return;
      var existing = piece.querySelector(".zoom-lens");
      if (existing) existing.remove();
      var lens = document.createElement("span");
      lens.className = "zoom-lens";
      lens.style.backgroundImage = "url('" + src + "')";
      piece.appendChild(lens);
      var ZOOM = 2.4;
      function inRoom() {
        var host = piece.closest("[data-stage]");
        return !!(host && host.classList.contains("room"));
      }
      function zoomHost() { return piece.closest("[data-stage]"); }
      piece.addEventListener("mouseenter", function () {
        if (inRoom()) return;
        lens.style.display = "block";
        var host = zoomHost();
        if (host) host.classList.add("zoomed");
        dismissZoomHint();
      });
      piece.addEventListener("mouseleave", function () {
        lens.style.display = "none";
        var host = zoomHost();
        if (host) host.classList.remove("zoomed");
      });
      piece.addEventListener("mousemove", function (e) {
        if (inRoom()) { lens.style.display = "none"; return; }
        var r = piece.getBoundingClientRect();
        var x = e.clientX - r.left, y = e.clientY - r.top;
        if (x < 0 || y < 0 || x > r.width || y > r.height) { lens.style.display = "none"; return; }
        lens.style.display = "block";
        var ls = lens.offsetWidth || 150;
        lens.style.backgroundSize = (r.width * ZOOM) + "px " + (r.height * ZOOM) + "px";
        lens.style.backgroundPosition = (-(x * ZOOM - ls / 2)) + "px " + (-(y * ZOOM - ls / 2)) + "px";
        lens.style.left = (x - ls / 2) + "px";
        lens.style.top = (y - ls / 2) + "px";
      });
    }
    visualiser.querySelectorAll("[data-zoom]").forEach(function (piece) {
      attachMagnifier(piece, piece.getAttribute("data-zoom-src"));
    });

    // delivery option selection (cosmetic — real delivery is chosen at checkout)
    var delivery = root.querySelector("[data-delivery]");
    if (delivery) {
      delivery.addEventListener("click", function (e) {
        var row = e.target.closest("[data-deliv]");
        if (!row) return;
        delivery.querySelectorAll("[data-deliv]").forEach(function (x) { x.setAttribute("data-active", x === row ? "true" : "false"); });
      });
    }

    // add-to-basket feedback state
    if (form) {
      form.addEventListener("submit", function () {
        if (!addBtn.hasAttribute("disabled")) { addBtn.classList.add("added"); addLabel.textContent = "✓ Added to basket"; }
      });
    }

    visualiserApi.refresh = updatePreview;
    visualiserApi.setArtwork = function (artwork) {
      replaceArtwork(artwork);
      return visualiserApi;
    };
    visualiserApi.getOptions = function () {
      var activeView = visualiser.querySelector('.view-btn[aria-pressed="true"]');
      var activeMountColour = controlQuery('[data-mount-colour] [aria-pressed="true"]');
      return {
        frameStyle: controlValue("frametype") || "Classic",
        colour: controlValue("frame") || "Oak",
        size: controlValue("size") || "Medium",
        mount: controlValue("mount") || "Mounted",
        mountColour: activeMountColour
          ? activeMountColour.getAttribute("data-name")
          : (visualiser.dataset.initialMountColour || "White"),
        scene: activeView && activeView.getAttribute("data-view") === "room"
          ? activeView.getAttribute("data-room")
          : "artwork"
      };
    };

    // Share/download links use the Stage 1 URL built from the same live state
    // that drives the render. No configuration or uploaded photo is stored.
    function configuredProductUrl() {
      var options = visualiserApi.getOptions();
      var path = product.handle ? "/products/" + encodeURIComponent(product.handle) : location.pathname;
      var values = [
        ["frame", options.frameStyle],
        ["colour", options.colour],
        ["size", options.size],
        ["mount", options.mount],
        ["mountcolour", options.mountColour],
        ["scene", options.scene]
      ];
      var query = values.filter(function (entry) {
        return entry[1] != null && String(entry[1]).trim() !== "";
      }).map(function (entry) {
        return encodeURIComponent(entry[0]) + "=" + encodeURIComponent(String(entry[1]));
      }).join("&");
      return location.origin + path + (query ? "?" + query : "");
    }
    visualiserApi.getConfiguredUrl = configuredProductUrl;

    (function initShareAndDownload() {
      var shareButton = root.querySelector("[data-share-look]");
      var downloadButton = root.querySelector("[data-download-look]");
      var shareStatus = root.querySelector("[data-share-look-status]");
      if ((!shareButton && !downloadButton) || !shareStatus || !isProductPage) return;
      var statusTimer = null;

      function fallbackCopy(url, focusTarget) {
        var field = document.createElement("textarea");
        field.value = url;
        field.setAttribute("readonly", "");
        field.setAttribute("aria-hidden", "true");
        field.style.position = "fixed";
        field.style.left = "-9999px";
        document.body.appendChild(field);
        field.select();
        field.setSelectionRange(0, field.value.length);
        var copied = false;
        try { copied = document.execCommand("copy"); } catch (error) {}
        field.remove();
        if (focusTarget) focusTarget.focus();
        return copied;
      }

      function showStatus(message, isError) {
        clearTimeout(statusTimer);
        shareStatus.textContent = message;
        shareStatus.toggleAttribute("data-error", !!isError);
        shareStatus.classList.add("is-visible");
        statusTimer = setTimeout(function () {
          shareStatus.classList.remove("is-visible");
        }, 2400);
      }

      function copyText(url, focusTarget) {
        return new Promise(function (resolve) {
          function legacyCopy() { resolve(fallbackCopy(url, focusTarget)); }
          if (navigator.clipboard && typeof navigator.clipboard.writeText === "function") {
            try {
              Promise.resolve(navigator.clipboard.writeText(url)).then(function () {
                resolve(true);
              }).catch(legacyCopy);
            } catch (error) {
              legacyCopy();
            }
          } else {
            legacyCopy();
          }
        });
      }

      function stripHtml(html) {
        var el = document.createElement("div");
        el.innerHTML = html || "";
        return String(el.textContent || el.innerText || "").replace(/\s+/g, " ").trim();
      }

      function shareHeadline() {
        var title = String(product.title || "Artwork").trim();
        var vendor = String(product.vendor || "").trim();
        return vendor ? title + " by " + vendor : title;
      }

      function shareAbout() {
        var about = stripHtml(product.description || "");
        if (about.length <= 280) return about;
        return about.slice(0, 279).replace(/\s+\S*$/, "") + "…";
      }

      function shareFrameLine() {
        var options = visualiserApi.getOptions();
        return [options.frameStyle, options.colour, options.size].filter(Boolean).join(" · ");
      }

      function buildCaption(url) {
        var parts = [shareHeadline()];
        var about = shareAbout();
        var frameLine = shareFrameLine();
        if (about) parts.push(about);
        if (frameLine) parts.push(frameLine);
        parts.push(url);
        return parts.join("\n\n");
      }

      function featuredImageUrl() {
        var image = product.featured_image;
        if (!image) return "";
        if (typeof image === "string") return image;
        return image.src || image.url || "";
      }

      function canSharePayload(payload) {
        if (!navigator.share) return false;
        if (typeof navigator.canShare !== "function") return true;
        try {
          return navigator.canShare(payload);
        } catch (error) {
          return false;
        }
      }

      function nativeShare(payload) {
        return navigator.share(payload).then(function () {
          return true;
        }).catch(function (error) {
          if (error && error.name === "AbortError") return false;
          throw error;
        });
      }

      var sharePanel = root.querySelector("[data-share-look-panel]");
      var copyCaptionButton = root.querySelector("[data-share-copy-caption]");
      var copyLinkButton = root.querySelector("[data-share-copy-link]");
      var shareWa = root.querySelector("[data-share-wa]");
      var shareFb = root.querySelector("[data-share-fb]");
      var shareX = root.querySelector("[data-share-x]");
      var sharePin = root.querySelector("[data-share-pin]");
      var lastShareCaption = "";
      var lastShareUrl = "";

      function openSharePanel(url, caption) {
        lastShareUrl = url;
        lastShareCaption = caption;
        if (!sharePanel) {
          return copyText(caption, shareButton).then(function (copied) {
            if (copied) showStatus("Caption copied!", false);
            else window.prompt("Copy this caption:", caption);
          });
        }
        var encodedUrl = encodeURIComponent(url);
        var encodedCaption = encodeURIComponent(caption);
        var encodedTitle = encodeURIComponent(shareHeadline());
        var pinImage = featuredImageUrl();
        if (shareWa) shareWa.href = "https://wa.me/?text=" + encodedCaption;
        if (shareFb) shareFb.href = "https://www.facebook.com/sharer/sharer.php?u=" + encodedUrl;
        if (shareX) shareX.href = "https://twitter.com/intent/tweet?text=" + encodedTitle + "&url=" + encodedUrl;
        if (sharePin) {
          sharePin.href = "https://pinterest.com/pin/create/button/?url=" + encodedUrl +
            "&description=" + encodedCaption +
            (pinImage ? "&media=" + encodeURIComponent(pinImage) : "");
        }
        sharePanel.hidden = false;
        showStatus("Copy the caption, then share.", false);
      }

      if (copyCaptionButton) {
        copyCaptionButton.addEventListener("click", function () {
          var caption = lastShareCaption || buildCaption(configuredProductUrl());
          copyText(caption, copyCaptionButton).then(function (copied) {
            if (copied) showStatus("Caption copied!", false);
            else window.prompt("Copy this caption:", caption);
          });
        });
      }

      if (copyLinkButton) {
        copyLinkButton.addEventListener("click", function () {
          var url = lastShareUrl || configuredProductUrl();
          copyText(url, copyLinkButton).then(function (copied) {
            if (copied) showStatus("Link copied!", false);
            else window.prompt("Copy this configuration link:", url);
          });
        });
      }

      function loadImage(src) {
        return new Promise(function (resolve, reject) {
          var image = new Image();
          image.onload = function () { resolve(image); };
          image.onerror = reject;
          image.src = src;
        });
      }

      function qrImage(url) {
        if (typeof window.qrcode !== "function") return Promise.reject(new Error("QR library unavailable"));
        var qr = window.qrcode(0, "M");
        qr.addData(url);
        qr.make();
        return loadImage(qr.createDataURL(7, 4));
      }

      function fitCanvasText(context, text, maxWidth) {
        text = String(text || "");
        if (context.measureText(text).width <= maxWidth) return text;
        while (text.length > 1 && context.measureText(text + "…").width > maxWidth) {
          text = text.slice(0, -1);
        }
        return text + "…";
      }

      function captureStage() {
        if (typeof window.html2canvas !== "function") {
          return Promise.reject(new Error("Capture library unavailable"));
        }
        var bounds = stage.getBoundingClientRect();
        var desiredScale = 2;
        var cappedScale = Math.sqrt(12000000 / Math.max(1, bounds.width * bounds.height));
        var scale = Math.max(1, Math.min(desiredScale, cappedScale));

        // html2canvas approximates filter/box-shadow/clip-path/mix-blend-mode.
        // Keep mitres and shadows, but flatten the subtle room filter and grain
        // overlay in the cloned capture rather than risk a broken composite.
        return window.html2canvas(stage, {
          scale: scale,
          useCORS: true,
          allowTaint: false,
          backgroundColor: null,
          imageTimeout: 15000,
          logging: false,
          removeContainer: true,
          onclone: function (clonedDocument) {
            var clonedStage = clonedDocument.querySelector("[data-stage]");
            if (!clonedStage) return;
            clonedStage.setAttribute("data-capture", "true");
            clonedStage.querySelectorAll("*").forEach(function (node) {
              node.style.transition = "none";
              node.style.animation = "none";
            });
            clonedStage.querySelectorAll(
              "[data-selection-summary],.zoom-hint,[data-your-room-ui],[data-your-room-light],[data-arrange-ui],[data-position-tool-ui]"
            ).forEach(function (node) { node.style.display = "none"; });
            var clonedWrap = clonedStage.querySelector("[data-framewrap]");
            if (clonedWrap) clonedWrap.style.filter = "none";
            hardenFrameMitres(clonedStage);
          }
        }).then(function (canvas) {
          return paintMitredRails(canvas, stage);
        });
      }

      function composeMockup(sceneCanvas, qr, url) {
        var options = visualiserApi.getOptions();
        var footerHeight = Math.round(Math.max(170, Math.min(240, sceneCanvas.width * 0.2)));
        var output = document.createElement("canvas");
        output.width = sceneCanvas.width;
        output.height = sceneCanvas.height + footerHeight;
        var context = output.getContext("2d");
        var padding = Math.round(Math.max(24, sceneCanvas.width * 0.035));
        var qrSize = Math.round(Math.min(footerHeight - 36, sceneCanvas.width * 0.18));
        var textWidth = output.width - padding * 3 - qrSize;
        var titleSize = Math.round(Math.max(22, Math.min(36, output.width * 0.032)));
        var detailSize = Math.round(Math.max(14, Math.min(22, output.width * 0.018)));
        var sceneName = options.scene === "yours" ? "Your room" :
          options.scene.charAt(0).toUpperCase() + options.scene.slice(1);
        var details = [
          options.frameStyle,
          options.colour,
          options.size,
          options.mount,
          options.mountColour,
          sceneName
        ].filter(Boolean).join(" · ");

        context.fillStyle = "#FAF8F5";
        context.fillRect(0, 0, output.width, output.height);
        context.drawImage(sceneCanvas, 0, 0);
        context.strokeStyle = "#E3DDD3";
        context.beginPath();
        context.moveTo(0, sceneCanvas.height + 0.5);
        context.lineTo(output.width, sceneCanvas.height + 0.5);
        context.stroke();

        context.fillStyle = "#8C6B4A";
        context.font = "600 " + detailSize + "px sans-serif";
        context.fillText("THE ARTFOLIO", padding, sceneCanvas.height + padding + detailSize);
        context.fillStyle = "#1B1A18";
        context.font = "600 " + titleSize + "px Georgia, serif";
        context.fillText(
          fitCanvasText(context, product.title || "Configured artwork", textWidth),
          padding,
          sceneCanvas.height + padding + detailSize + titleSize + 12
        );
        context.fillStyle = "#625E57";
        context.font = detailSize + "px sans-serif";
        context.fillText(
          fitCanvasText(context, details, textWidth),
          padding,
          sceneCanvas.height + padding + detailSize + titleSize + detailSize + 28
        );
        context.fillStyle = "#625E57";
        context.font = Math.max(12, detailSize - 2) + "px sans-serif";
        context.fillText("Scan to view this configuration", padding, output.height - padding);

        context.imageSmoothingEnabled = false;
        context.drawImage(qr, output.width - padding - qrSize, sceneCanvas.height + 18, qrSize, qrSize);
        context.imageSmoothingEnabled = true;
        output.setAttribute("data-share-url", url);
        return output;
      }

      function canvasBlob(canvas) {
        return new Promise(function (resolve, reject) {
          try {
            canvas.toBlob(function (blob) {
              if (blob) resolve(blob);
              else reject(new Error("PNG export failed"));
            }, "image/png");
          } catch (error) {
            reject(error);
          }
        });
      }

      function mockupBlob(url) {
        return Promise.all([captureStage(), qrImage(url)]).then(function (results) {
          return canvasBlob(composeMockup(results[0], results[1], url));
        });
      }

      function mockupFile(blob) {
        var handle = product.handle || "artwork";
        var name = "theartfolio-" + handle + ".png";
        try {
          return new File([blob], name, { type: "image/png" });
        } catch (error) {
          return blob;
        }
      }

      function triggerDownload(blob, sceneName) {
        var objectUrl = URL.createObjectURL(blob);
        var link = document.createElement("a");
        var handle = product.handle || "artwork";
        link.href = objectUrl;
        link.download = "theartfolio-" + handle + "-" + sceneName + ".png";
        document.body.appendChild(link);
        link.click();
        link.remove();
        setTimeout(function () { URL.revokeObjectURL(objectUrl); }, 1000);
      }

      function captureFailure(url, focusTarget) {
        return copyText(url, focusTarget || downloadButton).then(function (copied) {
          if (copied) {
            showStatus("Image unavailable. Link copied instead.", true);
            return;
          }
          showStatus("Image unavailable. Copy the link shown.", true);
          window.prompt("Copy this configuration link:", url);
        });
      }

      function shareWithNative(url, caption, blob) {
        var file = blob ? mockupFile(blob) : null;
        var withFile = file ? { files: [file], title: shareHeadline(), text: caption, url: url } : null;
        var textOnly = { title: shareHeadline(), text: caption, url: url };
        var fileOnly = file ? { files: [file], title: shareHeadline(), text: caption } : null;

        function tryShare(payload) {
          if (!payload || !canSharePayload(payload)) return Promise.resolve(null);
          return nativeShare(payload).then(function (shared) {
            return shared ? true : false;
          }).catch(function () {
            return null;
          });
        }

        return tryShare(withFile).then(function (shared) {
          if (shared === true) return true;
          if (shared === false) return false;
          return tryShare(fileOnly).then(function (sharedFile) {
            if (sharedFile === true) return true;
            if (sharedFile === false) return false;
            return tryShare(textOnly).then(function (sharedText) {
              if (sharedText === true) return true;
              if (sharedText === false) return false;
              return null;
            });
          });
        });
      }

      function canShareFiles() {
        if (!navigator.share || typeof File === "undefined") return false;
        try {
          var probe = new File(["t"], "t.png", { type: "image/png" });
          return canSharePayload({ files: [probe] });
        } catch (error) {
          return false;
        }
      }

      function hideShareStatus() {
        clearTimeout(statusTimer);
        shareStatus.textContent = "";
        shareStatus.removeAttribute("data-error");
        shareStatus.classList.remove("is-visible");
      }

      if (shareButton) {
        shareButton.addEventListener("click", function () {
          if (shareButton.disabled) return;
          var url = configuredProductUrl();
          var caption = buildCaption(url);
          lastShareUrl = url;
          lastShareCaption = caption;

          function finishShare(shared) {
            if (shared === true) {
              showStatus("Shared!", false);
              return;
            }
            if (shared === false) {
              hideShareStatus();
              return;
            }
            openSharePanel(url, caption);
          }

          if (canShareFiles()) {
            shareButton.disabled = true;
            shareButton.setAttribute("aria-busy", "true");
            showStatus("Preparing image…", false);
            mockupBlob(url)
              .then(function (blob) {
                return shareWithNative(url, caption, blob);
              })
              .catch(function () {
                return shareWithNative(url, caption, null);
              })
              .then(finishShare)
              .catch(function () {
                openSharePanel(url, caption);
              })
              .finally(function () {
                shareButton.disabled = false;
                shareButton.removeAttribute("aria-busy");
              });
            return;
          }

          if (navigator.share) {
            shareWithNative(url, caption, null).then(finishShare).catch(function () {
              openSharePanel(url, caption);
            });
            return;
          }

          openSharePanel(url, caption);
        });
      }

      if (downloadButton) {
        downloadButton.addEventListener("click", function () {
          if (downloadButton.disabled) return;
          var url = configuredProductUrl();
          var options = visualiserApi.getOptions();
          downloadButton.disabled = true;
          downloadButton.setAttribute("aria-busy", "true");
          showStatus("Preparing image…", false);

          mockupBlob(url)
            .then(function (blob) {
              triggerDownload(blob, options.scene || "artwork");
              showStatus("Mockup downloaded!", false);
            })
            .catch(function () {
              return captureFailure(url, downloadButton);
            })
            .finally(function () {
              downloadButton.disabled = false;
              downloadButton.removeAttribute("aria-busy");
            });
        });
      }
    })();

    visualiserApi.setOptions = function (options) {
      options = options || {};
      function choose(type, value, dataKey) {
        if (value == null) return;
        visualiser.dataset[dataKey] = value;
        var match = Array.prototype.find.call(controlQueryAll('[data-pp-type="' + type + '"]'), function (button) {
          return String(button.getAttribute("data-value")).toLowerCase() === String(value).toLowerCase();
        });
        if (match && match.getAttribute("aria-pressed") !== "true") match.click();
      }
      choose("frametype", options.frameStyle, "initialFrame");
      choose("frame", options.colour, "initialColour");
      choose("size", options.size, "initialSize");
      choose("mount", options.mount, "initialMount");
      if (options.mountColour != null) {
        visualiser.dataset.initialMountColour = options.mountColour;
        var mountColourButton = Array.prototype.find.call(controlQueryAll("[data-mount-colour] [data-name]"), function (button) {
          return String(button.getAttribute("data-name")).toLowerCase() === String(options.mountColour).toLowerCase();
        });
        if (mountColourButton && mountColourButton.getAttribute("aria-pressed") !== "true") mountColourButton.click();
      }
      if (options.scene != null) {
        var sceneKey = String(options.scene).toLowerCase();
        var sceneBtn = sceneKey === "art" || sceneKey === "artwork"
          ? root.querySelector('[data-view="art"]')
          : root.querySelector('[data-view="room"][data-room="' + sceneKey + '"]');
        if (sceneBtn) sceneBtn.click();
      }
      updatePreview();
    };

    // Stage 1 — pre-select from URL query params (discovery/remix links).
    // Supported params (case/format tolerant; invalid values ignored):
    //   frame       → Frame style (Classic / Swoop / Venice / Deep Classic)
    //   colour      → Frame colour (Oak, Gold, Antique Gold, Venice finishes, …)
    //   size        → Size (Small / Medium / Large …)
    //   mount       → Mount (Mounted / No mount; also mounted, none, no-mount)
    //   mountcolour → Mount colour (Snow White / Fresh Linen / Warm Sand / French Grey / Olive / Black)
    //   scene       → Preview scene (artwork / lounge / bedroom / kitchen / office / conservatory / yours)
    (function applyUrlParams() {
      var qs = location.search;
      if (!qs || qs.length < 2) return;
      var params = new URLSearchParams(qs);
      var keys = ["frame", "colour", "color", "size", "mount", "mountcolour", "mount_colour", "mount-colour", "scene"];
      var any = false;
      for (var ki = 0; ki < keys.length; ki++) {
        var raw = params.get(keys[ki]);
        if (raw != null && String(raw).replace(/^\s+|\s+$/g, "") !== "") { any = true; break; }
      }
      if (!any) return;

      function normKey(s) {
        return String(s || "")
          .toLowerCase()
          .replace(/[+_\-]+/g, " ")
          .replace(/\s+/g, " ")
          .replace(/^\s+|\s+$/g, "");
      }
      function valuesEqual(a, b) {
        if (normKey(a) === normKey(b)) return true;
        var ca = colourKey(a), cb = colourKey(b);
        if (ca && cb && ca === cb) return true;
        return false;
      }
      function findBtn(nodes, wanted) {
        if (!wanted) return null;
        var list = Array.prototype.slice.call(nodes || []);
        for (var i = 0; i < list.length; i++) {
          var b = list[i];
          if (b.disabled || b.hidden) continue;
          var v = b.getAttribute("data-value") || b.getAttribute("data-name") || "";
          if (valuesEqual(v, wanted)) return b;
        }
        return null;
      }
      function clickBtn(btn) {
        if (btn) btn.click();
      }
      function selectPp(type, wanted) {
        if (!wanted) return;
        clickBtn(findBtn(controlQueryAll('[data-pp-type="' + type + '"]'), wanted));
      }
      function selectVariant(words, wanted) {
        if (!wanted || !product.options) return;
        product.options.forEach(function (optName, i) {
          if (!looksLike(optName, words)) return;
          var group = root.querySelector('[data-option-index="' + (i + 1) + '"]');
          if (!group) return;
          clickBtn(findBtn(group.querySelectorAll("[data-value]"), wanted));
        });
      }
      function param() {
        for (var i = 0; i < arguments.length; i++) {
          var v = params.get(arguments[i]);
          if (v != null && String(v).replace(/^\s+|\s+$/g, "") !== "") return v;
        }
        return null;
      }

      // Order: frame style → colour → size → mount → mount colour → scene
      var frameStyle = param("frame");
      if (frameStyle) {
        selectPp("frametype", frameStyle);
        selectVariant(["frame"], frameStyle);
      }

      var colour = param("colour", "color");
      if (colour) {
        selectPp("frame", colour);
        selectVariant(["frame"], colour);
      }

      var size = param("size");
      if (size) {
        selectPp("size", size);
        selectVariant(["size", "dimension"], size);
      }

      var mount = param("mount");
      if (mount) {
        var mn = normKey(mount);
        var mountVal = mount;
        if (/^(mounted|mount|yes)$/.test(mn)) mountVal = "Mounted";
        else if (/^(none|no mount|no|unmounted)$/.test(mn)) mountVal = "No mount";
        selectPp("mount", mountVal);
        selectVariant(["mount"], mountVal);
      }

      var mountColour = param("mountcolour", "mount_colour", "mount-colour");
      if (mountColour && mcGroup) {
        clickBtn(findBtn(mcGroup.querySelectorAll("[data-name]"), mountColour));
      }

      var scene = param("scene");
      if (scene) {
        var sn = normKey(scene);
        if (sn === "art" || sn === "artwork") {
          clickBtn(root.querySelector('[data-view="art"]'));
        } else {
          var roomKey = sn.replace(/\s+/g, "");
          if (roomKey === "yourroom" || roomKey === "myroom") roomKey = "yours";
          clickBtn(root.querySelector('[data-view="room"][data-room="' + roomKey + '"]'));
        }
      }
    })();

    (function bindStaffFrameDefaults() {
      if (!isProductPage) return;
      var staffBound = false;
      var pinKey = "artfolio-promote-pin";
      var staffUiKey = "artfolio-staff-ui";

      function hasStaffQuery() {
        try { return /(?:\?|&)staff=1(?:&|$)/.test(location.search || ""); } catch (err) { return false; }
      }
      function hasStoredStaff() {
        try {
          return !!(localStorage.getItem(pinKey) || sessionStorage.getItem(pinKey) || localStorage.getItem(staffUiKey) === "1");
        } catch (err) { return false; }
      }
      function hasAdminChrome() {
        var html = document.documentElement;
        if (html.classList.contains("has-shopify-admin-chrome") || html.classList.contains("shopify-design-mode")) return true;
        try {
          if (window.Shopify && (Shopify.designMode || Shopify.visualPreviewMode)) return true;
        } catch (err) {}
        return !!(
          document.getElementById("PBarNextFrameWrapper") ||
          document.getElementById("PBarNextFrame") ||
          document.getElementById("admin-bar-iframe") ||
          document.getElementById("PreviewBarContainer") ||
          document.querySelector("iframe[id*='admin-bar'], iframe[id*='preview-bar'], [id*='PBarNext'], .shopify-preview-bar, #shopify-preview-bar")
        );
      }
      function detectStaffSession() {
        var themeCfg = window.theme || {};
        if (themeCfg.isStaff || hasStaffQuery() || hasStoredStaff() || hasAdminChrome()) return true;
        try {
          var ref = String(document.referrer || "");
          if (/admin\.shopify\.com/i.test(ref) || /\/admin(\/|$|\?)/i.test(ref)) return true;
        } catch (err) {}
        try {
          if (/(?:preview_theme_id|preview_token)/.test(location.search || "")) return true;
        } catch (err) {}
        return false;
      }
      function rememberStaffUi() {
        try { localStorage.setItem(staffUiKey, "1"); } catch (err) {}
      }

      function startStaffPanel() {
        if (staffBound) return;
        if (!detectStaffSession()) return;
        staffBound = true;
        rememberStaffUi();
        bindStaffPanel();
      }

      function bindStaffPanel() {
      var themeCfg = window.theme || {};
      if (!document.getElementById("staff-frame-defaults")) {
        var dummyForm = document.createElement("form");
        dummyForm.id = "staff-frame-defaults";
        dummyForm.hidden = true;
        dummyForm.setAttribute("aria-hidden", "true");
        root.insertBefore(dummyForm, root.firstChild);
      }

      function staffPanelMarkup() {
        return '<button type="button" class="pdp-staff-defaults__toggle" data-staff-defaults-toggle aria-expanded="false">' +
          '<span class="pdp-staff-defaults__kicker">Staff</span>' +
          '<span class="pdp-staff-defaults__toggle-label" data-staff-defaults-summary></span>' +
          '<span class="pdp-staff-defaults__chevron" aria-hidden="true"></span></button>' +
          '<div class="pdp-staff-defaults__body" data-staff-defaults-body hidden>' +
          '<div class="pdp-staff-defaults__row"><div>' +
          '<p class="pdp-staff-defaults__title">Set this look as the product default</p>' +
          '<p class="pdp-staff-defaults__summary" data-staff-defaults-summary></p></div>' +
          '<button type="button" class="pdp-staff-defaults__save" data-staff-defaults-save>Set as default</button></div>' +
          '<fieldset class="pdp-staff-defaults__feed" data-staff-feed>' +
          '<legend>Shopping-feed image</legend>' +
          '<p class="pdp-staff-defaults__feed-copy">Google Shopping uses the <strong>second</strong> product photo as the framed look. Preview a new render first — nothing is written until you say it looks right. The first image — the unframed print — is never changed.</p>' +
          '<div class="pdp-staff-defaults__feed-current" data-staff-feed-current hidden>' +
          '<button type="button" class="pdp-staff-defaults__enlarge" data-staff-feed-enlarge aria-label="Enlarge the current 2nd image">' +
          '<img alt="Current shopping-feed image" width="96" height="96" data-staff-feed-thumb></button>' +
          '<p data-staff-feed-current-label>Current 2nd image</p></div>' +
          '<div class="pdp-staff-defaults__actions"><button type="button" class="pdp-staff-defaults__ghost" data-staff-feed-preview>Preview framed render</button></div>' +
          '<div class="pdp-staff-defaults__preview" data-staff-feed-preview-box hidden>' +
          '<p class="pdp-staff-defaults__preview-label">New framed render — not saved yet</p>' +
          '<button type="button" class="pdp-staff-defaults__enlarge pdp-staff-defaults__enlarge--preview" data-staff-preview-enlarge aria-label="Enlarge the framed render preview">' +
          '<img alt="Framed render preview" data-staff-feed-preview-img></button>' +
          '<div class="pdp-staff-defaults__preview-tools">' +
          '<label class="pdp-staff-defaults__keep" data-staff-feed-keep-wrap hidden><input type="checkbox" form="staff-frame-defaults" data-staff-feed-keep> Keep the old 2nd image in the gallery (moved to 3rd)</label>' +
          '<button type="button" class="pdp-staff-defaults__save" data-staff-feed-use>Looks right — use as 2nd image</button>' +
          '<button type="button" class="pdp-staff-defaults__ghost" data-staff-feed-retry>Try again</button>' +
          '<button type="button" class="pdp-staff-defaults__ghost" data-staff-feed-discard>Discard</button></div></div>' +
          '<label class="pdp-staff-defaults__choice pdp-staff-defaults__choice--warn" data-staff-feed-delete-wrap hidden>' +
          '<input type="checkbox" form="staff-frame-defaults" data-staff-feed-delete> Remove the current 2nd image, don’t add a new one</label>' +
          '<p class="pdp-staff-defaults__warn" data-staff-feed-warn hidden>This deletes the 2nd product image shown above. It cannot be undone from here.</p></fieldset>' +
          '<fieldset class="pdp-staff-defaults__feed" data-staff-scene>' +
          '<legend>In the room</legend>' +
          '<p class="pdp-staff-defaults__feed-copy">Generate a lifestyle photograph of this framed look — same rooms and prompts as Promote. It lands on In the room only. It does not preview or replace the shopping-feed image.</p>' +
          '<label class="pdp-staff-defaults__field"><span>Room</span><span class="pdp-staff-defaults__select"><select form="staff-frame-defaults" data-staff-scene-room><option value="auto">Auto — match the print</option></select></span></label>' +
          '<div class="pdp-staff-defaults__actions"><button type="button" class="pdp-staff-defaults__ghost" data-staff-scene-generate>Generate scene</button></div>' +
          '<p class="pdp-staff-defaults__progress" data-staff-scene-progress hidden></p>' +
          '<div class="pdp-staff-defaults__preview" data-staff-scene-preview-box hidden>' +
          '<p class="pdp-staff-defaults__preview-label" data-staff-scene-preview-label>Lifestyle — not on the product page yet</p>' +
          '<img alt="Lifestyle preview" data-staff-scene-preview-img>' +
          '<div class="pdp-staff-defaults__preview-tools">' +
          '<label class="pdp-staff-defaults__field pdp-staff-defaults__field--wide"><span>Caption</span>' +
          '<textarea form="staff-frame-defaults" data-staff-scene-caption-text maxlength="400" rows="3"></textarea>' +
          '<span class="pdp-staff-defaults__hint">Shoppers see this under the photograph. Edit it before you add the scene.</span></label>' +
          '<label class="pdp-staff-defaults__keep"><input type="checkbox" form="staff-frame-defaults" data-staff-scene-caption checked> Show caption on the product page</label>' +
          '<button type="button" class="pdp-staff-defaults__save" data-staff-scene-save hidden>Looks right — save to In the room</button>' +
          '<button type="button" class="pdp-staff-defaults__ghost" data-staff-scene-retry>Try another</button>' +
          '<button type="button" class="pdp-staff-defaults__ghost" data-staff-scene-discard>Discard</button></div></div></fieldset>' +
          '<fieldset class="pdp-staff-defaults__feed" data-staff-rooms>' +
          '<legend>Shop by room</legend>' +
          '<p class="pdp-staff-defaults__feed-copy">Tick the rooms this print belongs in. That adds a <code>room-*</code> tag so it appears on the matching collection.</p>' +
          '<div class="pdp-staff-defaults__rooms" data-staff-rooms-list>' +
          '<label class="pdp-staff-defaults__choice"><input type="checkbox" form="staff-frame-defaults" data-staff-room value="lounge"> Sitting room</label>' +
          '<label class="pdp-staff-defaults__choice"><input type="checkbox" form="staff-frame-defaults" data-staff-room value="bedroom"> Bedroom</label>' +
          '<label class="pdp-staff-defaults__choice"><input type="checkbox" form="staff-frame-defaults" data-staff-room value="office"> Study</label>' +
          '<label class="pdp-staff-defaults__choice"><input type="checkbox" form="staff-frame-defaults" data-staff-room value="kitchen"> Kitchen</label>' +
          '<label class="pdp-staff-defaults__choice"><input type="checkbox" form="staff-frame-defaults" data-staff-room value="conservatory"> Conservatory</label>' +
          '<label class="pdp-staff-defaults__choice"><input type="checkbox" form="staff-frame-defaults" data-staff-room value="dining-room"> Dining room</label>' +
          '<label class="pdp-staff-defaults__choice"><input type="checkbox" form="staff-frame-defaults" data-staff-room value="hallway"> Hallway</label>' +
          '</div><div class="pdp-staff-defaults__actions">' +
          '<button type="button" class="pdp-staff-defaults__save" data-staff-rooms-save>Save rooms</button></div></fieldset>' +
          '<div class="pdp-staff-defaults__pin" data-staff-defaults-pin hidden>' +
          '<label for="StaffFramePin">Staff PIN</label>' +
          '<input id="StaffFramePin" type="password" inputmode="numeric" autocomplete="off" form="staff-frame-defaults" data-staff-defaults-pin-input>' +
          '</div><p class="pdp-staff-defaults__status" data-staff-defaults-status role="status" aria-live="polite"></p></div>';
      }

      var box = root.querySelector("[data-staff-defaults]");
      if (!box) {
        var firstOpt = root.querySelector("form .opt");
        var form = root.querySelector("form");
        box = document.createElement("aside");
        box.className = "pdp-staff-defaults";
        box.setAttribute("data-staff-defaults", "");
        box.innerHTML = staffPanelMarkup();
        box.setAttribute("hidden", "");
        if (firstOpt && firstOpt.parentNode) firstOpt.parentNode.insertBefore(box, firstOpt);
        else if (form) form.insertBefore(box, form.firstChild);
        else return;
      }
      if (!box.querySelector("[data-staff-defaults-toggle]")) {
        var existing = document.createElement("div");
        existing.className = "pdp-staff-defaults__body";
        existing.setAttribute("data-staff-defaults-body", "");
        existing.hidden = true;
        while (box.firstChild) existing.appendChild(box.firstChild);
        var toggle = document.createElement("button");
        toggle.type = "button";
        toggle.className = "pdp-staff-defaults__toggle";
        toggle.setAttribute("data-staff-defaults-toggle", "");
        toggle.setAttribute("aria-expanded", "false");
        toggle.innerHTML = '<span class="pdp-staff-defaults__kicker">Staff</span>' +
          '<span class="pdp-staff-defaults__toggle-label" data-staff-defaults-summary></span>' +
          '<span class="pdp-staff-defaults__chevron" aria-hidden="true"></span>';
        box.appendChild(toggle);
        box.appendChild(existing);
      }

      var toggleBtn = box.querySelector("[data-staff-defaults-toggle]");
      var bodyEl = box.querySelector("[data-staff-defaults-body]");
      var summaries = box.querySelectorAll("[data-staff-defaults-summary]");
      var saveBtn = box.querySelector("[data-staff-defaults-save]");
      var status = box.querySelector("[data-staff-defaults-status]");
      var pinWrap = box.querySelector("[data-staff-defaults-pin]");
      var pinInput = box.querySelector("[data-staff-defaults-pin-input]");
      var feedThumb = box.querySelector("[data-staff-feed-thumb]");
      var feedCurrent = box.querySelector("[data-staff-feed-current]");
      var feedCurrentLabel = box.querySelector("[data-staff-feed-current-label]");
      var keepWrap = box.querySelector("[data-staff-feed-keep-wrap]");
      var keepInput = box.querySelector("[data-staff-feed-keep]");
      var deleteWrap = box.querySelector("[data-staff-feed-delete-wrap]");
      var deleteInput = box.querySelector("[data-staff-feed-delete]");
      var warnEl = box.querySelector("[data-staff-feed-warn]");
      var previewBtn = box.querySelector("[data-staff-feed-preview]");
      var previewBox = box.querySelector("[data-staff-feed-preview-box]");
      var previewImg = box.querySelector("[data-staff-feed-preview-img]");
      var useFeedBtn = box.querySelector("[data-staff-feed-use]");
      var retryFeedBtn = box.querySelector("[data-staff-feed-retry]");
      var discardFeedBtn = box.querySelector("[data-staff-feed-discard]");
      var sceneRoomEl = box.querySelector("[data-staff-scene-room]");
      var sceneGenerateBtn = box.querySelector("[data-staff-scene-generate]");
      var sceneProgress = box.querySelector("[data-staff-scene-progress]");
      var scenePreviewBox = box.querySelector("[data-staff-scene-preview-box]");
      var scenePreviewImg = box.querySelector("[data-staff-scene-preview-img]");
      var scenePreviewLabel = box.querySelector("[data-staff-scene-preview-label]");
      var sceneSaveBtn = box.querySelector("[data-staff-scene-save]");
      var sceneRetryBtn = box.querySelector("[data-staff-scene-retry]");
      var sceneDiscardBtn = box.querySelector("[data-staff-scene-discard]");
      var sceneCaptionInput = box.querySelector("[data-staff-scene-caption]");
      var sceneCaptionText = box.querySelector("[data-staff-scene-caption-text]");
      if (!box.querySelector("[data-staff-rooms]")) {
        var pinAnchor = box.querySelector("[data-staff-defaults-pin]");
        var roomsFs = document.createElement("fieldset");
        roomsFs.className = "pdp-staff-defaults__feed";
        roomsFs.setAttribute("data-staff-rooms", "");
        roomsFs.innerHTML = '<legend>Shop by room</legend>' +
          '<p class="pdp-staff-defaults__feed-copy">Tick the rooms this print belongs in. That adds a <code>room-*</code> tag so it appears on the matching collection.</p>' +
          '<div class="pdp-staff-defaults__rooms" data-staff-rooms-list>' +
          '<label class="pdp-staff-defaults__choice"><input type="checkbox" form="staff-frame-defaults" data-staff-room value="lounge"> Sitting room</label>' +
          '<label class="pdp-staff-defaults__choice"><input type="checkbox" form="staff-frame-defaults" data-staff-room value="bedroom"> Bedroom</label>' +
          '<label class="pdp-staff-defaults__choice"><input type="checkbox" form="staff-frame-defaults" data-staff-room value="office"> Study</label>' +
          '<label class="pdp-staff-defaults__choice"><input type="checkbox" form="staff-frame-defaults" data-staff-room value="kitchen"> Kitchen</label>' +
          '<label class="pdp-staff-defaults__choice"><input type="checkbox" form="staff-frame-defaults" data-staff-room value="conservatory"> Conservatory</label>' +
          '<label class="pdp-staff-defaults__choice"><input type="checkbox" form="staff-frame-defaults" data-staff-room value="dining-room"> Dining room</label>' +
          '<label class="pdp-staff-defaults__choice"><input type="checkbox" form="staff-frame-defaults" data-staff-room value="hallway"> Hallway</label>' +
          '</div><div class="pdp-staff-defaults__actions">' +
          '<button type="button" class="pdp-staff-defaults__save" data-staff-rooms-save>Save rooms</button></div>';
        if (pinAnchor && pinAnchor.parentNode) pinAnchor.parentNode.insertBefore(roomsFs, pinAnchor);
        else if (bodyEl) bodyEl.appendChild(roomsFs);
      }
      var roomsSaveBtn = box.querySelector("[data-staff-rooms-save]");
      var captionSeed = "";
      var busyBtns = [saveBtn, previewBtn, useFeedBtn, retryFeedBtn, discardFeedBtn, sceneGenerateBtn, sceneSaveBtn, sceneRetryBtn, sceneDiscardBtn, roomsSaveBtn];
      var pinKey = "artfolio-promote-pin";
      var endpoint = themeCfg.promoteEndpoint || "/apps/artfolio/promote";
      var handle = root.getAttribute("data-product-handle") || (product && product.handle) || "";
      var feedUrl = root.getAttribute("data-staff-feed-url") || "";
      var sceneLock = null;
      var feedAlt = root.getAttribute("data-staff-feed-alt") || "";
      var hasFeedImage = !!feedUrl;
      var framedDataUrl = "";
      var framedLookSig = "";
      var sceneDraft = null;
      var sceneLookSig = "";
      var sceneRolls = {};
      var staffBusy = false;

      if (feedThumb && feedUrl) {
        feedThumb.src = feedUrl;
        feedThumb.alt = feedAlt || "Current second product image";
      }
      (function bindStaffImageEnlarge() {
        var dialog = document.createElement("dialog");
        dialog.className = "pdp-staff-defaults__lightbox";
        var large = document.createElement("img");
        large.alt = "";
        var close = document.createElement("button");
        close.type = "button";
        close.className = "pdp-staff-defaults__lightbox-close";
        close.textContent = "Close";
        dialog.appendChild(large);
        dialog.appendChild(close);
        document.body.appendChild(dialog);
        function largerSrc(url) {
          if (!url || url.indexOf("data:") === 0) return url;
          if (/([?&])width=\d+/i.test(url)) return url.replace(/([?&])width=\d+/i, "$1width=2000");
          return url;
        }
        function openLarge(src, alt) {
          if (!src || typeof dialog.showModal !== "function") return;
          large.alt = alt || "Framed image";
          large.src = largerSrc(src);
          if (!dialog.open) dialog.showModal();
        }
        close.addEventListener("click", function () { dialog.close(); });
        dialog.addEventListener("click", function (event) {
          if (event.target === dialog) dialog.close();
        });
        var currentBtn = box.querySelector("[data-staff-feed-enlarge]");
        if (currentBtn) {
          currentBtn.addEventListener("click", function () {
            if (feedThumb && feedThumb.src) openLarge(feedThumb.src, feedThumb.alt);
          });
        }
        var previewBtnEnlarge = box.querySelector("[data-staff-preview-enlarge]");
        if (previewBtnEnlarge && previewImg) {
          previewBtnEnlarge.addEventListener("click", function () {
            if (previewImg.getAttribute("src")) openLarge(previewImg.src, previewImg.alt);
          });
        }
      })();
      if (feedCurrent) feedCurrent.hidden = !hasFeedImage;
      if (feedCurrentLabel) {
        feedCurrentLabel.textContent = feedAlt
          ? "Current 2nd image — " + feedAlt
          : "Current 2nd image. Check this is the framed shopping-feed photo before replacing it.";
      }
      if (deleteWrap) deleteWrap.hidden = !hasFeedImage;
      if (window.ArtfolioScenes && sceneRoomEl) window.ArtfolioScenes.fillSelect(sceneRoomEl);
      (function seedRoomChecks() {
        var currentRooms = (root.getAttribute("data-staff-rooms") || "").split(",").map(function (s) {
          return String(s || "").trim();
        }).filter(Boolean);
        box.querySelectorAll("[data-staff-room]").forEach(function (input) {
          input.checked = currentRooms.indexOf(input.value) !== -1;
        });
      })();

      function readPin() {
        try { return localStorage.getItem(pinKey) || sessionStorage.getItem(pinKey) || ""; } catch (err) { return ""; }
      }
      function writePin(value) {
        try {
          localStorage.setItem(pinKey, value);
          sessionStorage.setItem(pinKey, value);
        } catch (err) {}
      }
      function lookLabel(options) {
        var parts = [
          options.frameStyle,
          options.colour,
          options.size,
          options.mount,
          options.mountColour
        ].filter(function (part) { return part && String(part).trim(); });
        return parts.join(" · ");
      }
      function refreshSummary() {
        if (!visualiserApi.getOptions) return;
        var text = lookLabel(visualiserApi.getOptions());
        summaries.forEach(function (el) { el.textContent = text; });
      }
      function lookSignature() {
        return visualiserApi.getOptions ? lookLabel(visualiserApi.getOptions()) : "";
      }
      var baselineLook = lookSignature();
      window.setTimeout(function () {
        baselineLook = lookSignature() || baselineLook;
      }, 80);
      function hasPendingPreview() {
        return !!(framedDataUrl || (sceneDraft && sceneDraft.url));
      }
      function setStaffOpen(open) {
        box.classList.toggle("is-open", !!open);
        if (toggleBtn) toggleBtn.setAttribute("aria-expanded", open ? "true" : "false");
        if (bodyEl) bodyEl.hidden = !open;
      }
      function revealStaffPanel() {
        box.hidden = false;
        box.removeAttribute("hidden");
        refreshSummary();
        refreshFeedUi();
      }
      function collapseStaffPanel() {
        if (hasPendingPreview()) return;
        setStaffOpen(false);
      }
      function finishSaved(message) {
        setStatus(message, false);
        baselineLook = lookSignature() || baselineLook;
        try {
          var url = new URL(window.location.href);
          url.searchParams.delete("variant");
          window.history.replaceState({}, "", url.pathname + url.search + url.hash);
        } catch (e) {}
        try {
          root.dispatchEvent(new CustomEvent("artfolio:frame-defaults-saved"));
        } catch (e) {}
        window.setTimeout(collapseStaffPanel, 2400);
      }
      function setStatus(message, isError) {
        if (!status) return;
        status.textContent = message || "";
        if (isError) status.setAttribute("data-error", "");
        else status.removeAttribute("data-error");
      }
      function currentPin() {
        var typed = pinInput && pinInput.value ? String(pinInput.value).trim() : "";
        return typed || readPin();
      }
      function requirePin(actionLabel) {
        var pin = currentPin();
        if (pin) return pin;
        if (pinWrap) pinWrap.hidden = false;
        if (pinInput) pinInput.focus();
        setStatus("Enter the staff PIN to " + (actionLabel || "continue") + ".", true);
        return "";
      }
      function setBusy(on) {
        staffBusy = !!on;
        busyBtns.forEach(function (btn) {
          if (btn) btn.disabled = !!on;
        });
        if (sceneRoomEl) sceneRoomEl.disabled = !!on;
        box.querySelectorAll("[data-staff-room]").forEach(function (input) {
          input.disabled = !!on;
        });
      }
      function setSceneGenerating(on) {
        function paint(btn, idleLabel) {
          if (!btn) return;
          btn.classList.toggle("is-generating", !!on);
          if (on) {
            btn.setAttribute("aria-busy", "true");
            btn.textContent = "Generating…";
          } else {
            btn.removeAttribute("aria-busy");
            btn.textContent = idleLabel;
          }
        }
        paint(sceneGenerateBtn, "Generate scene");
        paint(sceneRetryBtn, "Try another");
      }
      function setSceneProgress(message, isError) {
        if (!sceneProgress) return;
        sceneProgress.textContent = message || "";
        sceneProgress.hidden = !message;
        if (isError) sceneProgress.setAttribute("data-error", "");
        else sceneProgress.removeAttribute("data-error");
      }
      function wantsDelete() {
        return !!(deleteInput && deleteInput.checked && hasFeedImage);
      }
      function refreshFeedUi() {
        if (keepWrap) keepWrap.hidden = !(hasFeedImage && framedDataUrl);
        if (warnEl) warnEl.hidden = !wantsDelete();
        if (!saveBtn) return;
        saveBtn.textContent = wantsDelete() ? "Set default & remove 2nd image" : "Set as default";
      }
      function clearFramedPreview() {
        framedDataUrl = "";
        framedLookSig = "";
        if (previewBox) previewBox.hidden = true;
        if (previewImg) previewImg.removeAttribute("src");
        refreshFeedUi();
      }
      function showFramedPreview(dataUrl) {
        framedDataUrl = dataUrl;
        framedLookSig = lookSignature();
        if (deleteInput) deleteInput.checked = false;
        if (previewImg) previewImg.src = dataUrl;
        if (previewBox) previewBox.hidden = false;
        refreshFeedUi();
      }
      function clearScenePreview() {
        sceneDraft = null;
        sceneLookSig = "";
        captionSeed = "";
        if (scenePreviewBox) scenePreviewBox.hidden = true;
        if (scenePreviewImg) scenePreviewImg.removeAttribute("src");
        if (sceneCaptionText) sceneCaptionText.value = "";
      }
      function draftSceneCaption(body, roomName) {
        var options = visualiserApi.getOptions ? visualiserApi.getOptions() : {};
        if (window.ArtfolioScenes && typeof window.ArtfolioScenes.caption === "function") {
          return window.ArtfolioScenes.caption(
            sceneProduct(),
            (body && body.room) || roomName || (sceneRoomEl && sceneRoomEl.value) || "auto",
            { frameStyle: options.frameStyle, colour: options.colour }
          );
        }
        var title = (product && product.title) || "Framed print";
        var vendor = (product && product.vendor) || "";
        var byline = vendor ? title + " by " + vendor : title;
        var frame = [options.frameStyle, options.colour].filter(Boolean).join(" ") || "Classic Oak";
        var room = (body && body.room) || roomName || "British interior";
        return (byline + ", in " + frame + ", hanging in a " + room + ".").replace(/\s+/g, " ").trim().slice(0, 400);
      }
      function typedCaption() {
        return sceneCaptionText ? String(sceneCaptionText.value || "").replace(/\s+/g, " ").trim() : "";
      }
      function showCaptionDraft(roomName) {
        var typed = typedCaption();
        if (!typed || typed === captionSeed) {
          captionSeed = draftSceneCaption({}, roomName);
          if (sceneCaptionText) sceneCaptionText.value = captionSeed;
        }
        if (scenePreviewLabel) {
          scenePreviewLabel.textContent = (window.ArtfolioScenes ? window.ArtfolioScenes.titleCase(roomName) : roomName) +
            " — painting the room. You can edit the caption now.";
        }
        if (scenePreviewBox) scenePreviewBox.hidden = false;
      }
      function showScenePreview(body, roomName) {
        var typed = typedCaption();
        var caption = (typed && typed !== captionSeed ? typed : draftSceneCaption(body, roomName)).slice(0, 400);
        sceneDraft = {
          url: body.url,
          alt: body.alt || "",
          caption: caption,
          room: body.room || roomName || ""
        };
        sceneLookSig = lookSignature();
        if (scenePreviewImg) {
          scenePreviewImg.src = body.url;
          scenePreviewImg.alt = sceneDraft.alt || "Lifestyle preview";
        }
        if (sceneCaptionText) sceneCaptionText.value = caption;
        if (scenePreviewLabel) {
          scenePreviewLabel.textContent = (window.ArtfolioScenes ? window.ArtfolioScenes.titleCase(sceneDraft.room) : sceneDraft.room) +
            " — not on the product page yet";
        }
        if (scenePreviewBox) scenePreviewBox.hidden = false;
        if (sceneSaveBtn) sceneSaveBtn.hidden = false;
      }
      function addSceneToGallery(scene) {
        var section = document.querySelector("[data-scenes]");
        var grid = section && section.querySelector("[data-scenes-grid]");
        if (!section || !grid || !scene || !scene.url) return false;
        var already = false;
        Array.prototype.forEach.call(grid.querySelectorAll("[data-scene-src]"), function (el) {
          if (el.getAttribute("data-scene-src") === scene.url) already = true;
        });
        if (already) return true;
        var showCaption = !(sceneCaptionInput && sceneCaptionInput.checked === false);
        var caption = String(scene.caption || "").trim();
        var alt = String(scene.alt || caption || "Lifestyle photograph");
        var li = document.createElement("li");
        var figure = document.createElement("figure");
        figure.className = "scenes-figure";
        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = "scenes-item";
        btn.setAttribute("data-scene-src", scene.url);
        btn.setAttribute("data-scene-alt", alt);
        btn.setAttribute("data-scene-caption", caption);
        var img = document.createElement("img");
        img.src = scene.url;
        img.alt = alt;
        img.loading = "lazy";
        btn.appendChild(img);
        figure.appendChild(btn);
        if (showCaption && caption) {
          var figcaption = document.createElement("figcaption");
          figcaption.className = "scenes-caption";
          figcaption.textContent = caption;
          figure.appendChild(figcaption);
        }
        li.appendChild(figure);
        grid.insertBefore(li, grid.firstChild);
        var count = grid.querySelectorAll("li").length;
        grid.className = "scenes-grid is-" + count;
        section.hidden = false;
        section.removeAttribute("hidden");
        bindScenesLightbox(section);
        try {
          li.scrollIntoView({ block: "center", behavior: "smooth" });
        } catch (err) {}
        return true;
      }
      function invalidateStalePreviews() {
        var nextLook = lookSignature();
        if (framedLookSig && framedLookSig !== nextLook) clearFramedPreview();
        if (sceneLookSig && sceneLookSig !== nextLook) clearScenePreview();
      }
      function splitList(value) {
        return String(value || "").split(",").map(function (part) {
          return part.replace(/\s+/g, " ").trim();
        }).filter(Boolean);
      }
      function sceneProduct() {
        var options = visualiserApi.getOptions ? visualiserApi.getOptions() : {};
        var parsed = parseSizeCmFromLabel(options.size);
        if (/no\s*mount|none|unmounted/i.test(String(options.mount || "")) &&
            /rosenstiel/i.test(root.getAttribute("data-catalogue") || "")) {
          var noMountScene = rosenstielsNoMountFromLabel(options.size);
          if (noMountScene) parsed = noMountScene;
        }
        var collections = [];
        if (product && Array.isArray(product.collections)) {
          collections = product.collections.map(function (item) {
            return { title: item && (item.title || item), handle: item && item.handle };
          });
        }
        return {
          title: (product && product.title) || "Framed print",
          vendor: (product && product.vendor) || "",
          handle: handle,
          blurb: String((product && (product.description || product.body_html)) || "")
            .replace(/<[^>]+>/g, " ")
            .replace(/\s+/g, " ")
            .trim()
            .slice(0, 400),
          orientation: root.getAttribute("data-orientation") || "",
          genre: root.getAttribute("data-genre") || (product && product.type) || "",
          colours: splitList(root.getAttribute("data-colours")),
          moods: splitList(root.getAttribute("data-moods")),
          collections: collections,
          rosenstiels: /rosenstiel/i.test(root.getAttribute("data-catalogue") || ""),
          frameSize: parsed ? { label: options.size, w: parsed.w, h: parsed.h } : null,
          frameOptions: {
            frameStyle: options.frameStyle || "",
            colour: options.colour || "",
            mount: options.mount || "",
            mountColour: options.mountColour || ""
          },
          image: feedUrl || ""
        };
      }
      function currentFeedAction() {
        if (wantsDelete()) return "delete";
        return "none";
      }
      function staffError(code) {
        var map = {
          feed_image_changed: "Gallery changed since this page loaded. Refresh and check the 2nd image.",
          featured_image_changed: "Stopped — the featured print image would have changed.",
          refused_featured_image: "Refused to delete the featured print.",
          no_feed_image: "This product has no 2nd image to remove.",
          reorder_failed: "Defaults saved. The new render uploaded, but it didn’t land in 2nd place. Check the product gallery before deleting anything.",
          missing_image: "Couldn’t capture the framed look. Stay on Artwork view and try again.",
          invalid_image: "That render wasn’t a usable JPEG. Try again.",
          upload_failed: "Couldn’t upload the new render. Defaults are saved; the gallery was left alone.",
          media_failed: "Couldn’t attach the new render. Defaults are saved; the gallery was left alone.",
          unauthorized: "PIN not accepted. Try again.",
          missing_openai_key: "OpenAI isn’t configured on Promote yet.",
          openai_billing: "OpenAI billing or quota blocked this image.",
          openai_unverified: "GPT Image needs organisation verification in the OpenAI dashboard.",
          openai_rejected: "OpenAI rejected that scene. Try another room.",
          openai_failed: "OpenAI could not generate that scene. Try again.",
          image_fetch_failed: "Couldn’t read the framed reference. Try again.",
          missing_fields: "That request was incomplete. Refresh and try again."
        };
        return map[code] || code || "Couldn’t save those settings.";
      }
      function postPromote(pin, body) {
        return fetch(endpoint, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Promote-Pin": pin
          },
          body: JSON.stringify(body)
        }).then(function (res) {
          return res.json().then(function (payload) {
            return { ok: res.ok && payload && payload.ok, status: res.status, body: payload || {} };
          }).catch(function () {
            return { ok: false, status: res.status, body: {} };
          });
        });
      }
      function pollJob(pin, jobId, attempt, pendingCopy) {
        if (attempt > 200) return Promise.reject(new Error("This is taking too long. Check before trying again."));
        return new Promise(function (resolve) {
          window.setTimeout(resolve, attempt ? 1200 : 400);
        }).then(function () {
          return postPromote(pin, { op: "job", jobId: jobId, pin: pin });
        }).then(function (result) {
          var body = result.body || {};
          if (body.pending || body.status === "queued" || body.status === "running") {
            setStatus(pendingCopy || "Still working…", false);
            if (sceneGenerateBtn && sceneGenerateBtn.classList.contains("is-generating")) {
              setSceneProgress(pendingCopy || "Still working…");
            }
            return pollJob(pin, jobId, attempt + 1, pendingCopy);
          }
          if (result.status === 401 || body.error === "unauthorized") {
            var err = new Error("unauthorized");
            err.code = "unauthorized";
            throw err;
          }
          if (body.status === "error" || body.ok === false) {
            var fail = new Error(body.error || "media_failed");
            fail.code = body.error || "media_failed";
            fail.defaultsSaved = true;
            throw fail;
          }
          return result;
        });
      }
      function handleAuth(result) {
        if (result.status === 401 || (result.body && result.body.error === "unauthorized")) {
          if (pinWrap) pinWrap.hidden = false;
          if (pinInput) {
            pinInput.value = "";
            pinInput.focus();
          }
          setStatus("PIN not accepted. Try again.", true);
          return true;
        }
        return false;
      }
      function cssNum(el, name, fallback) {
        var view = (el.ownerDocument && el.ownerDocument.defaultView) || window;
        var n = parseFloat(view.getComputedStyle(el).getPropertyValue(name));
        return isFinite(n) ? n : fallback;
      }

      function firstHex(value, fallback) {
        var match = /#([0-9a-f]{6}|[0-9a-f]{3})/i.exec(String(value || ""));
        return match ? match[0] : fallback;
      }

      function loadCanvasImage(url) {
        if (!url) return Promise.reject(new Error("missing_image"));
        return fetch(url, { mode: "cors", credentials: "omit" }).then(function (res) {
          if (!res.ok) throw new Error("missing_image");
          return res.blob();
        }).then(function (blob) {
          if (typeof createImageBitmap === "function") return createImageBitmap(blob);
          return new Promise(function (resolve, reject) {
            var img = new Image();
            var objectUrl = URL.createObjectURL(blob);
            img.onload = function () {
              URL.revokeObjectURL(objectUrl);
              resolve(img);
            };
            img.onerror = function () {
              URL.revokeObjectURL(objectUrl);
              reject(new Error("missing_image"));
            };
            img.src = objectUrl;
          });
        });
      }

      function artStageFrames() {
        var stage = visualiser.querySelector('[data-stage="art"]') || visualiser.querySelector(".stage:not(.room)");
        if (!stage) return [];
        return Array.prototype.filter.call(stage.querySelectorAll("[data-frame]"), function (frame) {
          var rect = frame.getBoundingClientRect();
          return rect.width > 40 && rect.height > 40;
        });
      }

      function shadowLayersFor(mode, s, sep, lx, depth, canvasScale) {
        function x(px) { return px * lx * s * depth; }
        function y(px) { return px * s * depth; }
        var k = canvasScale || 1;
        if (mode === "realistic-v4") {
          return [
            { ox: x(3), oy: y(8), blur: y(12), spread: y(-2), alpha: 0.16 * sep },
            { ox: x(2), oy: y(5), blur: y(7), spread: 0, alpha: 0.34 * sep },
            { ox: x(1), oy: y(2), blur: y(3), spread: 0, alpha: 0.50 * sep }
          ];
        }
        if (mode === "realistic-v2" || mode === "realistic-v3") {
          return [
            { ox: x(10), oy: y(20), blur: y(34), spread: y(-14), alpha: 0.20 * sep },
            { ox: x(4), oy: y(8), blur: y(14), spread: y(-6), alpha: 0.30 * sep },
            { ox: x(1), oy: y(2), blur: y(3), spread: y(-1), alpha: 0.20 * sep }
          ];
        }
        if (mode === "realistic") {
          return [
            { ox: -7 * k, oy: 13 * k, blur: 20 * k, spread: -14 * k, alpha: 0.28 },
            { ox: -3 * k, oy: 6 * k, blur: 10 * k, spread: -6 * k, alpha: 0.42 }
          ];
        }
        return [{ ox: 0, oy: 26 * k, blur: 50 * k, spread: -28 * k, alpha: 0.55 }];
      }

      function paintShadow(ctx, x, y, w, h, layers) {
        layers.forEach(function (layer) {
          ctx.save();
          ctx.shadowOffsetX = layer.ox;
          ctx.shadowOffsetY = layer.oy;
          ctx.shadowBlur = Math.max(0, layer.blur);
          ctx.shadowColor = "rgba(20,16,12," + layer.alpha + ")";
          ctx.fillStyle = "#000";
          var spread = layer.spread || 0;
          ctx.fillRect(x - spread, y - spread, w + spread * 2, h + spread * 2);
          ctx.restore();
        });
      }

      function mitrePath(ctx, side, x, y, w, h, t, r, b, l) {
        ctx.beginPath();
        if (side === "t") {
          ctx.moveTo(x, y);
          ctx.lineTo(x + w, y);
          ctx.lineTo(x + w - r, y + h);
          ctx.lineTo(x + l, y + h);
        } else if (side === "b") {
          ctx.moveTo(x + l, y);
          ctx.lineTo(x + w - r, y);
          ctx.lineTo(x + w, y + h);
          ctx.lineTo(x, y + h);
        } else if (side === "l") {
          ctx.moveTo(x, y);
          ctx.lineTo(x + w, y + t);
          ctx.lineTo(x + w, y + h - b);
          ctx.lineTo(x, y + h);
        } else {
          ctx.moveTo(x, y + t);
          ctx.lineTo(x + w, y);
          ctx.lineTo(x + w, y + h);
          ctx.lineTo(x, y + h - b);
        }
        ctx.closePath();
      }

      function railFinish(frame) {
        var attrs = ["data-classic", "data-deep-classic", "data-swoop", "data-venice"];
        for (var i = 0; i < attrs.length; i += 1) {
          var key = frame.getAttribute(attrs[i]);
          if (key && FINISH[key]) return FINISH[key];
        }
        return null;
      }

      function drawCoverImage(ctx, img, x, y, w, h) {
        var sw = img.naturalWidth || img.width;
        var sh = img.naturalHeight || img.height;
        if (!sw || !sh) return;
        var scale = Math.max(w / sw, h / sh);
        var dw = sw * scale;
        var dh = sh * scale;
        ctx.save();
        ctx.beginPath();
        ctx.rect(x, y, w, h);
        ctx.clip();
        ctx.drawImage(img, x + (w - dw) / 2, y + (h - dh) / 2, dw, dh);
        ctx.restore();
      }

      function drawSliceImage(ctx, img, piece, x, y, w, h, canvasScale) {
        var size = String(piece.style.backgroundSize || "").trim().split(/\s+/);
        var pos = String(piece.style.backgroundPosition || "").trim().split(/\s+/);
        var drawnW = parseFloat(size[0]);
        var drawnH = parseFloat(size[1]);
        var originX = parseFloat(pos[0]);
        var originY = parseFloat(pos[1]);
        if (!isFinite(drawnW) || !isFinite(drawnH)) {
          drawCoverImage(ctx, img, x, y, w, h);
          return;
        }
        var localX = piece.offsetWidth ? (w / canvasScale) / piece.offsetWidth : 1;
        var localY = piece.offsetHeight ? (h / canvasScale) / piece.offsetHeight : 1;
        ctx.save();
        ctx.beginPath();
        ctx.rect(x, y, w, h);
        ctx.clip();
        ctx.drawImage(
          img,
          x + (isFinite(originX) ? originX : 0) * localX * canvasScale,
          y + (isFinite(originY) ? originY : 0) * localY * canvasScale,
          drawnW * localX * canvasScale,
          drawnH * localY * canvasScale
        );
        ctx.restore();
      }

      function insetBoxShadow(ctx, x, y, w, h, ox, oy, blur, spread, color) {
        ctx.save();
        ctx.beginPath();
        ctx.rect(x, y, w, h);
        ctx.clip();
        ctx.shadowColor = color;
        ctx.shadowBlur = Math.max(0, blur);
        ctx.shadowOffsetX = ox;
        ctx.shadowOffsetY = oy;
        var pad = Math.ceil(Math.abs(ox) + Math.abs(oy) + blur + Math.abs(spread) + Math.max(w, h));
        ctx.beginPath();
        ctx.rect(x - pad, y - pad, w + pad * 2, h + pad * 2);
        ctx.rect(x + spread, y + spread, w - spread * 2, h - spread * 2);
        ctx.fillStyle = "#000";
        ctx.fill("evenodd");
        ctx.restore();
      }

      function outsideRing(ctx, x, y, w, h, width, color) {
        if (width <= 0) return;
        ctx.save();
        ctx.strokeStyle = color;
        ctx.lineWidth = width;
        ctx.strokeRect(x - width / 2, y - width / 2, w + width, h + width);
        ctx.restore();
      }

      function paintShoppingFrame() {
        var frames = artStageFrames();
        if (!frames.length) return Promise.reject(new Error("missing_image"));
        var stage = frames[0].closest("[data-stage]") || frames[0];
        var union = frames[0].getBoundingClientRect();
        frames.forEach(function (frame) {
          var rect = frame.getBoundingClientRect();
          union = {
            left: Math.min(union.left, rect.left),
            top: Math.min(union.top, rect.top),
            right: Math.max(union.right, rect.right),
            bottom: Math.max(union.bottom, rect.bottom)
          };
        });
        union.width = union.right - union.left;
        union.height = union.bottom - union.top;
        var sample = frames[0];
        var shadowMode = stage.getAttribute("data-shadow") || "realistic-v4";
        var s = cssNum(sample, "--fv-s", 1);
        var sep = cssNum(sample, "--fv-sep", 1);
        var lx = cssNum(sample, "--fv-lx", -1);
        var depth = cssNum(sample, "--fv-depth", 1);
        var lit = cssNum(stage, "--fv-lit", 1.05);
        var shade = cssNum(stage, "--fv-shade", 0.96);
        var pad = Math.ceil(36 * Math.max(1, s * depth));
        var longEdge = Math.max(union.width, union.height) + pad * 2;
        var canvasScale = Math.min(3, 2400 / Math.max(1, longEdge));
        var canvas = document.createElement("canvas");
        canvas.width = Math.max(1, Math.round((union.width + pad * 2) * canvasScale));
        canvas.height = Math.max(1, Math.round((union.height + pad * 2) * canvasScale));
        var ctx = canvas.getContext("2d");
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = "high";
        ctx.fillStyle = "#f4f1ea";
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        function place(rect) {
          return {
            x: (rect.left - union.left + pad) * canvasScale,
            y: (rect.top - union.top + pad) * canvasScale,
            w: rect.width * canvasScale,
            h: rect.height * canvasScale
          };
        }

        var jobs = [];
        var railUrls = {};
        var printUrls = {};
        frames.forEach(function (frame) {
          Array.prototype.forEach.call(frame.querySelectorAll("[data-rail]"), function (rail) {
            var url = extractBgImageUrl(window.getComputedStyle(rail).backgroundImage);
            if (url) railUrls[url] = true;
          });
          var piece = frame.querySelector("[data-piece]");
          if (!piece) return;
          var printUrl = extractBgImageUrl(piece.style.backgroundImage);
          var img = piece.querySelector("img");
          if (!printUrl && img) printUrl = img.currentSrc || img.src || "";
          if (printUrl) printUrls[printUrl] = true;
        });
        Object.keys(railUrls).concat(Object.keys(printUrls)).forEach(function (url) {
          jobs.push(loadCanvasImage(url).then(function (image) {
            railUrls[url] = image;
            printUrls[url] = image;
          }));
        });

        return Promise.all(jobs).then(function () {
          var layers = shadowLayersFor(shadowMode, s * canvasScale, sep, lx, depth, canvasScale);
          var bareLayers = [{ ox: 0, oy: 18 * canvasScale, blur: 40 * canvasScale, spread: -26 * canvasScale, alpha: 0.4 }];
          var boxes = [];
          frames.forEach(function (frame) {
            var box = place(frame.getBoundingClientRect());
            boxes.push(box);
            paintShadow(ctx, box.x, box.y, box.w, box.h, frame.classList.contains("none") ? bareLayers : layers);
          });
          frames.forEach(function (frame) {
            var box = place(frame.getBoundingClientRect());
            var none = frame.classList.contains("none");
            if (none) {
              ctx.fillStyle = "#f4f1ea";
              ctx.fillRect(box.x, box.y, box.w, box.h);
            }
            var framePx = cssNum(frame, "--frame-w", 0) * canvasScale;
            var t = cssNum(frame, "--frame-t", framePx / canvasScale) * canvasScale || framePx;
            var r = cssNum(frame, "--frame-r", framePx / canvasScale) * canvasScale || framePx;
            var b = cssNum(frame, "--frame-b", framePx / canvasScale) * canvasScale || framePx;
            var l = cssNum(frame, "--frame-l", framePx / canvasScale) * canvasScale || framePx;
            if (!none) {
              ctx.fillStyle = firstHex(frame.style.getPropertyValue("--frame-bg"), "#c4a066");
              ctx.fillRect(box.x, box.y, box.w, box.h);
              Array.prototype.forEach.call(frame.querySelectorAll("[data-rail]"), function (rail) {
                var side = rail.getAttribute("data-rail");
                var railBox = place(rail.getBoundingClientRect());
                var url = extractBgImageUrl(window.getComputedStyle(rail).backgroundImage);
                var image = url && railUrls[url] && railUrls[url].width ? railUrls[url] : null;
                var bright = (side === "t" || side === "r") ? lit : shade;
                ctx.save();
                mitrePath(ctx, side, railBox.x, railBox.y, railBox.w, railBox.h, t, r, b, l);
                ctx.clip();
                if (image) {
                  ctx.filter = "brightness(" + bright + ")";
                  ctx.drawImage(image, railBox.x, railBox.y, railBox.w, railBox.h);
                  ctx.filter = "none";
                } else {
                  var finish = railFinish(frame);
                  var gradient = (side === "l" || side === "r")
                    ? ctx.createLinearGradient(railBox.x, 0, railBox.x + railBox.w, 0)
                    : ctx.createLinearGradient(0, railBox.y, 0, railBox.y + railBox.h);
                  if (finish) {
                    gradient.addColorStop(0, finish.out);
                    gradient.addColorStop(0.55, finish.mid);
                    gradient.addColorStop(1, finish.inn);
                  } else {
                    gradient.addColorStop(0, "#c4a066");
                    gradient.addColorStop(1, "#a87e4c");
                  }
                  ctx.fillStyle = gradient;
                  ctx.fillRect(railBox.x, railBox.y, railBox.w, railBox.h);
                }
                var lip = Math.max(1, 1.15 * s * canvasScale);
                ctx.fillStyle = "rgba(24,22,19,.22)";
                if (side === "t") ctx.fillRect(railBox.x, railBox.y, railBox.w, lip);
                else if (side === "b") ctx.fillRect(railBox.x, railBox.y + railBox.h - lip, railBox.w, lip);
                else if (side === "l") ctx.fillRect(railBox.x, railBox.y, lip, railBox.h);
                else ctx.fillRect(railBox.x + railBox.w - lip, railBox.y, lip, railBox.h);
                ctx.fillStyle = "rgba(255,255,255,.36)";
                if (side === "t") ctx.fillRect(railBox.x, railBox.y + railBox.h - lip, railBox.w, lip);
                else if (side === "b") ctx.fillRect(railBox.x, railBox.y, railBox.w, lip);
                else if (side === "l") ctx.fillRect(railBox.x + railBox.w - lip, railBox.y, lip, railBox.h);
                else ctx.fillRect(railBox.x, railBox.y, lip, railBox.h);
                ctx.restore();
              });
            }
            var mount = frame.querySelector("[data-mount]");
            var piece = frame.querySelector("[data-piece]");
            if (mount && !mount.classList.contains("off")) {
              var mountBox = place(mount.getBoundingClientRect());
              ctx.fillStyle = window.getComputedStyle(mount).backgroundColor || "#eee9e3";
              ctx.fillRect(mountBox.x, mountBox.y, mountBox.w, mountBox.h);
            }
            if (piece) {
              var pieceBox = place(piece.getBoundingClientRect());
              var printUrl = extractBgImageUrl(piece.style.backgroundImage);
              var imgEl = piece.querySelector("img");
              if (!printUrl && imgEl) printUrl = imgEl.currentSrc || imgEl.src || "";
              var print = printUrl && printUrls[printUrl];
              if (print && print.width) {
                if (piece.classList.contains("tri-slice") || piece.classList.contains("dip-slice")) {
                  drawSliceImage(ctx, print, piece, pieceBox.x, pieceBox.y, pieceBox.w, pieceBox.h, canvasScale);
                } else {
                  drawCoverImage(ctx, print, pieceBox.x, pieceBox.y, pieceBox.w, pieceBox.h);
                }
              }
              if (mount && !mount.classList.contains("off")) {
                var well = s * depth * canvasScale;
                outsideRing(ctx, pieceBox.x, pieceBox.y, pieceBox.w, pieceBox.h, 2 * canvasScale, "rgba(255,255,255,.78)");
                outsideRing(ctx, pieceBox.x, pieceBox.y, pieceBox.w, pieceBox.h, canvasScale, "rgba(0,0,0,.18)");
                insetBoxShadow(ctx, pieceBox.x, pieceBox.y, pieceBox.w, pieceBox.h, 0, 3 * well, 5 * well, -2 * well, "rgba(0,0,0,.40)");
                insetBoxShadow(ctx, pieceBox.x, pieceBox.y, pieceBox.w, pieceBox.h, 2 * well, 0, 4 * well, -2 * well, "rgba(0,0,0,.22)");
                insetBoxShadow(ctx, pieceBox.x, pieceBox.y, pieceBox.w, pieceBox.h, -2 * well, 0, 4 * well, -2 * well, "rgba(0,0,0,.26)");
                insetBoxShadow(ctx, pieceBox.x, pieceBox.y, pieceBox.w, pieceBox.h, 0, -2 * well, 4 * well, -2 * well, "rgba(0,0,0,.16)");
              }
            }
            if (!none && mount) {
              var opening = place(mount.getBoundingClientRect());
              var rebate = s * depth * canvasScale;
              outsideRing(ctx, opening.x, opening.y, opening.w, opening.h, canvasScale, "rgba(0,0,0,.16)");
              insetBoxShadow(
                ctx, opening.x, opening.y, opening.w, opening.h,
                2 * lx * rebate, 3 * rebate, 7 * rebate, -2 * rebate, "rgba(0,0,0,.34)"
              );
            }
          });
          return { canvas: canvas, boxes: boxes };
        });
      }

      function captureFeedJpeg() {
        return paintShoppingFrame().then(function (painted) {
          return canvasToJpegDataUrl(painted.canvas, 0.93, 2400, "#f4f1ea");
        });
      }
      function canvasToPngDataUrl(canvas) {
        return new Promise(function (resolve, reject) {
          if (!canvas || !canvas.toBlob) {
            reject(new Error("invalid_image"));
            return;
          }
          canvas.toBlob(function (blob) {
            if (!blob) {
              reject(new Error("invalid_image"));
              return;
            }
            var reader = new FileReader();
            reader.onload = function () { resolve(String(reader.result || "")); };
            reader.onerror = function () { reject(new Error("invalid_image")); };
            reader.readAsDataURL(blob);
          }, "image/png");
        });
      }
      function unionFrameBoxes(boxes) {
        var union = null;
        (boxes || []).forEach(function (box) {
          if (!box || !(box.w > 1) || !(box.h > 1)) return;
          if (!union) {
            union = { x: box.x, y: box.y, r: box.x + box.w, b: box.y + box.h };
            return;
          }
          union.x = Math.min(union.x, box.x);
          union.y = Math.min(union.y, box.y);
          union.r = Math.max(union.r, box.x + box.w);
          union.b = Math.max(union.b, box.y + box.h);
        });
        if (!union) return null;
        return { x: union.x, y: union.y, w: union.r - union.x, h: union.b - union.y };
      }
      function scenePlateSize(aspect) {
        if (aspect > 1.15) return { w: 1536, h: 1024, name: "1536x1024" };
        if (aspect < 0.87) return { w: 1024, h: 1536, name: "1024x1536" };
        return { w: 1024, h: 1024, name: "1024x1024" };
      }
      // Place the exact framed render on a plate the edits API will not redraw.
      // The mask is opaque on the print and transparent on the empty background.
      function buildScenePlate(painted) {
        var crop = unionFrameBoxes(painted && painted.boxes);
        var source = painted && painted.canvas;
        if (!crop || !source) throw new Error("missing_image");
        var size = scenePlateSize(crop.w / crop.h);
        var plate = document.createElement("canvas");
        plate.width = size.w;
        plate.height = size.h;
        var ctx = plate.getContext("2d");
        ctx.fillStyle = "#e7e1d6";
        ctx.fillRect(0, 0, size.w, size.h);
        var maxW = size.w * 0.42;
        var maxH = size.h * 0.5;
        var scale = Math.min(maxW / crop.w, maxH / crop.h);
        var dw = crop.w * scale;
        var dh = crop.h * scale;
        var dx = (size.w - dw) / 2;
        var dy = Math.max(24, size.h * 0.16);
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = "high";
        ctx.drawImage(source, crop.x, crop.y, crop.w, crop.h, dx, dy, dw, dh);
        var mask = document.createElement("canvas");
        mask.width = size.w;
        mask.height = size.h;
        var maskCtx = mask.getContext("2d");
        maskCtx.clearRect(0, 0, size.w, size.h);
        maskCtx.fillStyle = "#000000";
        maskCtx.fillRect(Math.round(dx), Math.round(dy), Math.round(dw), Math.round(dh));
        return { canvas: plate, mask: mask, size: size.name };
      }
      function loadSceneImage(url) {
        return new Promise(function (resolve, reject) {
          var img = new Image();
          img.crossOrigin = "anonymous";
          img.onload = function () { resolve(img); };
          img.onerror = function () { reject(new Error("image_fetch_failed")); };
          img.src = url;
        });
      }
      function framedPhotoBounds(img) {
        var canvas = document.createElement("canvas");
        var w = img.naturalWidth || img.width;
        var h = img.naturalHeight || img.height;
        canvas.width = w;
        canvas.height = h;
        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        var full = { canvas: canvas, x: 0, y: 0, w: w, h: h };
        var data;
        try {
          data = ctx.getImageData(0, 0, w, h).data;
        } catch (error) {
          return full;
        }
        var minX = w;
        var minY = h;
        var maxX = 0;
        var maxY = 0;
        var found = false;
        var step = Math.max(1, Math.floor(Math.min(w, h) / 400));
        var y;
        var x;
        for (y = 0; y < h; y += step) {
          for (x = 0; x < w; x += step) {
            var i = (y * w + x) * 4;
            if (data[i + 3] < 16) continue;
            if (data[i] > 246 && data[i + 1] > 246 && data[i + 2] > 246) continue;
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
            found = true;
          }
        }
        if (!found) return full;
        minX = Math.max(0, minX - step);
        minY = Math.max(0, minY - step);
        maxX = Math.min(w - 1, maxX + step);
        maxY = Math.min(h - 1, maxY + step);
        return { canvas: canvas, x: minX, y: minY, w: maxX - minX + 1, h: maxY - minY + 1 };
      }
      function sceneReference() {
        var src = feedUrl || root.getAttribute("data-staff-feed-url") || "";
        if (!src) return Promise.reject(new Error("There is no 2nd image on this product to place in the room."));
        if (!window.ArtfolioScenes || typeof window.ArtfolioScenes.prepareLockedScene !== "function") {
          return Promise.reject(new Error("Scene helper failed to load. Refresh and try again."));
        }
        return window.ArtfolioScenes.prepareLockedScene(src).then(function (asset) {
          sceneLock = asset.lock;
          return { image: asset.image, mask: asset.mask, size: asset.size };
        });
      }
      function placeLockedPrint(body) {
        var locked = sceneLock;
        if (!locked || !body || !body.url || !window.ArtfolioScenes || typeof window.ArtfolioScenes.pasteLockedScene !== "function") {
          return Promise.resolve(body);
        }
        return window.ArtfolioScenes.pasteLockedScene(body.url, locked).then(function (dataUrl) {
          if (dataUrl) body.url = dataUrl;
          return body;
        }).catch(function () {
          return body;
        });
      }
      function currentOptions() {
        var options = visualiserApi.getOptions() || {};
        function pressedValue(type, attr) {
          var btn = root.querySelector('[data-pp-type="' + type + '"][aria-pressed="true"]');
          if (!btn) return "";
          return btn.getAttribute(attr || "data-value") || "";
        }
        var sizeBtn = root.querySelector('[data-bb-panel="size"] [data-value][aria-pressed="true"]')
          || root.querySelector('[data-pp-type="size"][aria-pressed="true"]');
        var mountBtn = root.querySelector('[data-pp-type="mount"][aria-pressed="true"]');
        var mountColourBtn = root.querySelector("[data-mount-colour] [aria-pressed='true']");
        return {
          frameStyle: pressedValue("frametype") || options.frameStyle,
          colour: pressedValue("frame") || options.colour,
          size: (sizeBtn && sizeBtn.getAttribute("data-value")) || options.size,
          mount: (mountBtn && mountBtn.getAttribute("data-value")) || options.mount,
          mountColour: (mountColourBtn && mountColourBtn.getAttribute("data-name")) || options.mountColour
        };
      }
      function sizedFeedUrl(url, width) {
        if (!url || url.indexOf("data:") === 0) return url;
        if (/([?&])width=\d+/i.test(url)) return url.replace(/([?&])width=\d+/i, "$1width=" + width);
        return url + (url.indexOf("?") >= 0 ? "&" : "?") + "width=" + width;
      }
      function savedFeedAlt(options) {
        var title = (product && product.title) || "Print";
        var mount = /no\s*mount/i.test(String(options && options.mount || "")) ? "no mount" : "mounted";
        return (title + " framed print, " + (options.frameStyle || "") + " " + (options.colour || "") + ", " + mount)
          .replace(/\s+/g, " ")
          .trim();
      }
      function showCurrentFeed(url, alt) {
        if (!url) return;
        var cdn = url.indexOf("data:") === 0 ? "" : url;
        if (cdn) {
          feedUrl = cdn;
          root.setAttribute("data-staff-feed-url", cdn);
        }
        hasFeedImage = true;
        if (alt) {
          feedAlt = alt;
          root.setAttribute("data-staff-feed-alt", alt);
        }
        if (feedThumb) {
          feedThumb.src = cdn ? sizedFeedUrl(cdn, 600) : url;
          feedThumb.alt = feedAlt || "Current second product image";
        }
        if (feedCurrent) feedCurrent.hidden = false;
        if (feedCurrentLabel && feedAlt) feedCurrentLabel.textContent = "Current 2nd image — " + feedAlt;
        if (deleteWrap) deleteWrap.hidden = false;
      }
      function hideCurrentFeed() {
        feedUrl = "";
        feedAlt = "";
        hasFeedImage = false;
        root.removeAttribute("data-staff-feed-url");
        root.removeAttribute("data-staff-feed-alt");
        if (feedThumb) {
          feedThumb.removeAttribute("src");
          feedThumb.alt = "";
        }
        if (feedCurrent) feedCurrent.hidden = true;
        if (feedCurrentLabel) feedCurrentLabel.textContent = "Current 2nd image";
        if (deleteWrap) deleteWrap.hidden = true;
      }
      function savedFeedUrl(result, fallback) {
        var body = result && result.body;
        var url = body && (body.url || (body.feed && body.feed.newImageUrl));
        return url || fallback || "";
      }
      function saveDefaults(feedImage, successMessage) {
        var pin = requirePin("save");
        if (!pin) return Promise.resolve();
        if (!handle || !visualiserApi.getOptions) {
          setStatus("Couldn’t read this product.", true);
          return Promise.resolve();
        }
        var options = currentOptions();
        var payload = {
          frameStyle: options.frameStyle,
          colour: options.colour,
          size: options.size,
          mount: options.mount,
          mountColour: options.mountColour,
          variantId: idInput && idInput.value ? String(idInput.value) : ""
        };
        setBusy(true);
        setStatus("Saving…", false);
        return postPromote(pin, {
          op: "save_frame_defaults",
          handle: handle,
          pin: pin,
          options: payload,
          feedImage: feedImage
        }).then(function (result) {
          if (handleAuth(result)) return;
          if (result.body && result.body.pending && result.body.jobId) {
            writePin(pin);
            if (pinWrap) pinWrap.hidden = true;
            setStatus("Defaults saved. Updating shopping-feed image…", false);
            return pollJob(pin, result.body.jobId, 0, "Updating shopping-feed image…").then(function (done) {
              showCurrentFeed(savedFeedUrl(done, feedImage && feedImage.dataUrl), savedFeedAlt(payload));
              clearFramedPreview();
              finishSaved(successMessage || ("Saved. Shoppers will see " + lookLabel(payload) + " first, and the 2nd image is the new framed look."));
            });
          }
          if (!result.ok) {
            setStatus(staffError((result.body && result.body.error) || "") + (result.body && result.body.defaultsSaved ? " Defaults were still saved." : ""), true);
            return;
          }
          writePin(pin);
          if (pinWrap) pinWrap.hidden = true;
          if (feedImage && feedImage.action === "delete") {
            hideCurrentFeed();
            finishSaved("Saved. Shoppers will see " + lookLabel(payload) + " first, and the old 2nd image has been removed.");
          } else if (feedImage && feedImage.action === "replace") {
            showCurrentFeed(savedFeedUrl(result, feedImage.dataUrl), savedFeedAlt(payload));
            clearFramedPreview();
            finishSaved(successMessage || ("Saved. Shoppers will see " + lookLabel(payload) + " first, and the 2nd image is the new framed look."));
          } else {
            finishSaved("Saved. Shoppers will see " + lookLabel(payload) + " first.");
          }
        }).catch(function (error) {
          var code = (error && (error.code || error.message)) || "";
          setStatus(staffError(code), true);
        }).finally(function () {
          setBusy(false);
        });
      }

      refreshSummary();
      refreshFeedUi();
      setStaffOpen(false);
      revealStaffPanel();
      if (toggleBtn) {
        toggleBtn.addEventListener("click", function () {
          setStaffOpen(!!(bodyEl && bodyEl.hidden));
        });
      }
      box.addEventListener("change", function (event) {
        if (!event.target || !event.target.closest) return;
        if (event.target.closest("[data-staff-feed-delete]")) {
          if (wantsDelete()) clearFramedPreview();
          refreshFeedUi();
        }
        if (event.target.closest("[data-staff-feed-keep]")) refreshFeedUi();
      });
      root.addEventListener("click", function (event) {
        if (!event.target || !event.target.closest) return;
        if (!event.target.closest("[data-pp-type], [data-option-index], [data-mount-colour], [data-mount-switch], [data-pp-group]")) return;
        window.setTimeout(function () {
          refreshSummary();
          invalidateStalePreviews();
        }, 30);
      });

      if (previewBtn) {
        previewBtn.addEventListener("click", function () {
          if (staffBusy) return;
          setBusy(true);
          setStatus("Capturing framed look…", false);
          captureFeedJpeg().then(function (dataUrl) {
            if (!dataUrl) throw new Error("missing_image");
            showFramedPreview(dataUrl);
            setStatus("Check the render. Nothing has been saved yet.", false);
          }).catch(function (error) {
            setStatus(staffError((error && error.message) || "missing_image"), true);
          }).finally(function () {
            setBusy(false);
          });
        });
      }
      if (retryFeedBtn) retryFeedBtn.addEventListener("click", function () {
        if (previewBtn) previewBtn.click();
      });
      if (discardFeedBtn) discardFeedBtn.addEventListener("click", function () {
        clearFramedPreview();
        setStatus("Discarded. The shopping-feed image is unchanged.", false);
      });
      if (useFeedBtn) {
        useFeedBtn.addEventListener("click", function () {
          if (staffBusy) return;
          if (!framedDataUrl) {
            setStatus("Preview the framed render first.", true);
            return;
          }
          saveDefaults({
            action: "replace",
            expectedSecondUrl: feedUrl,
            keepCurrent: !!(keepInput && keepInput.checked),
            dataUrl: framedDataUrl
          });
        });
      }
      if (sceneGenerateBtn) {
        sceneGenerateBtn.addEventListener("click", function () {
          if (staffBusy) return;
          var pin = requirePin("generate a scene");
          if (!pin) return;
          if (!window.ArtfolioScenes) {
            setStatus("Scene helper failed to load. Refresh and try again.", true);
            return;
          }
          var roomId = sceneRoomEl && sceneRoomEl.value ? sceneRoomEl.value : "auto";
          var rollKey = handle + ":" + roomId;
          sceneRolls[rollKey] = (sceneRolls[rollKey] || 0) + 1;
          var sceneSource = sceneProduct();
          var planned;
          try {
            planned = window.ArtfolioScenes.prompt(sceneSource, roomId, sceneRolls[rollKey]);
          } catch (error) {
            setStatus("Couldn’t build that room prompt.", true);
            return;
          }
          setBusy(true);
          setSceneGenerating(true);
          sceneDraft = null;
          if (sceneSaveBtn) sceneSaveBtn.hidden = true;
          if (scenePreviewImg) scenePreviewImg.removeAttribute("src");
          showCaptionDraft(planned.scene.room);
          setStatus("Painting a new room around the framed print…", false);
          setSceneProgress("Painting a new room around the framed print…");
          postPromote(pin, {
            op: "generate_scene",
            handle: handle,
            pin: pin,
            prompt: planned.prompt,
            room: planned.scene.room,
            orientation: sceneSource.orientation,
            freshScene: true
          }).then(function (result) {
            if (handleAuth(result)) return null;
            writePin(pin);
            if (pinWrap) pinWrap.hidden = true;
            if (result.body && result.body.pending && result.body.jobId) {
              setStatus("Painting the room around the print…", false);
              setSceneProgress("Painting the room around the print…");
              return pollJob(pin, result.body.jobId, 0, "Painting the room around the print…");
            }
            if (!result.ok) throw new Error((result.body && result.body.error) || "openai_failed");
            return result;
          }).then(function (result) {
            if (!result) {
              setSceneProgress("");
              return;
            }
            var body = result.body || {};
            if (!body.url) throw new Error("openai_failed");
            showScenePreview(body, planned.scene.room);
            setSceneProgress("");
            setStatus("Scene ready. Check it, then save to In the room if you want it on the product page.", false);
          }).catch(function (error) {
            var code = (error && (error.code || error.message)) || "openai_failed";
            var message = staffError(code);
            setStatus(message, true);
            setSceneProgress(message, true);
          }).finally(function () {
            setSceneGenerating(false);
            setBusy(false);
          });
        });
      }
      if (sceneRetryBtn) sceneRetryBtn.addEventListener("click", function () {
        if (sceneGenerateBtn) sceneGenerateBtn.click();
      });
      if (sceneDiscardBtn) sceneDiscardBtn.addEventListener("click", function () {
        var alreadySaved = !!(sceneDraft && sceneSaveBtn && sceneSaveBtn.hidden);
        clearScenePreview();
        setStatus(alreadySaved
          ? "Preview closed. The saved scene is still on In the room."
          : "Discarded. That scene was not added to In the room.", false);
      });
      if (roomsSaveBtn) roomsSaveBtn.addEventListener("click", function () {
        if (staffBusy) return;
        var pin = requirePin("save rooms");
        if (!pin) return;
        var rooms = [];
        box.querySelectorAll("[data-staff-room]:checked").forEach(function (input) {
          rooms.push(input.value);
        });
        setBusy(true);
        setStatus("Saving rooms…", false);
        postPromote(pin, { op: "set_rooms", handle: handle, pin: pin, rooms: rooms }).then(function (result) {
          if (handleAuth(result)) return;
          if (!result.ok) {
            setStatus(staffError((result.body && result.body.error) || "") || "Couldn’t save rooms.", true);
            return;
          }
          writePin(pin);
          if (pinWrap) pinWrap.hidden = true;
          root.setAttribute("data-staff-rooms", rooms.join(","));
          finishSaved(rooms.length
            ? ("Saved. This print is in " + rooms.length + (rooms.length === 1 ? " room collection." : " room collections."))
            : "Saved. This print is not in any room collection.");
        }).catch(function (error) {
          var code = (error && (error.code || error.message)) || "";
          setStatus(staffError(code), true);
        }).finally(function () {
          setBusy(false);
        });
      });
      if (sceneSaveBtn) {
        sceneSaveBtn.addEventListener("click", function () {
          if (staffBusy) return;
          if (!sceneDraft || !sceneDraft.url) {
            setStatus("Generate a scene first.", true);
            return;
          }
          var pin = requirePin("save this scene");
          if (!pin) return;
          var caption = (typedCaption() || sceneDraft.caption || "").slice(0, 400);
          sceneDraft.caption = caption;
          setBusy(true);
          setStatus("Saving to In the room…", false);
          var staged = String(sceneDraft.url).indexOf("data:") === 0
            ? postPromote(pin, { op: "upload", handle: handle, pin: pin, image: sceneDraft.url, scratch: true }).then(function (uploaded) {
              if (!uploaded.ok || !uploaded.body || !uploaded.body.url) throw new Error("upload_failed");
              sceneDraft.url = uploaded.body.url;
              return sceneDraft.url;
            })
            : Promise.resolve(sceneDraft.url);
          staged.then(function (sceneUrl) {
            return postPromote(pin, {
            op: "save_scene",
            handle: handle,
            pin: pin,
            url: sceneUrl,
            alt: sceneDraft.alt || "",
            caption: caption,
            room: sceneDraft.room || "",
            showCaption: !(sceneCaptionInput && sceneCaptionInput.checked === false),
            saved: true
          });
          }).then(function (result) {
            if (handleAuth(result)) return;
            if (!result.ok) throw new Error((result.body && result.body.error) || "Couldn’t save that scene.");
            writePin(pin);
            if (pinWrap) pinWrap.hidden = true;
            sceneLookSig = "";
            if (result.body && result.body.caption) sceneDraft.caption = result.body.caption;
            if (result.body && result.body.alt) sceneDraft.alt = result.body.alt;
            if (scenePreviewLabel) scenePreviewLabel.textContent = "Saved to In the room";
            if (sceneSaveBtn) sceneSaveBtn.hidden = true;
            var added = addSceneToGallery(sceneDraft);
            if (added) {
              setStatus("Added to In the room.", false);
              return;
            }
            setStatus("Saved. Reloading so it shows in In the room…", false);
            window.setTimeout(function () {
              window.location.hash = "in-the-room";
              window.location.reload();
            }, 350);
          }).catch(function (error) {
            setStatus(staffError((error && (error.code || error.message)) || ""), true);
          }).finally(function () {
            setBusy(false);
          });
        });
      }

      if (!saveBtn) return;
      saveBtn.addEventListener("click", function () {
        if (staffBusy) return;
        saveDefaults({
          action: currentFeedAction(),
          expectedSecondUrl: feedUrl,
          keepCurrent: false
        });
      });
      }
      startStaffPanel();
      if (!staffBound) {
        var staffTries = 0;
        var staffTimer = window.setInterval(function () {
          staffTries += 1;
          startStaffPanel();
          if (staffBound || staffTries > 48) window.clearInterval(staffTimer);
        }, 250);
        if (typeof MutationObserver === "function") {
          var staffObs = new MutationObserver(function () { startStaffPanel(); });
          staffObs.observe(document.documentElement, { childList: true, subtree: true });
        }
      }
    })();

    if (!isProductPage) {
      var hasSceneParam = false;
      try {
        var bootParams = new URLSearchParams(location.search);
        hasSceneParam = !!(bootParams.get("scene") || bootParams.get("dscene"));
      } catch (error) {
        hasSceneParam = false;
      }
      if (!hasSceneParam) {
        var initialScene = String(visualiser.dataset.initialScene || "artwork").toLowerCase();
        var initialView = initialScene === "art" || initialScene === "artwork"
          ? root.querySelector('[data-view="art"]')
          : root.querySelector('[data-view="room"][data-room="' + initialScene + '"]');
        if (initialView) initialView.click();
      }
    }
    updateVariant();

    /* ---------- desktop enlarge / isolate lightbox ---------- */
    (function bindPreviewEnlarge() {
      if (!isProductPage) return;
      var enlargeBtn = visualiser.querySelector("[data-preview-enlarge]");
      var enlargeDialog = visualiser.querySelector("[data-preview-enlarge-dialog]");
      var enlargeMount = enlargeDialog && enlargeDialog.querySelector("[data-preview-enlarge-mount]");
      if (!enlargeBtn || !enlargeDialog || !enlargeMount || typeof enlargeDialog.showModal !== "function") return;

      var desktopQuery = window.matchMedia("(min-width: 1001px)");
      var lastEnlargeTrigger = null;

      function bumpShopifyWidth(url, width) {
        if (!url) return url;
        var next = String(url);
        if (/([?&])width=\d+/i.test(next)) {
          return next.replace(/([?&])width=\d+/i, "$1width=" + width);
        }
        if (/_\d+x(?=\.[a-z]+(?:\?|$))/i.test(next)) {
          return next.replace(/_\d+x(?=\.[a-z]+(?:\?|$))/i, "_" + width + "x");
        }
        return next + (next.indexOf("?") >= 0 ? "&" : "?") + "width=" + width;
      }

      function scaleCssPxValue(value, scale) {
        if (!value) return value;
        return String(value).replace(/(-?\d+\.?\d*)px/g, function (_, num) {
          return (parseFloat(num) * scale) + "px";
        });
      }

      function closeEnlarge() {
        if (enlargeDialog.open) enlargeDialog.close();
        document.documentElement.classList.remove("preview-enlarge-lock");
        enlargeMount.innerHTML = "";
        if (lastEnlargeTrigger && document.contains(lastEnlargeTrigger) && desktopQuery.matches) {
          lastEnlargeTrigger.focus();
        }
        lastEnlargeTrigger = null;
      }

      function openEnlarge() {
        if (!desktopQuery.matches) return;
        var source = visualiser.querySelector('[data-stage="art"] [data-framewrap]')
          || visualiser.querySelector("[data-framewrap]");
        var stage = visualiser.querySelector('[data-stage="art"]')
          || visualiser.querySelector("[data-stage]");
        if (!source || !stage) return;

        lastEnlargeTrigger = enlargeBtn;
        var sourceRect = source.getBoundingClientRect();
        var nativeW = Math.max(1, sourceRect.width);
        var nativeH = Math.max(1, sourceRect.height);
        var maxW = Math.max(200, window.innerWidth - 128);
        var maxH = Math.max(200, window.innerHeight - 120);
        var scale = Math.min(maxW / nativeW, maxH / nativeH, 3);
        var targetW = Math.round(nativeW * scale);
        var targetH = Math.round(nativeH * scale);
        var dpr = Math.min(window.devicePixelRatio || 1, 2.5);
        var imageWidth = Math.min(3600, Math.max(3000, Math.ceil(Math.max(targetW, targetH) * dpr)));

        // Rebuild at the fitted layout size (not CSS transform scale) so the
        // browser re-decodes artwork/moulding at the large display size.
        var clone = source.cloneNode(true);
        clone.removeAttribute("data-framewrap");
        clone.classList.add("preview-enlarge-framewrap");
        clone.style.position = "relative";
        clone.style.left = "0";
        clone.style.top = "0";
        clone.style.right = "auto";
        clone.style.bottom = "auto";
        clone.style.transform = "none";
        clone.style.filter = "none";
        clone.style.boxShadow = "none";
        clone.style.width = targetW + "px";
        clone.style.height = targetH + "px";
        clone.style.maxHeight = "none";
        clone.style.setProperty("--fv-s", frameShadowScale(targetW));
        clone.style.setProperty("--fv-s-fit", frameShadowScale(targetW));
        clone.style.setProperty("--arrange-x", "0px");
        clone.style.setProperty("--arrange-y", "0px");
        clone.style.setProperty("--arrange-s", "1");

        var layer = clone.querySelector("[data-arrange-layer]");
        if (layer) {
          layer.removeAttribute("style");
          layer.removeAttribute("tabindex");
          layer.removeAttribute("aria-label");
        }
        clone.querySelectorAll("[data-arrange-handle]").forEach(function (handle) {
          if (handle.parentNode) handle.parentNode.removeChild(handle);
        });

        clone.querySelectorAll("[data-frame]").forEach(function (frame) {
          ["--frame-w", "--frame-t", "--frame-r", "--frame-b", "--frame-l"].forEach(function (name) {
            var frameW = parseFloat(frame.style.getPropertyValue(name));
            if (!isNaN(frameW) && frameW > 0) frame.style.setProperty(name, (frameW * scale) + "px");
          });
        });
        clone.querySelectorAll("[data-mount]").forEach(function (mount) {
          ["--mount-w", "--mount-t", "--mount-r", "--mount-b", "--mount-l"].forEach(function (name) {
            var mountW = parseFloat(mount.style.getPropertyValue(name));
            if (!isNaN(mountW)) mount.style.setProperty(name, (mountW * scale) + "px");
          });
        });
        var panelSet = clone.querySelector(".triptych, .diptych");
        if (panelSet) {
          var gap = parseFloat(panelSet.style.getPropertyValue("--panel-gap"));
          if (!isNaN(gap)) panelSet.style.setProperty("--panel-gap", (gap * scale) + "px");
        }

        clone.querySelectorAll("[data-piece]").forEach(function (piece) {
          var isSlice = piece.classList.contains("tri-slice") || piece.classList.contains("dip-slice");
          if (isSlice) {
            piece.style.width = "100%";
            piece.style.height = "100%";
            piece.style.aspectRatio = "auto";
            return;
          }
          if (piece.style.backgroundSize) {
            piece.style.backgroundSize = scaleCssPxValue(piece.style.backgroundSize, scale);
          }
          if (piece.style.backgroundPosition) {
            piece.style.backgroundPosition = scaleCssPxValue(piece.style.backgroundPosition, scale);
          }
          var zoomSrc = piece.getAttribute("data-zoom-src");
          var bgUrl = extractBgImageUrl(piece.style.backgroundImage);
          var img = piece.querySelector("img");
          var baseUrl = zoomSrc || (img && (img.currentSrc || img.getAttribute("src"))) || bgUrl;
          var hiUrl = bumpShopifyWidth(baseUrl, imageWidth);
          if (img && hiUrl) {
            img.setAttribute("src", hiUrl);
            img.removeAttribute("srcset");
            img.removeAttribute("sizes");
            img.setAttribute("decoding", "async");
            img.style.imageRendering = "auto";
          }
          if (bgUrl && hiUrl) {
            piece.style.backgroundImage = 'url("' + hiUrl + '")';
          }
          if (hiUrl) piece.setAttribute("data-zoom-src", hiUrl);
        });

        enlargeMount.innerHTML = "";
        var shell = document.createElement("div");
        shell.className = "preview-enlarge-stage";
        stage.classList.forEach(function (name) {
          if (name.indexOf("o-") === 0) shell.classList.add(name);
        });
        ["data-shadow", "data-swoop-render", "data-classic-render", "data-venice-render"].forEach(function (attr) {
          var value = stage.getAttribute(attr);
          if (value != null && value !== "") shell.setAttribute(attr, value);
        });
        shell.appendChild(clone);
        enlargeMount.appendChild(shell);

        enlargeDialog.showModal();
        document.documentElement.classList.add("preview-enlarge-lock");

        if (panelSet) {
          var layoutName = panelSet.classList.contains("triptych") ? "triptych" : "diptych";
          var spec = MULTI_PANEL_SPECS[layoutName];
          var paintCloneSlices = function (urlOverride) {
            if (!spec) return;
            var slices = clone.querySelectorAll(".tri-slice, .dip-slice");
            var first = slices[0];
            if (!first) return;
            var panelPxW = first.clientWidth || first.offsetWidth;
            var panelPxH = first.clientHeight || first.offsetHeight;
            if (!panelPxW || !panelPxH) return;
            var srcUrl = urlOverride || extractBgImageUrl(first.style.backgroundImage);
            if (!srcUrl) return;
            loadImageSize(srcUrl, function (size) {
              if (!size) return;
              var layout = multiPanelSliceLayout(spec, panelPxW, panelPxH, size.w, size.h);
              var escaped = String(srcUrl).replace(/"/g, "%22");
              Array.prototype.forEach.call(slices, function (piece, index) {
                var slice = layout[index];
                if (!slice) return;
                piece.style.backgroundImage = 'url("' + escaped + '")';
                piece.style.backgroundRepeat = "no-repeat";
                piece.style.backgroundSize = slice.size;
                piece.style.backgroundPosition = slice.position;
              });
            });
          };
          paintCloneSlices();
          if (window.requestAnimationFrame) {
            window.requestAnimationFrame(function () {
              paintCloneSlices();
              window.requestAnimationFrame(function () { paintCloneSlices(); });
            });
          }
          var firstSlice = clone.querySelector(".tri-slice, .dip-slice");
          var liveUrl = firstSlice && extractBgImageUrl(firstSlice.style.backgroundImage);
          var hiSliceUrl = bumpShopifyWidth(liveUrl, imageWidth);
          if (hiSliceUrl && hiSliceUrl !== liveUrl) {
            var upgrade = new Image();
            upgrade.onload = function () { paintCloneSlices(hiSliceUrl); };
            upgrade.src = hiSliceUrl;
          }
        }

        var closeBtn = enlargeDialog.querySelector("[data-preview-enlarge-close]");
        if (closeBtn) closeBtn.focus();
      }

      enlargeBtn.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        openEnlarge();
      });

      enlargeDialog.querySelectorAll("[data-preview-enlarge-close]").forEach(function (btn) {
        btn.addEventListener("click", function (event) {
          event.preventDefault();
          closeEnlarge();
        });
      });

      enlargeDialog.addEventListener("click", function (event) {
        if (event.target === enlargeDialog) closeEnlarge();
      });

      enlargeDialog.addEventListener("close", function () {
        document.documentElement.classList.remove("preview-enlarge-lock");
        if (enlargeMount.innerHTML) enlargeMount.innerHTML = "";
      });

      if (desktopQuery.addEventListener) {
        desktopQuery.addEventListener("change", function () {
          if (!desktopQuery.matches) closeEnlarge();
        });
      }
    })();

    visualiser.frameVisualiser = visualiserApi;
    return visualiserApi;
  }

  // Public, instance-safe API for future pages:
  // FrameVisualiser.init(container) → { refresh(), setArtwork(), getOptions(), setOptions() }.
  // `container` may be the [data-frame-visualiser] itself or a wrapper that
  // also contains external option controls / the finish-inspect companion.
  window.FrameVisualiser = {
    init: initFrameVisualiser
  };

  /* ---------- homepage lifestyle scenes ---------- */
  function initHomeScenes() {
    document.querySelectorAll("[data-home-scenes]").forEach(function (root) {
      if (root.hasAttribute("data-room-mosaic")) return;
      if (root.getAttribute("data-home-scenes-bound")) return;
      var poolEl = root.querySelector("[data-home-scenes-pool]");
      var grid = root.querySelector("[data-home-scenes-grid]");
      if (!poolEl || !grid) return;
      var pool;
      try {
      pool = JSON.parse(poolEl.textContent || "[]").filter(function (item) {
        return item && item.scenes && item.scenes.length;
      });
      } catch (err) {
        return;
      }
      if (!pool.length) {
        if (!grid.children.length) root.hidden = true;
        return;
      }
      root.setAttribute("data-home-scenes-bound", "true");
      var count = Math.max(2, Math.min(12, Number(root.getAttribute("data-count")) || 8));
      var randomize = root.getAttribute("data-randomize") !== "false";
      var pinned = [];
      var rest = [];
      var seen = {};
      pool.forEach(function (item) {
        if (!item || !item.handle || seen[item.handle]) return;
        if (!item.scenes || !item.scenes.length) return;
        seen[item.handle] = true;
        if (item.pinned) pinned.push(item);
        else rest.push(item);
      });
      function shuffle(list) {
        var i;
        var j;
        var swap;
        for (i = list.length - 1; i > 0; i -= 1) {
          j = Math.floor(Math.random() * (i + 1));
          swap = list[i];
          list[i] = list[j];
          list[j] = swap;
        }
        return list;
      }
      if (randomize) shuffle(rest);
      var picked = pinned.concat(rest).slice(0, count);
      if (!picked.length) {
        root.hidden = true;
        return;
      }
      function esc(value) {
        return String(value || "")
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/"/g, "&quot;");
      }
      function sceneMarkup(item, role) {
        var scenes = item.scenes;
        var scene = item.pinned || !randomize
          ? scenes[0]
          : (scenes[Math.floor(Math.random() * scenes.length)] || scenes[0]);
        var title = esc(item.title || "Framed print");
        var vendor = esc(item.vendor || "");
        var href = esc(item.url || "#");
        var src = esc(scene && scene.src);
        var alt = esc((scene && scene.alt) || item.title || "");
        var copy = '<span class="home-scenes-copy"><span class="home-scenes-title">' + title + "</span>" +
          (vendor ? '<span class="home-scenes-artist">' + vendor + "</span>" : "") +
          "</span>";
        var img = '<img src="' + src + '" alt="' + alt + '" loading="lazy" decoding="async">';
        if (role === "hero") {
          return '<a class="home-scenes-hero" href="' + href + '">' + img + copy + "</a>";
        }
        return '<li><a class="home-scenes-item" href="' + href + '">' + img + copy + "</a></li>";
      }
      var hero = picked[0];
      var rest = picked.slice(1);
      grid.innerHTML = sceneMarkup(hero, "hero") +
        '<ul class="home-scenes-support">' + rest.map(function (item) {
          return sceneMarkup(item, "support");
        }).join("") + "</ul>";
    });
  }

  /* ---------- homepage carousels (journal + genres) ---------- */
  function initScrollCarousel(section, opts) {
    var track = section.querySelector(opts.track);
    var prev = section.querySelector(opts.prev);
    var next = section.querySelector(opts.next);
    if (!track || !prev || !next) return;

    function slideAmount() {
      var slide = track.querySelector(opts.slide);
      if (!slide) return track.clientWidth * 0.8;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 22;
      return slide.getBoundingClientRect().width + gap;
    }

    function updateButtons() {
      var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth - 2);
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maxScroll;
    }

    function scrollByDir(dir) {
      track.scrollBy({ left: dir * slideAmount(), behavior: "smooth" });
    }

    prev.addEventListener("click", function () { scrollByDir(-1); });
    next.addEventListener("click", function () { scrollByDir(1); });
    track.addEventListener("scroll", updateButtons, { passive: true });
    window.addEventListener("resize", updateButtons);
    updateButtons();
  }

  function initJournalCarousels() {
    document.querySelectorAll("[data-journal-carousel]").forEach(function (section) {
      initScrollCarousel(section, {
        track: "[data-journal-track]",
        prev: "[data-journal-prev]",
        next: "[data-journal-next]",
        slide: ".journal-carousel-slide"
      });
    });
  }

  function initGenreCarousels() {
    document.querySelectorAll("[data-genre-carousel]").forEach(function (section) {
      initScrollCarousel(section, {
        track: "[data-genre-track]",
        prev: "[data-genre-prev]",
        next: "[data-genre-next]",
        slide: ".genre-carousel-slide"
      });
    });
  }

  function initFeaturedCarousels() {
    document.querySelectorAll("[data-featured-carousel]").forEach(function (section) {
      initScrollCarousel(section, {
        track: "[data-featured-track]",
        prev: "[data-featured-prev]",
        next: "[data-featured-next]",
        slide: ".featured-carousel-slide"
      });
    });
  }

  function initGenreArticleCarousels() {
    document.querySelectorAll("[data-genre-article-carousel]").forEach(function (section) {
      initScrollCarousel(section, {
        track: "[data-genre-article-track]",
        prev: "[data-genre-article-prev]",
        next: "[data-genre-article-next]",
        slide: ".journal-carousel-slide"
      });
    });
  }

  function initHowItWorks() {
    var mobileMq = window.matchMedia("(max-width: 680px)");
    document.querySelectorAll("[data-how-it-works]").forEach(function (section) {
      var steps = Array.prototype.slice.call(section.querySelectorAll("[data-hiw-step]"));
      var dotsWrap = section.querySelector("[data-hiw-dots]");
      var prevBtn = section.querySelector("[data-hiw-prev]");
      var nextBtn = section.querySelector("[data-hiw-next]");
      var nextLabel = section.querySelector("[data-hiw-next-label]");
      if (steps.length < 2 || !nextBtn) return;

      var index = Math.max(0, steps.findIndex(function (step) {
        return step.classList.contains("is-active");
      }));
      if (index < 0) index = 0;

      function titleFor(i) {
        return steps[i].getAttribute("data-hiw-title") || ("Step " + (i + 1));
      }

      if (dotsWrap && !dotsWrap.children.length) {
        steps.forEach(function (step, i) {
          var dot = document.createElement("button");
          dot.type = "button";
          dot.className = "how-it-works-dot";
          dot.setAttribute("aria-label", "Step " + (i + 1) + ": " + titleFor(i));
          dot.addEventListener("click", function () {
            if (!mobileMq.matches) return;
            show(i);
          });
          dotsWrap.appendChild(dot);
        });
      }

      function showDesktop() {
        steps.forEach(function (step) {
          step.hidden = false;
          step.classList.add("is-active");
        });
        if (prevBtn) prevBtn.hidden = true;
      }

      function show(i) {
        index = (i + steps.length) % steps.length;
        steps.forEach(function (step, n) {
          var on = n === index;
          step.classList.toggle("is-active", on);
          step.hidden = !on;
        });
        if (dotsWrap) {
          Array.prototype.forEach.call(dotsWrap.children, function (dot, n) {
            dot.setAttribute("aria-current", n === index ? "true" : "false");
          });
        }
        if (prevBtn) prevBtn.hidden = index === 0;
        if (nextLabel) {
          if (index >= steps.length - 1) nextLabel.textContent = "Start again";
          else nextLabel.textContent = "Next: " + titleFor(index + 1);
        }
      }

      function syncMode() {
        showDesktop();
      }

      if (prevBtn) {
        prevBtn.addEventListener("click", function () {
          if (!mobileMq.matches) return;
          show(index - 1);
        });
      }
      nextBtn.addEventListener("click", function () {
        if (!mobileMq.matches) return;
        show(index + 1);
      });

      if (mobileMq.addEventListener) mobileMq.addEventListener("change", syncMode);
      else if (mobileMq.addListener) mobileMq.addListener(syncMode);
      syncMode();
    });
  }

  function initDiscoverPromos() {
    document.querySelectorAll("[data-discover-promo]").forEach(function (stage) {
      var scenes = Array.prototype.slice.call(stage.querySelectorAll("[data-promo-scene]"));
      var tabs = Array.prototype.slice.call(stage.querySelectorAll("button[data-promo-tab]"));
      if (scenes.length < 2) return;

      var intervalMs = parseInt(stage.getAttribute("data-promo-interval"), 10) || 5000;
      var index = Math.max(0, scenes.findIndex(function (scene) {
        return scene.classList.contains("is-active");
      }));
      var timer = 0;
      var reduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

      function setRoom(room, user) {
        var nextIndex = scenes.findIndex(function (scene) {
          return scene.getAttribute("data-promo-scene") === room;
        });
        if (nextIndex < 0) return;
        index = nextIndex;
        stage.setAttribute("data-promo-room", room);
        scenes.forEach(function (scene, i) {
          scene.classList.toggle("is-active", i === index);
        });
        tabs.forEach(function (tab) {
          var active = tab.getAttribute("data-promo-tab") === room;
          tab.classList.toggle("is-active", active);
          tab.setAttribute("aria-selected", active ? "true" : "false");
        });
        if (user) restart();
      }

      function next() {
        var nextIndex = (index + 1) % scenes.length;
        setRoom(scenes[nextIndex].getAttribute("data-promo-scene"), false);
      }

      function stop() {
        if (timer) {
          window.clearInterval(timer);
          timer = 0;
        }
      }

      function restart() {
        stop();
        if (reduced) return;
        timer = window.setInterval(next, intervalMs);
      }

      tabs.forEach(function (tab) {
        tab.addEventListener("click", function () {
          setRoom(tab.getAttribute("data-promo-tab"), true);
        });
      });

      stage.addEventListener("mouseenter", stop);
      stage.addEventListener("mouseleave", restart);
      stage.addEventListener("focusin", stop);
      stage.addEventListener("focusout", function (event) {
        if (!stage.contains(event.relatedTarget)) restart();
      });

      setRoom(scenes[index].getAttribute("data-promo-scene") || "lounge", false);
      restart();
    });
  }

  function initTagClouds() {
    document.querySelectorAll("[data-tag-cloud]").forEach(function (stage) {
      var frames = Array.prototype.slice.call(stage.querySelectorAll("[data-tag-frame]"));
      var items = Array.prototype.slice.call(stage.querySelectorAll("[data-tag-show]"));
      var labelEl = stage.querySelector("[data-tag-visual-label]");
      if (!frames.length || !items.length) return;

      var intervalMs = parseInt(stage.getAttribute("data-tag-interval"), 10) || 3800;
      var index = 0;
      var timer = 0;
      var paused = false;
      var reduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

      function labelForIndex(i) {
        var item = items.find(function (el) {
          return el.getAttribute("data-tag-show") === String(i);
        });
        if (!item) return "";
        var link = item.querySelector(".tag-cloud-link");
        return link ? link.textContent.trim() : "";
      }

      function setIndex(nextIndex, fromUser) {
        if (nextIndex < 0 || nextIndex >= frames.length) return;
        index = nextIndex;
        frames.forEach(function (frame, i) {
          frame.classList.toggle("is-active", i === index);
        });
        items.forEach(function (item) {
          item.classList.toggle("is-active", item.getAttribute("data-tag-show") === String(index));
        });
        if (labelEl) {
          var nextLabel = labelForIndex(index);
          if (reduced) {
            labelEl.textContent = nextLabel;
          } else {
            labelEl.classList.add("is-swap");
            window.setTimeout(function () {
              labelEl.textContent = nextLabel;
              labelEl.classList.remove("is-swap");
            }, 180);
          }
        }
        if (fromUser) restart();
      }

      function next() {
        if (paused) return;
        setIndex((index + 1) % frames.length, false);
      }

      function stop() {
        paused = true;
        if (timer) {
          window.clearInterval(timer);
          timer = 0;
        }
      }

      function restart() {
        stop();
        paused = false;
        if (reduced || frames.length < 2) return;
        timer = window.setInterval(next, intervalMs);
      }

      items.forEach(function (item) {
        var show = item.getAttribute("data-tag-show");
        function activate() {
          setIndex(parseInt(show, 10), true);
        }
        item.addEventListener("mouseenter", activate);
        item.addEventListener("focusin", activate);
      });

      stage.addEventListener("mouseenter", function () { paused = true; });
      stage.addEventListener("mouseleave", restart);
      stage.addEventListener("focusin", function () { paused = true; });
      stage.addEventListener("focusout", function (event) {
        if (!stage.contains(event.relatedTarget)) restart();
      });

      setIndex(0, false);
      restart();
    });
  }

  function initCollectionMobileFilters() {
    document.querySelectorAll("[data-collection-filters]").forEach(function (root) {
      var toggle = root.querySelector("[data-filters-mobile-toggle]");
      var panel = root.querySelector("[data-filters-panel]");
      var closeBtn = root.querySelector("[data-filters-mobile-close]");
      var results = root.closest(".coll-layout") && root.closest(".coll-layout").querySelector(".coll-main");
      if (!toggle || !panel || !closeBtn) return;

      var mobileQuery = window.matchMedia("(max-width: 680px)");
      function setOpen(open) {
        open = !mobileQuery.matches || open;
        panel.hidden = !open;
        toggle.setAttribute("aria-expanded", open ? "true" : "false");
      }
      toggle.addEventListener("click", function () {
        setOpen(toggle.getAttribute("aria-expanded") !== "true");
      });
      closeBtn.addEventListener("click", function () {
        setOpen(false);
        if (results && results.scrollIntoView) {
          results.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
      document.addEventListener("keydown", function (event) {
        if (
          event.key === "Escape" &&
          mobileQuery.matches &&
          toggle.getAttribute("aria-expanded") === "true"
        ) {
          event.preventDefault();
          setOpen(false);
          toggle.focus();
        }
      });
      if (mobileQuery.addEventListener) {
        mobileQuery.addEventListener("change", function () {
          setOpen(!mobileQuery.matches);
        });
      } else if (mobileQuery.addListener) {
        mobileQuery.addListener(function () {
          setOpen(!mobileQuery.matches);
        });
      }
      setOpen(!mobileQuery.matches);
    });
  }

  function initPriceFilters() {
    document.querySelectorAll("[data-price-filter]").forEach(function (root) {
      var maxInput = root.querySelector("[data-price-max]");
      var range = root.querySelector("[data-price-range]");
      var label = root.querySelector("[data-price-range-label]");
      if (!maxInput || !range) return;

      function syncFromRange() {
        maxInput.value = range.value;
        if (label) label.textContent = range.value;
      }
      function syncFromMax() {
        var max = Number(range.max) || 0;
        var value = maxInput.value === "" ? max : Number(maxInput.value);
        if (!isFinite(value)) return;
        if (value < 0) value = 0;
        if (value > max) value = max;
        range.value = String(value);
        if (label) label.textContent = String(value);
      }

      range.addEventListener("input", syncFromRange);
      maxInput.addEventListener("input", syncFromMax);
      maxInput.addEventListener("change", syncFromMax);
    });
  }

  function initCollectionFrameCustomise() {
    var MODE_KEY = "artfolio-coll-frames";
    var PREFS_KEY = "artfolio-coll-frame-prefs";
    var host = document.querySelector("[data-coll-customise]");
    var toggles = document.querySelectorAll("[data-coll-frame-toggle]");
    if (!host && !toggles.length) return;

    var DEFAULT_PREFS = {
      frametype: "Classic",
      frame: "Oak",
      mount: "Mounted",
      mountColour: "Fresh Linen"
    };

    var FRAME_COLOURS = {
      oak: "linear-gradient(135deg,#C49A66,#A87E4C)",
      black: "#1B1A18",
      white: "#F4F1EA",
      gold: "linear-gradient(135deg,#D9B978,#B8934E)",
      silver: "linear-gradient(135deg,#D8DBDE,#AEB4B9)",
      bronze: "linear-gradient(135deg,#B08D5B,#7C5C34)",
      natural: "linear-gradient(135deg,#E6D6BC,#CBB68E)",
      "antique-gold": "linear-gradient(135deg,#C7A867,#93753F)",
      "antique-silver": "linear-gradient(135deg,#C4C3BC,#98968C)",
      "black-pewter": "linear-gradient(135deg,#26262a,#26262a 55%,#9a9ea1 55%,#7f8386)",
      "terracotta-silver": "linear-gradient(135deg,#b5673f,#b5673f 55%,#c9ccce 55%,#aeb2b5)",
      "white-silver": "linear-gradient(135deg,#f0ede7,#f0ede7 55%,#cfd2d5 55%,#b8bcbf)"
    };
    var MOUNT_COLOURS = {
      white: "#FFFFFF",
      "snow white": "#EDF0F0",
      "fresh linen": "#EEE9E3",
      "warm sand": "#E8DABF",
      "french grey": "#C3BCA8",
      olive: "#7E7661",
      black: "#2D2824",
      snow: "#EDF0F0",
      ivory: "#EEE9E3",
      stone: "#C3BCA8",
      charcoal: "#2D2824",
      sage: "#7E7661",
      clay: "#E8DABF"
    };
    var FINISH = {
      oak: { out: "#cda86f", mid: "#9b7a4d", inn: "#bb976a", hi: "#e6cd9d", grain: "rgba(70,44,16,.13)" },
      black: { out: "#33302d", mid: "#121110", inn: "#262321", hi: "#4d4945", grain: "rgba(255,255,255,.05)" },
      white: { out: "#f3efe9", mid: "#dad4ca", inn: "#eae5dd", hi: "#ffffff", grain: "rgba(0,0,0,.035)" },
      gold: { out: "#d9b978", mid: "#b8934e", inn: "#c9a45c", hi: "#e8d09a", grain: "rgba(90,60,10,.10)" },
      silver: { out: "#d8dbde", mid: "#aeb4b9", inn: "#c4c8cc", hi: "#eceef0", grain: "rgba(0,0,0,.04)" },
      bronze: { out: "#b08d5b", mid: "#7c5c34", inn: "#997745", hi: "#caa870", grain: "rgba(60,30,8,.12)" },
      natural: { out: "#e6d6bc", mid: "#cbb68e", inn: "#d9c7a5", hi: "#f2eadb", grain: "rgba(70,44,16,.10)" },
      "antique-gold": { out: "#c7a867", mid: "#93753f", inn: "#b0924e", hi: "#d9c080", grain: "rgba(80,50,10,.10)" },
      "antique-silver": { out: "#c4c3bc", mid: "#98968c", inn: "#b0aea6", hi: "#d6d5d0", grain: "rgba(0,0,0,.05)" },
      "black-pewter": { out: "#3a3a3e", mid: "#1a1a1c", inn: "#2a2a2e", hi: "#9a9ea1", grain: "rgba(255,255,255,.05)" },
      "terracotta-silver": { out: "#c47852", mid: "#b5673f", inn: "#a05535", hi: "#c9ccce", grain: "rgba(80,40,10,.10)" },
      "white-silver": { out: "#f0ede7", mid: "#e0dbd2", inn: "#ece8e0", hi: "#cfd2d5", grain: "rgba(0,0,0,.04)" }
    };
    var CSS_COLOURS = ["None", "Oak", "Black", "White"];
    var PHOTO_COLOURS = {
      swoop: ["White", "Black", "Gold", "Silver"],
      classic: ["Oak", "Black", "White", "Gold", "Silver", "Bronze", "Natural", "Antique Gold", "Antique Silver"],
      venice: ["Silver", "Black and Pewter", "Terracotta and Silver", "White and Silver"]
    };
    var SWOOP_PHOTO = { white: 1, black: 1, gold: 1, silver: 1 };
    var CLASSIC_PHOTO = { oak: 1, black: 1, white: 1, gold: 1, silver: 1, bronze: 1, natural: 1, "antique-gold": 1, "antique-silver": 1 };
    var CLASSIC_RAIL_PHOTO = { oak: 1, black: 1, white: 1, gold: 1, silver: 1, bronze: 1, natural: 1, "antique-gold": 1, "antique-silver": 1 };
    var DEEP_CLASSIC_RAIL_PHOTO = { oak: 1, black: 1, white: 1, gold: 1, silver: 1, bronze: 1, natural: 1, "antique-gold": 1, "antique-silver": 1 };
    var VENICE_PHOTO = { silver: 1, "black-pewter": 1, "terracotta-silver": 1, "white-silver": 1 };
    var FRAME_W = { standard: "9px", swoop: "14px", widebox: "9px", venice: "11px" };
    var FRAME_COLOUR_DEFAULTS = { standard: "Oak", widebox: "Oak", swoop: "Black", venice: "Silver" };
    var frameColourByStyle = {
      standard: FRAME_COLOUR_DEFAULTS.standard,
      widebox: FRAME_COLOUR_DEFAULTS.widebox,
      swoop: FRAME_COLOUR_DEFAULTS.swoop,
      venice: FRAME_COLOUR_DEFAULTS.venice
    };

    function colourForStyle(ftype) {
      var key = ftype || "standard";
      return frameColourByStyle[key] || FRAME_COLOUR_DEFAULTS[key] || "Oak";
    }

    function stylePhotoFamily(chip) {
      if (chip === "swoop") return "swoop";
      if (chip === "venice") return "venice";
      if (chip === "widebox") return "deep-classic";
      return "classic";
    }

    var PROFILE_COLOUR_KEYS = {
      oak: 1, black: 1, white: 1, gold: 1, silver: 1, bronze: 1, natural: 1,
      "antique-gold": 1, "antique-silver": 1
    };
    var VENICE_PROFILE_KEYS = {
      silver: 1,
      "black-pewter": 1,
      "terracotta-silver": 1,
      "white-silver": 1
    };

    function profileColourKey(val, family) {
      var k = colourKey(val);
      if (family === "venice") {
        if (VENICE_PROFILE_KEYS[k]) return k;
        if (k === "black") return "black-pewter";
        if (k === "white") return "white-silver";
        if (k === "bronze" || k === "terracotta") return "terracotta-silver";
        return "silver";
      }
      if (k === "black-pewter") return "black";
      if (k === "terracotta-silver") return "bronze";
      if (k === "white-silver") return "white";
      return PROFILE_COLOUR_KEYS[k] ? k : "oak";
    }

    function styleProfileLabel(family) {
      if (family === "deep-classic") return "Deep Classic";
      if (family === "swoop") return "Swoop";
      if (family === "venice") return "Venice";
      return "Classic";
    }

    function frameProfileFilename(profile) {
      if (profile.indexOf("deep-classic-") === 0) return "frame-profile-" + profile + "-r2.png";
      if (/^swoop-(white|black|gold|silver)$/.test(profile)) return "frame-profile-" + profile + "-r2.png";
      if (/^venice-(silver|black-pewter|terracotta-silver|white-silver)$/.test(profile)) {
        return "frame-profile-" + profile + "-r2.png";
      }
      return "frame-profile-" + profile + ".png";
    }

    function syncFrameStylePreviews(panel, frameVal) {
      if (!panel) return;
      // Only the selected style tile follows the active frame colour.
      var colour = frameVal || prefs.frame || "Oak";
      var frameNone = !colour || /no frame|none|unframed/i.test(colour);
      var colourLabel = frameNone ? "Oak" : colour;
      panel.querySelectorAll(".frame-style-swatch").forEach(function (swatch) {
        var el = swatch.querySelector(".frame-style-preview");
        if (!el) return;
        var family = el.getAttribute("data-profile-family") || stylePhotoFamily(el.getAttribute("data-chip"));
        var isActive = swatch.getAttribute("aria-pressed") === "true";
        var fallbackKey = family === "swoop" ? "black" : family === "venice" ? "silver" : "oak";
        var fkey = frameNone ? fallbackKey : profileColourKey(colour, family);
        var profile = isActive
          ? family + "-" + fkey
          : (el.getAttribute("data-default-profile") || family + "-" + fallbackKey);
        if (family === "swoop" && !/^swoop-(white|black|gold|silver)$/.test(profile)) {
          profile = "swoop-black";
        }
        if (family === "venice" && !/^venice-(silver|black-pewter|terracotta-silver|white-silver)$/.test(profile)) {
          profile = "venice-silver";
        }
        var label;
        if (!isActive) {
          label = family === "swoop" ? "Black" : family === "venice" ? "Silver" : "Oak";
        } else if (frameNone) {
          label = family === "swoop" ? "Black" : family === "venice" ? "Silver" : "Oak";
        } else {
          label = colourLabel;
        }
        el.setAttribute("data-profile", profile);
        var img = el.querySelector(".frame-style-profile");
        if (!img) return;
        swapFrameStyleProfile(img, frameProfileFilename(profile), styleProfileLabel(family) + " frame profile — " + label);
      });
    }

    function colourKey(val) {
      if (!val) return "";
      var v = String(val).toLowerCase();
      if (v === "antique gold") return "antique-gold";
      if (v === "antique silver") return "antique-silver";
      if (v === "black and pewter") return "black-pewter";
      if (v === "terracotta and silver") return "terracotta-silver";
      if (v === "white and silver") return "white-silver";
      return v.split(" ")[0];
    }
    function typeKey(v) {
      v = String(v || "").toLowerCase();
      if (v.indexOf("swoop") > -1) return "swoop";
      if (v.indexOf("venice") > -1) return "venice";
      if (v.indexOf("wide") > -1 || v.indexOf("box") > -1 || v.indexOf("deep") > -1) return "widebox";
      return "standard";
    }
    function railBg(tk, fk, side) {
      var f = FINISH[fk] || FINISH.black;
      var dir = side === "t" ? "to bottom" : side === "b" ? "to top" : side === "l" ? "to right" : "to left";
      var prof;
      if (tk === "standard") prof = "linear-gradient(" + dir + "," + f.out + "," + f.mid + " 58%," + f.inn + ")";
      else if (tk === "swoop") {
        prof = "linear-gradient(" + dir + "," + f.out + " 0%," + f.hi + " 9%," + f.mid + " 50%," + f.out + " 91%," + f.inn + ")";
      } else if (tk === "venice") {
        prof = "linear-gradient(" + dir + "," + f.out + " 0%," + f.hi + " 12%," + f.mid + " 45%," + f.out + " 88%," + f.inn + ")";
      } else {
        prof = "linear-gradient(" + dir + "," + f.hi + " 0%," + f.out + " 15%," + f.mid + " 36%," + f.mid + " 84%," + f.inn + ")";
      }
      var gd = side === "t" || side === "b" ? "90deg" : "0deg";
      var grain = "repeating-linear-gradient(" + gd + ",transparent 0 2px," + f.grain + " 2px 2.7px,transparent 2.7px 5.4px)";
      return grain + "," + prof;
    }
    function finishBg(fk) {
      var f = FINISH[fk] || FINISH.black;
      return (
        "radial-gradient(130% 100% at 30% 20%," +
        f.hi +
        "55,transparent 60%),repeating-linear-gradient(8deg,transparent 0 3px," +
        f.grain +
        " 3px 4px,transparent 4px 7px),linear-gradient(135deg," +
        f.out +
        "," +
        f.mid +
        ")"
      );
    }

    function readMode() {
      try {
        var stored = window.localStorage.getItem(MODE_KEY);
        if (stored === "on" || stored === "off") return stored;
      } catch (e) {}
      if (document.querySelector("[data-artist-grid-controls]")) return "on";
      return "off";
    }
    function writeMode(mode) {
      try {
        window.localStorage.setItem(MODE_KEY, mode);
      } catch (e) {}
    }
    function readPrefs() {
      var prefs = Object.assign({}, DEFAULT_PREFS);
      try {
        var raw = window.localStorage.getItem(PREFS_KEY);
        if (!raw) return prefs;
        var parsed = JSON.parse(raw);
        if (parsed && typeof parsed === "object") {
          if (parsed.frametype) prefs.frametype = parsed.frametype;
          if (parsed.frame) prefs.frame = parsed.frame;
          if (parsed.mount) prefs.mount = parsed.mount;
          if (parsed.mountColour) prefs.mountColour = parsed.mountColour;
        }
      } catch (e) {}
      return prefs;
    }
    function writePrefs(prefs) {
      try {
        window.localStorage.setItem(PREFS_KEY, JSON.stringify(prefs));
      } catch (e) {}
    }
    function clearPrefs() {
      try {
        window.localStorage.removeItem(PREFS_KEY);
      } catch (e) {}
    }
    function hasStoredPrefs() {
      try {
        return !!window.localStorage.getItem(PREFS_KEY);
      } catch (e) {
        return false;
      }
    }

    var prefs = readPrefs();
    frameColourByStyle[typeKey(prefs.frametype)] = prefs.frame || colourForStyle(typeKey(prefs.frametype));
    var mode = readMode();
    var overrideActive = hasStoredPrefs();

    function snapshotCardDefaults() {
      document.querySelectorAll(".card-frame").forEach(function (frame) {
        if (frame._collDefault) return;
        var mount = frame.querySelector(".card-mount");
        frame._collDefault = {
          className: frame.className,
          classic: frame.getAttribute("data-classic"),
          deepClassic: frame.getAttribute("data-deep-classic"),
          swoop: frame.getAttribute("data-swoop"),
          venice: frame.getAttribute("data-venice"),
          frameType: frame.getAttribute("data-frame-type"),
          style: frame.getAttribute("style"),
          mountClass: mount ? mount.className : null,
          mountStyle: mount ? mount.getAttribute("style") : null,
          rails: Array.prototype.map.call(frame.querySelectorAll(".card-rail"), function (rail) {
            return rail.getAttribute("style");
          })
        };
      });
    }

    function restoreCardDefaults() {
      document.querySelectorAll(".card-frame").forEach(function (frame) {
        var d = frame._collDefault;
        if (!d) return;
        frame.className = d.className;
        ["data-classic", "data-deep-classic", "data-swoop", "data-venice", "data-frame-type"].forEach(function (attr) {
          frame.removeAttribute(attr);
        });
        if (d.classic != null) frame.setAttribute("data-classic", d.classic);
        if (d.deepClassic != null) frame.setAttribute("data-deep-classic", d.deepClassic);
        if (d.swoop != null) frame.setAttribute("data-swoop", d.swoop);
        if (d.venice != null) frame.setAttribute("data-venice", d.venice);
        if (d.frameType != null) frame.setAttribute("data-frame-type", d.frameType);
        if (d.style != null) frame.setAttribute("style", d.style);
        else frame.removeAttribute("style");
        var mount = frame.querySelector(".card-mount");
        if (mount) {
          if (d.mountClass != null) mount.className = d.mountClass;
          if (d.mountStyle != null) mount.setAttribute("style", d.mountStyle);
          else mount.removeAttribute("style");
        }
        frame.querySelectorAll(".card-rail").forEach(function (rail, i) {
          var railStyle = d.rails && d.rails[i];
          if (railStyle != null) rail.setAttribute("style", railStyle);
          else rail.removeAttribute("style");
        });
      });
    }

    function syncResetUi() {
      var panel = drawer || host;
      if (!panel) return;
      var resetBtn = panel.querySelector("[data-coll-reset]");
      var resetNote = panel.querySelector("[data-coll-reset-note]");
      if (resetBtn) {
        resetBtn.disabled = !overrideActive;
        resetBtn.setAttribute("aria-disabled", overrideActive ? "false" : "true");
      }
      if (resetNote) {
        resetNote.textContent = overrideActive
          ? "Gallery override is on. Reset to show each print’s default frame."
          : "Each print shows its own default frame.";
      }
      if (host) host.setAttribute("data-coll-override", overrideActive ? "on" : "off");
    }

    function setMode(next, persist) {
      mode = next === "on" ? "on" : "off";
      document.querySelectorAll("[data-coll-frames]").forEach(function (grid) {
        grid.setAttribute("data-coll-frames", mode);
      });
      toggles.forEach(function (toggle) {
        toggle.querySelectorAll("[data-coll-frames-value]").forEach(function (btn) {
          var on = btn.getAttribute("data-coll-frames-value") === mode;
          btn.classList.toggle("is-active", on);
          btn.setAttribute("aria-pressed", on ? "true" : "false");
        });
      });
      var frameHint = document.querySelector("[data-coll-frame-cue]");
      if (frameHint) frameHint.hidden = mode !== "on";
      if (persist !== false) writeMode(mode);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          document.querySelectorAll("[data-format-panels]").forEach(sizeCollectionFormatCard);
          sizeAllSingleFrameCards();
        });
      });
    }

    function syncDrawerUi() {
      var panel = drawer || host;
      if (!panel) return;
      ["frametype", "frame", "mount", "mountColour"].forEach(function (key) {
        var val = prefs[key];
        var label = panel.querySelector('[data-coll-val="' + key + '"]');
        var matchBtn = null;
        panel.querySelectorAll('[data-coll-opt="' + key + '"]').forEach(function (btn) {
          var on = btn.getAttribute("data-value") === val;
          btn.setAttribute("aria-pressed", on ? "true" : "false");
          if (on) matchBtn = btn;
        });
        if (label) {
          label.textContent = (key === "frametype" && matchBtn && matchBtn.getAttribute("data-display-name")) || val;
        }
      });

      var ftype = typeKey(prefs.frametype);
      var activeList;
      if (ftype === "standard" || ftype === "widebox") {
        activeList = ["None"].concat(PHOTO_COLOURS.classic);
      } else if (ftype === "swoop") {
        activeList = PHOTO_COLOURS.swoop.slice();
      } else if (ftype === "venice") {
        activeList = PHOTO_COLOURS.venice.slice();
      } else {
        activeList = CSS_COLOURS.slice();
      }

      var frameGroup = panel.querySelector('[data-coll-group="frame"]');
      if (frameGroup) {
        if (ftype === "standard") frameGroup.setAttribute("data-frame-finish-family", "classic");
        else if (ftype === "widebox") frameGroup.setAttribute("data-frame-finish-family", "deep-classic");
        else frameGroup.removeAttribute("data-frame-finish-family");
      }

      var frameButtons = panel.querySelectorAll('[data-coll-opt="frame"]');
      var currentValid = false;
      var styleDefault = FRAME_COLOUR_DEFAULTS[ftype] || "Oak";
      var firstValid = null;
      var defaultValid = null;
      frameButtons.forEach(function (btn) {
        var value = btn.getAttribute("data-value");
        var allowed = activeList.indexOf(value) !== -1;
        btn.hidden = !allowed;
        btn.disabled = !allowed;
        if (allowed && !firstValid) firstValid = value;
        if (allowed && value === styleDefault) defaultValid = value;
        if (allowed && value === prefs.frame) currentValid = true;
      });
      if (!currentValid) {
        prefs.frame = defaultValid || firstValid || prefs.frame;
      }
      if (prefs.frame) frameColourByStyle[ftype] = prefs.frame;
      var frameLabel = panel.querySelector('[data-coll-val="frame"]');
      if (frameLabel) frameLabel.textContent = prefs.frame;
      frameButtons.forEach(function (btn) {
        btn.setAttribute("aria-pressed", btn.getAttribute("data-value") === prefs.frame ? "true" : "false");
      });

      var mounted = prefs.mount === "Mounted";
      var mountSwitch = panel.querySelector("[data-coll-mount-switch]");
      if (mountSwitch) mountSwitch.setAttribute("aria-checked", mounted ? "true" : "false");
      var mountTitle = panel.querySelector("[data-coll-mount-title]");
      var mountSub = panel.querySelector("[data-coll-mount-sub]");
      if (mountTitle) mountTitle.textContent = mounted ? "Mounted" : "No mount";
      if (mountSub) mountSub.textContent = mounted ? "Bordered with card" : "Print to the frame edge";
      var mountColourOpt = panel.querySelector("[data-coll-mount-colour-opt]");
      if (mountColourOpt) mountColourOpt.hidden = !mounted;

      var fkey = colourKey(prefs.frame);
      syncFrameStylePreviews(panel, prefs.frame);
      var fpSwatch = panel.querySelector("[data-fp-swatch]");
      var fpName = panel.querySelector("[data-fp-name]");
      var frameNone = !prefs.frame || /none/i.test(prefs.frame);
      if (fpName) {
        fpName.textContent = frameNone
          ? "No frame selected"
          : "Close-up: " + prefs.frametype + " " + prefs.frame;
      }
      if (fpSwatch) {
        var photoStyle = ftype === "swoop" ? "swoop"
          : ftype === "standard" ? "classic"
          : ftype === "widebox" ? "deep-classic"
          : ftype === "venice" ? "venice"
          : null;
        var photoKeys = ftype === "swoop" ? SWOOP_PHOTO
          : (ftype === "standard" || ftype === "widebox") ? CLASSIC_PHOTO
          : ftype === "venice" ? VENICE_PHOTO
          : {};
        var finishKey = photoStyle ? photoStyle + "-" + fkey : "";
        if (!frameNone && photoStyle && photoKeys[fkey]) {
          fpSwatch.setAttribute("data-finish", finishKey);
          fpSwatch.style.backgroundImage = "";
        } else {
          fpSwatch.removeAttribute("data-finish");
          fpSwatch.style.backgroundImage = frameNone ? "" : finishBg(fkey || "black");
        }
      }
    }

    function applyCards() {
      var ftype = typeKey(prefs.frametype);
      var fkey = colourKey(prefs.frame);
      var frameNone = !prefs.frame || /none/i.test(prefs.frame);
      var mounted = prefs.mount === "Mounted" && !frameNone;
      var mountBg = MOUNT_COLOURS[String(prefs.mountColour || "Fresh Linen").toLowerCase()] || "#EEE9E3";
      var frameW = FRAME_W[ftype] || FRAME_W.standard;
      var photoPlan = frameNone
        ? null
        : frameRailPhotoPlan(ftype, fkey, { swoop: "photo", classic: "photo", venice: "photo" });
      if (photoPlan) {
        frameRailFilenames(photoPlan.prefix, photoPlan.key).forEach(prefetchFrameAsset);
      }

      document.querySelectorAll(".card-frame").forEach(function (frame) {
        var mount = frame.querySelector(".card-mount");
        frame.classList.toggle("is-none", frameNone);
        frame.setAttribute("data-frame-type", ftype);

        if (frameNone) {
          clearFramePhotoAttrs(frame);
          frame.style.removeProperty("--frame-bg");
          frame.style.setProperty("--frame-w", "0px");
          if (mount) {
            mount.classList.add("is-off");
            mount.style.setProperty("--mount-w", "0px");
          }
          frame.querySelectorAll(".card-rail").forEach(function (rail) {
            rail.style.backgroundImage = "";
          });
          return;
        }

        var formatMedia = frame.closest("[data-format-panels]");
        if (!formatMedia) {
          frame.style.setProperty("--frame-w", frameW);
          if (mount) {
            mount.classList.toggle("is-off", !mounted);
            mount.style.setProperty("--mount-bg", mountBg);
          }
          sizeSingleFrameCard(frame);
        } else if (mount) {
          mount.classList.toggle("is-off", !mounted);
          mount.style.setProperty("--mount-bg", mountBg);
        }

        var applyToken = (frame._railApplyToken || 0) + 1;
        frame._railApplyToken = applyToken;
        var nextBg = FRAME_COLOURS[fkey] || "#1B1A18";

        if (photoPlan) {
          whenFrameAssetsReady(frameRailFilenames(photoPlan.prefix, photoPlan.key), function () {
            if (frame._railApplyToken !== applyToken) return;
            frame.style.setProperty("--frame-bg", nextBg);
            applyFramePhotoAttrs(frame, photoPlan);
          });
        } else {
          frame.style.setProperty("--frame-bg", nextBg);
          clearFramePhotoAttrs(frame);
          ["t", "r", "b", "l"].forEach(function (side) {
            var rail = frame.querySelector(".card-rail--" + side);
            if (rail) rail.style.backgroundImage = railBg(ftype, fkey || "black", side);
          });
        }
      });
      document.querySelectorAll("[data-format-panels]").forEach(sizeCollectionFormatCard);
    }

    function commitPrefs(next, enableFramed) {
      prefs = Object.assign({}, prefs, next);
      overrideActive = true;
      syncDrawerUi();
      writePrefs(prefs);
      applyCards();
      syncResetUi();
      if (enableFramed) setMode("on", true);
    }

    function resetToProductDefaults() {
      if (!overrideActive) return;
      clearPrefs();
      overrideActive = false;
      prefs = Object.assign({}, DEFAULT_PREFS);
      restoreCardDefaults();
      document.querySelectorAll("[data-format-panels]").forEach(sizeCollectionFormatCard);
      sizeAllSingleFrameCards();
      syncDrawerUi();
      syncResetUi();
    }

    // Print / Framed toggle — listeners wired after drawer/cue so Framed can open Customise.
    setMode(mode, false);

    snapshotCardDefaults();
    scheduleFrameRailPrefetch({ swoop: "photo", classic: "photo", venice: "photo" });

    if (!host) {
      toggles.forEach(function (toggle) {
        toggle.addEventListener("click", function (event) {
          var btn = event.target.closest("[data-coll-frames-value]");
          if (!btn || !toggle.contains(btn)) return;
          setMode(btn.getAttribute("data-coll-frames-value"), true);
        });
      });
      if (overrideActive) applyCards();
      return;
    }

    // Resolve drawer before portal so UI queries keep working after move to body.
    var drawer = host.querySelector("[data-coll-drawer]");
    var drawerBackdrop = host.querySelector("[data-coll-drawer-backdrop]");
    var drawerTab = host.querySelector(".discover-edge-tab");
    var drawerToggle = host.querySelector("[data-coll-drawer-toggle]");
    var drawerClose = host.querySelector("[data-coll-drawer-close]");
    var frameHint = document.querySelector("[data-coll-frame-cue]");
    var lastOpener = null;
    var openCustomiseDrawer = function () {};

    if (drawer && drawerBackdrop && drawerTab && drawerToggle && drawerClose) {
      document.body.appendChild(drawerBackdrop);
      document.body.appendChild(drawer);
      document.body.appendChild(drawerTab);

      var drawerRevealTimer = null;
      function cancelDrawerReveal() {
        if (!drawerRevealTimer) return;
        window.clearTimeout(drawerRevealTimer);
        drawerRevealTimer = null;
      }
      function drawerIsOpen() {
        return host.getAttribute("data-drawer-open") === "true";
      }
      function setDrawerOpen(open, moveFocus) {
        host.setAttribute("data-drawer-open", open ? "true" : "false");
        document.documentElement.classList.toggle("discover-drawer-open", open);
        drawer.setAttribute("aria-hidden", open ? "false" : "true");
        if (open) drawer.removeAttribute("inert");
        else drawer.setAttribute("inert", "");
        drawerToggle.setAttribute("aria-expanded", open ? "true" : "false");
        drawerBackdrop.hidden = !open;
        document.documentElement.classList.toggle(
          "discover-drawer-lock",
          open && window.matchMedia("(max-width: 900px)").matches
        );
        if (!moveFocus) return;
        if (open) drawer.focus();
        else if (lastOpener) lastOpener.focus();
      }

      openCustomiseDrawer = function (opener) {
        cancelDrawerReveal();
        lastOpener = opener || drawerToggle;
        setDrawerOpen(true, true);
      };

      drawerToggle.addEventListener("click", function () {
        cancelDrawerReveal();
        var willOpen = !drawerIsOpen();
        if (willOpen) lastOpener = drawerToggle;
        setDrawerOpen(willOpen, true);
      });
      drawerClose.addEventListener("click", function () {
        cancelDrawerReveal();
        setDrawerOpen(false, true);
      });
      drawerBackdrop.addEventListener("click", function () {
        cancelDrawerReveal();
        setDrawerOpen(false, true);
      });
      drawer.addEventListener("pointerdown", cancelDrawerReveal);
      drawer.addEventListener("focusin", cancelDrawerReveal);
      document.addEventListener("keydown", function (event) {
        if (event.key === "Escape" && drawerIsOpen()) {
          cancelDrawerReveal();
          event.preventDefault();
          setDrawerOpen(false, true);
        }
      });

      if (frameHint) {
        frameHint.addEventListener("click", function () {
          openCustomiseDrawer(frameHint);
        });
      }

      // Clicks must bind to the portaled drawer — host no longer contains it.
      drawer.addEventListener("click", function (event) {
        var resetBtn = event.target.closest("[data-coll-reset]");
        if (resetBtn && drawer.contains(resetBtn) && !resetBtn.disabled) {
          resetToProductDefaults();
          return;
        }
        var opt = event.target.closest("[data-coll-opt]");
        if (opt && drawer.contains(opt) && !opt.disabled && !opt.hidden) {
          var key = opt.getAttribute("data-coll-opt");
          var value = opt.getAttribute("data-value");
          if (!key || value == null) return;
          var patch = {};
          patch[key] = value;
          if (key === "frame") {
            frameColourByStyle[typeKey(prefs.frametype)] = value;
          }
          commitPrefs(patch, key === "frame" ? value !== "None" : true);
          return;
        }
        var mountSwitch = event.target.closest("[data-coll-mount-switch]");
        if (mountSwitch && drawer.contains(mountSwitch)) {
          var nextMount = prefs.mount === "Mounted" ? "No mount" : "Mounted";
          commitPrefs({ mount: nextMount }, true);
        }
      });
    }

    toggles.forEach(function (toggle) {
      toggle.addEventListener("click", function (event) {
        var btn = event.target.closest("[data-coll-frames-value]");
        if (!btn || !toggle.contains(btn)) return;
        setMode(btn.getAttribute("data-coll-frames-value"), true);
      });
    });

    syncDrawerUi();
    if (overrideActive) applyCards();
    syncResetUi();
  }

  function initCollectionSimplify() {
    var STORAGE_KEY = "artfolio-coll-simplify";
    var DENSITY_KEY = "artfolio-coll-density";
    var layout = document.querySelector(".coll-layout");
    var toggle = document.querySelector("[data-coll-simplify-toggle]");
    if (!layout || !toggle) return;

    var label = toggle.querySelector("[data-coll-simplify-label]");
    var densityGroup = layout.querySelector("[data-coll-density-toggle]");
    var densityButtons = densityGroup
      ? Array.prototype.slice.call(densityGroup.querySelectorAll("[data-coll-density-value]"))
      : [];

    function readSimplify() {
      try {
        var stored = window.localStorage.getItem(STORAGE_KEY);
        var chosen = window.localStorage.getItem(STORAGE_KEY + "-chosen");
        if (chosen === "1" && (stored === "on" || stored === "off")) return stored === "on";
        // Collection pages used to write this key on every load, so a stored
        // "off" is the automatic default, not a choice. "on" only exists
        // after the visitor presses Simplify.
        if (stored === "on") return true;
      } catch (e) {}
      // Artist pages used to open simplified, which hides the title and price.
      return false;
    }

    function readDensity() {
      try {
        var value = parseInt(window.localStorage.getItem(DENSITY_KEY), 10);
        if (value === 2 || value === 3 || value === 4) return value;
      } catch (e) {}
      return 4;
    }

    function viewportMaxDensity() {
      var width = window.innerWidth || document.documentElement.clientWidth || 1200;
      if (width <= 800) return 2;
      if (width <= 1100) return 3;
      return 4;
    }

    function clampDensity(value) {
      var next = value === 2 || value === 3 || value === 4 ? value : 4;
      return Math.min(next, viewportMaxDensity());
    }

    function syncDensityButtons(active) {
      densityButtons.forEach(function (btn) {
        var value = parseInt(btn.getAttribute("data-coll-density-value"), 10);
        var max = viewportMaxDensity();
        var available = value <= max;
        btn.hidden = !available;
        var on = available && value === active;
        btn.classList.toggle("is-active", on);
        btn.setAttribute("aria-pressed", on ? "true" : "false");
      });
    }

    function applyDensity(value, persist) {
      var next = clampDensity(value);
      layout.setAttribute("data-coll-density", String(next));
      syncDensityButtons(next);
      if (persist) {
        try {
          window.localStorage.setItem(DENSITY_KEY, String(value === 2 || value === 3 || value === 4 ? value : next));
        } catch (e) {}
      }
      return next;
    }

    function applySimplify(on, persist) {
      layout.classList.toggle("is-simplified", on);
      toggle.setAttribute("aria-pressed", on ? "true" : "false");
      if (label) label.textContent = on ? "Default view" : "Simplify";
      if (persist) {
        try {
          window.localStorage.setItem(STORAGE_KEY, on ? "on" : "off");
          window.localStorage.setItem(STORAGE_KEY + "-chosen", "1");
        } catch (e) {}
      }
      if (on) applyDensity(readDensity(), false);
      else syncDensityButtons(clampDensity(readDensity()));
    }

    applySimplify(readSimplify(), false);
    applyDensity(readDensity(), false);

    toggle.addEventListener("click", function () {
      applySimplify(toggle.getAttribute("aria-pressed") !== "true", true);
    });

    densityButtons.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var value = parseInt(btn.getAttribute("data-coll-density-value"), 10);
        applyDensity(value, true);
      });
    });

    var resizeTimer = 0;
    window.addEventListener("resize", function () {
      if (resizeTimer) window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        applyDensity(readDensity(), false);
      }, 120);
    });
  }

  function initCollectionCardEnlarge() {
    var dialog = document.querySelector("[data-coll-enlarge-dialog]");
    var mount = dialog && dialog.querySelector("[data-coll-enlarge-mount]");
    var layout = document.querySelector(".coll-layout");
    if (!dialog || !mount || !layout || typeof dialog.showModal !== "function") return;

    var desktopQuery = window.matchMedia("(min-width: 1001px)");
    var lastTrigger = null;

    function bumpShopifyWidth(url, width) {
      if (!url) return url;
      var next = String(url);
      if (/([?&])width=\d+/i.test(next)) {
        return next.replace(/([?&])width=\d+/i, "$1width=" + width);
      }
      if (/_\d+x(?=\.[a-z]+(?:\?|$))/i.test(next)) {
        return next.replace(/_\d+x(?=\.[a-z]+(?:\?|$))/i, "_" + width + "x");
      }
      return next + (next.indexOf("?") >= 0 ? "&" : "?") + "width=" + width;
    }

    function canEnlarge() {
      return (
        desktopQuery.matches &&
        layout.classList.contains("is-simplified") &&
        !!document.querySelector('.masonry[data-coll-frames="on"]')
      );
    }

    function closeEnlarge() {
      if (dialog.open) dialog.close();
      document.documentElement.classList.remove("preview-enlarge-lock");
      mount.innerHTML = "";
      if (lastTrigger && document.contains(lastTrigger) && desktopQuery.matches) {
        lastTrigger.focus();
      }
      lastTrigger = null;
    }

    function openEnlarge(trigger) {
      if (!canEnlarge()) return;
      var card = trigger.closest(".mcard");
      var formatMedia = card && card.querySelector("[data-format-panels]");
      var source = formatMedia || (card && card.querySelector(".card-frame"));
      if (!source) return;

      lastTrigger = trigger;
      var sourceRect = source.getBoundingClientRect();
      var nativeW = Math.max(1, sourceRect.width);
      var nativeH = Math.max(1, sourceRect.height);
      var maxW = Math.max(200, window.innerWidth - 128);
      var maxH = Math.max(200, window.innerHeight - 120);
      var scale = Math.min(maxW / nativeW, maxH / nativeH, 3.2);
      var targetW = Math.round(nativeW * scale);
      var targetH = Math.round(nativeH * scale);
      var dpr = Math.min(window.devicePixelRatio || 1, 2.5);
      var imageWidth = Math.min(3600, Math.max(2400, Math.ceil(Math.max(targetW, targetH) * dpr)));

      var clone = source.cloneNode(true);
      clone.style.width = targetW + "px";
      clone.style.height = formatMedia ? targetH + "px" : "auto";
      clone.style.maxWidth = "none";
      clone.style.pointerEvents = "none";

      if (!formatMedia) {
        var frameW = parseFloat(clone.style.getPropertyValue("--frame-w")) || parseFloat(getComputedStyle(source).getPropertyValue("--frame-w")) || 9;
        var mountW = parseFloat(clone.style.getPropertyValue("--mount-w")) || parseFloat(getComputedStyle(source).getPropertyValue("--mount-w")) || 12;
        clone.style.setProperty("--frame-w", (frameW * scale) + "px");
        if (!clone.querySelector(".card-mount.is-off")) {
          clone.style.setProperty("--mount-w", (mountW * scale) + "px");
        }
      }

      var piece = clone.querySelector(".card-piece");
      var img = clone.querySelector("img");
      var zoomSrc = piece && piece.getAttribute("data-zoom-src");
      var sourceImg = formatMedia && formatMedia.querySelector("img");
      var baseUrl = zoomSrc || ((sourceImg || img) && ((sourceImg || img).currentSrc || (sourceImg || img).getAttribute("src")));
      var hiUrl = bumpShopifyWidth(baseUrl, imageWidth);
      if (!formatMedia) {
        if (img && hiUrl) {
          img.setAttribute("src", hiUrl);
          img.removeAttribute("srcset");
          img.removeAttribute("sizes");
          img.setAttribute("decoding", "async");
          img.style.width = "100%";
          img.style.height = "auto";
          img.style.imageRendering = "auto";
        }
        if (piece && hiUrl) piece.setAttribute("data-zoom-src", hiUrl);
      } else if (img) {
        img.setAttribute("loading", "eager");
        img.setAttribute("decoding", "async");
      }

      var host = document.createElement("div");
      host.className = "masonry coll-enlarge-host";
      host.setAttribute("data-coll-frames", "on");
      var mcard = document.createElement("div");
      mcard.className = "mcard";
      mcard.appendChild(clone);
      host.appendChild(mcard);

      mount.innerHTML = "";
      mount.appendChild(host);

      dialog.showModal();
      document.documentElement.classList.add("preview-enlarge-lock");

      if (formatMedia) {
        var layoutClone = function () {
          sizeCollectionFormatCard(clone);
          paintCollectionFormatCard(clone, sourceImg);
        };
        layoutClone();
        if (window.requestAnimationFrame) {
          window.requestAnimationFrame(function () {
            layoutClone();
            window.requestAnimationFrame(layoutClone);
          });
        }
        if (hiUrl && sourceImg) {
          var upgrade = new Image();
          upgrade.onload = function () {
            paintCollectionFormatCard(clone, sourceImg, hiUrl);
          };
          upgrade.src = hiUrl;
        }
      }

      var closeBtn = dialog.querySelector("[data-coll-enlarge-close]");
      if (closeBtn) closeBtn.focus();
    }

    document.addEventListener("click", function (event) {
      var btn = event.target.closest("[data-coll-enlarge]");
      if (!btn) return;
      event.preventDefault();
      event.stopPropagation();
      openEnlarge(btn);
    });

    dialog.querySelectorAll("[data-coll-enlarge-close]").forEach(function (btn) {
      btn.addEventListener("click", function (event) {
        event.preventDefault();
        closeEnlarge();
      });
    });

    dialog.addEventListener("click", function (event) {
      if (event.target === dialog) closeEnlarge();
    });

    dialog.addEventListener("close", function () {
      document.documentElement.classList.remove("preview-enlarge-lock");
      if (mount.innerHTML) mount.innerHTML = "";
    });

    if (desktopQuery.addEventListener) {
      desktopQuery.addEventListener("change", function () {
        if (!desktopQuery.matches) closeEnlarge();
      });
    }
  }

  function initPdpDock() {
    var dock = document.querySelector(".pdp-dock");
    var sentinel = document.querySelector(".pdp-dock-sentinel");
    if (!dock) return;

    var desktop = window.matchMedia("(min-width: 1001px)");
    var dockWatch = null;

    function adminChromePx() {
      var raw = getComputedStyle(document.documentElement).getPropertyValue("--shopify-admin-chrome");
      var n = parseFloat(raw);
      return isNaN(n) ? 0 : n;
    }

    function setDockHeight() {
      var host = document.body;
      if (!host || !host.classList.contains("template-product")) return;
      if (!desktop.matches) {
        host.style.setProperty("--pdp-dock-h", "0px");
        return;
      }
      var height = Math.round(dock.getBoundingClientRect().height - adminChromePx());
      host.style.setProperty("--pdp-dock-h", Math.max(0, height) + "px");
    }

    function syncDocked() {
      setDockHeight();
      if (!sentinel || !("IntersectionObserver" in window)) return;
      if (dockWatch) {
        dockWatch.disconnect();
        dockWatch = null;
      }
      if (!desktop.matches) {
        dock.classList.remove("is-docked");
        return;
      }
      dockWatch = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        if (!entry) return;
        dock.classList.toggle("is-docked", !entry.isIntersecting);
      }, { threshold: 0 });
      dockWatch.observe(sentinel);
    }
    syncDocked();
    if (desktop.addEventListener) desktop.addEventListener("change", syncDocked);
    else if (desktop.addListener) desktop.addListener(syncDocked);
    if ("ResizeObserver" in window) {
      new ResizeObserver(setDockHeight).observe(dock);
    } else {
      window.addEventListener("resize", setDockHeight);
    }

    dock.querySelectorAll("[data-dock-jump]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var group = document.getElementById(btn.getAttribute("data-dock-jump"));
        if (!group) return;
        var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        group.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "center" });
        var focusEl = group.querySelector(".mount-switch, .swatch:not([disabled]), .choice, button:not(.visually-hidden)");
        if (focusEl && typeof focusEl.focus === "function") {
          focusEl.focus({ preventScroll: true });
        }
      });
    });
  }

  /* ---------- hero oak plate rotator ---------- */
  function initHeroPlateRotators() {
    document.querySelectorAll("[data-hero-plate-rotator], .plate-frame--oak").forEach(initHeroPlateRotator);
  }

  function initHeroPlateRotator(root) {
    if (!root || root.getAttribute("data-hero-plate-bound") === "true") return;
    if (!root.querySelector(".hero-plate-stack")) return;
    root.setAttribute("data-hero-plate-bound", "true");

    var titleEl = root.querySelector("[data-hero-plate-title]");
    var artistEl = root.querySelector("[data-hero-plate-artist]");
    var slides = root.querySelectorAll("[data-hero-plate-slide]");
    var index = 0;
    var timer = null;
    var holdMs = 6000;
    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)");
    var desktop = window.matchMedia("(min-width: 1001px)");

    function syncStackToSlide(slide) {
      var stack = root.querySelector(".hero-plate-stack");
      var wrap = slide && slide.querySelector("[data-framewrap]");
      if (!stack || !wrap) return;
      var w = parseFloat(wrap.style.width);
      var h = parseFloat(wrap.style.height);
      if (!(w > 0) || !(h > 0)) return;
      stack.removeAttribute("data-hero-ratio");
      stack.style.aspectRatio = w + " / " + h;
    }

    function apply(next) {
      if (!slides.length) return;
      slides[index].classList.remove("is-active");
      slides[index].setAttribute("aria-hidden", "true");
      index = next;
      var slide = slides[index];
      slide.classList.add("is-active");
      slide.removeAttribute("aria-hidden");
      syncStackToSlide(slide);
      var href = slide.getAttribute("data-url");
      var linkEl = root.querySelector("[data-hero-plate-link]");
      if (href && linkEl) {
        linkEl.setAttribute("href", href);
        var label = slide.getAttribute("data-title");
        if (label) linkEl.setAttribute("aria-label", label);
      }
      if (href && root.tagName === "A") root.setAttribute("href", href);
      var titleLink = root.querySelector("[data-hero-plate-title]");
      if (href && titleLink && titleLink.tagName === "A") titleLink.setAttribute("href", href);
      root.classList.add("is-caption-out");
      window.setTimeout(function () {
        if (titleEl) titleEl.textContent = slide.getAttribute("data-title") || "";
        if (artistEl) artistEl.textContent = slide.getAttribute("data-artist") || "";
        root.classList.remove("is-caption-out");
      }, 280);
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function canPlay() {
      if (reduce.matches) return false;
      if (document.hidden) return false;
      if (!desktop.matches) return false;
      if (root.matches(":hover") || root.contains(document.activeElement)) return false;
      return slides.length > 1;
    }

    function start() {
      stop();
      if (!canPlay()) return;
      timer = window.setInterval(function () {
        if (!canPlay()) return;
        apply((index + 1) % slides.length);
      }, holdMs);
    }

    function bindChrome() {
      root.addEventListener("mouseenter", stop);
      root.addEventListener("mouseleave", start);
      root.addEventListener("focusin", stop);
      root.addEventListener("focusout", start);
      document.addEventListener("visibilitychange", function () {
        if (document.hidden) stop();
        else start();
      });
      if (desktop.addEventListener) desktop.addEventListener("change", start);
      else if (desktop.addListener) desktop.addListener(start);
    }

    bindChrome();
    if (slides.length > 1) root.setAttribute("data-hero-plate-rotator", "");
    start();
  }

  /* ---------- init ---------- */
  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-product]").forEach(initFrameVisualiser);
    document.querySelectorAll("[data-frame-visualiser-host]").forEach(initFrameVisualiser);
    document.querySelectorAll("[data-frame-visualiser]").forEach(function (visualiser) {
      if (!visualiser.closest("[data-product], [data-frame-visualiser-host]")) initFrameVisualiser(visualiser);
    });
    initJournalCarousels();
    initGenreCarousels();
    initFeaturedCarousels();
    initGenreArticleCarousels();
    initHowItWorks();
    initHomeScenes();
    initDiscoverPromos();
    initTagClouds();
    initCollectionMobileFilters();
    initPriceFilters();
    initCollectionFrameCustomise();
    initCollectionFormatCards();
    initSingleFrameMounts();
    initCollectionSimplify();
    initCollectionCardEnlarge();
    initPdpDock();
    initHeroPlateRotators();
    bindScenesLightbox();
    var aboutWork = document.querySelector(".js-about-work");
    if (aboutWork && window.matchMedia && window.matchMedia("(min-width: 1001px)").matches) {
      aboutWork.setAttribute("open", "");
    }
  });
  document.addEventListener("shopify:section:load", function (event) {
    event.target.querySelectorAll("[data-frame-visualiser]").forEach(function (visualiser) {
      if (!visualiser.closest("[data-product], [data-frame-visualiser-host]")) initFrameVisualiser(visualiser);
    });
    var plate = event.target.querySelector("[data-hero-plate-rotator], .plate-frame--oak");
    if (plate) initHeroPlateRotator(plate);
    var homeScenes = event.target.querySelector("[data-home-scenes]");
    if (homeScenes) {
      homeScenes.removeAttribute("data-home-scenes-bound");
      initHomeScenes();
    }
  });
})();
